import React, { useEffect, useRef, useState } from "react";
import { setCurrencyOverride, clearCurrencyOverride, getActiveCode, getActiveRate, setBookingView, clearBookingView } from "../../helper/currencyState";
import moment from 'moment';
import BaggageDetailsPopup from "../common-popup/BaggageDetailsPopup";
import { countryWithDialCode } from "../../helper/CountryWithDialCode";
import {
    acknowledgeBookedFlightPriceChangeFn,
    getBookingQueryParams,
    getCapturedBookedFlightPriceFn,
    getCookie,
    getSessionStorage,
    getUserToken, isBookedFlightPriceChangeAcknowledgedFn, paymentCaptureCommonFn, paymentCancelCommonFn,
    setCookie, countryCommonFn, formatePriceFn
} from "../../helper/commonFunction";
import { toUrlSource } from "../../helper/vendorMask";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import { ApiCall, GetApiCall } from "../../helper/axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import BookingDetailsSideBarComponent from "./BookingDetailsComponent/BookingDetailsSideBarComponent";
import FlightBookingDetailsComponent from "./BookingDetailsComponent/FlightBookingDetailsComponent";
import FlightBookingSkeleton from "./components/FlightBookingSkeleton";
import { BookingProcessingOverlay } from "../excursion/checkout/components/BookingProcessingOverlay";
import StripeWrapper from "../../component/StripeWrapper";
import { processVerteilFareRules } from './PassengerListPage/utils/verteilHelpers';
import { parsePassengerString, getAljazeeraInfantDobError, formatDateToDDMMYYYY, mapAljazeeraGenderTitle, getGenderFromTitle, getTitleFromGender, getTitleFromGenderLower, getTitleFromGenderMsFallback, getTitleFromGenderMsFallbackUpper, getGenderTitleUppercase, getTitleFromStoredGender, getNdcTitle, getNdcTitleFromStoredGender, getSimpleTitle } from './PassengerListPage/utils/bookingHelpers';
import BookingStepProgress from './PassengerListPage/components/BookingStepProgress';
import ReviewBookingBanner from './PassengerListPage/components/ReviewBookingBanner';
import BookingConfirmationBanner from './PassengerListPage/components/BookingConfirmationBanner';
import PassengerPageHeader from './PassengerListPage/components/PassengerPageHeader';
import VendorInfoBanners from './PassengerListPage/components/VendorInfoBanners';
import FlightPriceChangePopup from './PassengerListPage/components/FlightPriceChangePopup';
import PreBookingPriceRevisionPopup from './PassengerListPage/components/PreBookingPriceRevisionPopup';
import CommonPopup from '../common-popup/CommonPopup';

const ALJAZEERA_HOLD_FEE_PER_PAX = 40;

const PassengerListPage = () => {
    const location = useLocation();
    let userToken = getUserToken();
    const [queryParams, setQueryParams] = useState(() => getBookingQueryParams(location.search) || {});
    let navigate = useNavigate();
    const [currentTab, setCurrentTab] = useState(() => {
        const initialParams = getBookingQueryParams(location.search) || {};
        const isBookingConfirmation = !!(initialParams?.bookingId || initialParams?.refreshPage);
        return {
            1: { active: !isBookingConfirmation, success: false },
            2: { active: false, success: false },
            3: { active: isBookingConfirmation, success: false }
        };
    });

    const [tab2SubStep, setTab2SubStep] = useState('review');
    const { userAgentData, onlinePaymentEnable, displayPrice, agentActiveCurrency } = useSelector((state) => state.userData);
    const onineServicesFees = userAgentData?.onineServicesFees ?? 0;
    // const {agentActiveCurrency} = useSelector((state) => state.userData);
    // agentActiveCurrency now comes from the redux selector above (the selected currency)
    const [showTaxAndFees, setShowTaxAndFees] = useState(false);
    const [ndcFlightId, setNdcFlightId] = useState("")
    const [fareRulesOpen, setFareRulesOpen] = useState(false);
    const [showDiscounts, setShowDiscounts] = useState(false);
    const [flightDetails, setFlightDetails] = useState([{}]);
    const [showAllFlightDetails, setShowAllFlightDetails] = useState(false);
    const [fareRulesActiveTab, setFareRulesActiveTab] = useState(1);
    const [countryData, setCountryData] = useState([]);
    const [countryDialCodeData, setCountryDialCodeData] = useState([]);
    const countryWithDialCodeArr = countryWithDialCode();
    const [showBaggageDetailsModal, setShowBaggageDetailsModal] = useState(false);
    const [flightShowErrorMessage, setflightShowErrorMessage] = useState(false);
    const [flightShowBundleInclusionMessage, setflightShowBundleInclusionMessage] = useState(false);
    const [airArabiaBundleMessage, setAirArabiaBundleMessage] = useState(false);
    const [baggageDetailsPassengerData, setBaggageDetailsPassengerData] = useState([]);
    const [bagggageDetailsFlightDetails, setBaggageDetailsFlightDetails] = useState({});
    const [baggageDetailsFlightDetailsIndex, setBaggageDetailsFlightDetailsIndex] = useState(0);
    const [flightDataPriceObj, setFlightDataPriceObj] = useState({})
    const [travelFusionRoutingId, setTravelFusionRoutingId] = useState('');
    const [usePreRegisteredSupplier, setUsePreRegisteredSupplier] = useState(false)
    const [travelfusionparameters, setTravelfusionparameters] = useState({})
    const [onLoadLoader, setOnLoadLoader] = useState(true);
    const initialTime = queryParams?.source === 'air-arabia' ? 600 : 900
    const [timeRemaining, setTimeRemaining] = useState(initialTime);
    const intervalRef = useRef(null);
    const [isExpiredSearch, setIsExpiredSearch] = useState(false);
    const [showSessionExpired, setShowSessionExpired] = useState(false);
    const [bookingOtherData, setBookingOtherData] = useState([]);
    if (currentTab?.['3']?.active) {
        // Booking detail is LOCKED to a single currency - the switcher must not
        // change it. Prefer the currency the booking was MADE in; if the booking
        // did not record one (some vendors), freeze at whatever is shown now so it
        // still cannot be changed.
        setBookingView(
            bookingOtherData?.currency || getActiveCode(),
            Number(bookingOtherData?.conversionRate) || getActiveRate()
        );
    } else {
        clearBookingView();
    }
    useEffect(() => () => clearBookingView(), []);
    const [selectPaymentMethod, setSelectPaymentMethod] = useState(0);
    const [iAcceptCheckBox, setIAcceptCheckBox] = useState(false);
    const [checkboxAndWalletError, setCheckboxAndWalletError] = useState('');
    const [termsError, setTermsError] = useState('');
    const [couponCodeInput, setCouponCodeInput] = useState('');
    const [couponCodeError, setCouponCodeError] = useState('');
    const [finalAmount, setFinalAmount] = useState(0);
    const [tripJackBookingId, setTripJackBookingId] = useState('');
    const [payNowBtnLoader, setPayNowBtnLoader] = useState(false);
    const [couponCodeLoader, setCouponCodeLoader] = useState(false)
    const [fareRuleDataBookingPage, setFareRuleDataBookingPage] = useState({});
    const [fareRuleData, setFareRuleData] = useState({})
    const [akasaAirToken, setAkasaAirToken] = useState('');
    const [echoToken, setechoToken] = useState(null)
    const [transactionId, settransactionId] = useState(null)
    const [rphCode, setrphcode] = useState(null);
    const [checkPriceBeforeBooking, setCheckPriceBeforeBooking] = useState({})
    // Price-change popup (compares the price captured at Book-click time vs. flight-review's totalPrice).
    const [flightPriceChangeInfo, setFlightPriceChangeInfo] = useState({ show: false, oldPrice: 0, newPrice: 0, currency: 'AED', direction: 'down', diff: 0 });
    const flightPriceChangeCheckedRef = useRef(false);
    const aljazeeraFlightDatesRef = useRef({ outbound: null, inbound: null });
    // Holds the Amadeus order created + reconfirmed during check-price-before-booking,
    // so the booking call can ISSUE it instead of creating a second order.
    const amadeusReconfirmRef = useRef({});
    // const [showTravelFusioNote, setShowTravelFusionNote] = useState(false);
    const [orderCreateRq, setOrderCreateRq] = useState({});
    const [extraChargePrice, setExtraChargePrice] = useState({
        show: false,
        open: false,
        meal: 0,
        baggage: 0,
        seat: 0,
        total: 0
    })
    const [downloadTicketWithFareLoader, setDownloadTicketWithFareLoader] = useState(false)
    const [downloadTicketWithMarkupLoader, setDownloadTicketWithMarkupLoader] = useState(false)
    const [downloadTicketWithOutFareLoader, setDownloadTicketWithOutFareLoader] = useState(false)
    const [holdButtonLoader, setHoldButtonLoader] = useState(false);
    const [unHoldButtonLoader, setUnHoldButtonLoader] = useState(false);
    const [searchQueryObj, setSearchQueryObj] = useState({});
    const [fareRuleActiveIndex, setFareRuleActiveIndex] = useState(0);
    const [airArabiaFlightData, setAirArabiaFlightData] = useState({});
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const [activeCouponCodeData, setActiveCouponCodeData] = useState({
        coupon_code: '',
        discount_type: '',
        discount_value: ''
    });
    const [flightOnHoldCondition, setFlightOnHoldCondition] = useState(false);
    const [seatMappayload, setseatMappayload] = useState({})
    const [sectionError, setSectionError] = useState({
        baggageMealError: '',
        seatError: ''
    });
    const [airArabiaBundle, setairArabiaBundle] = useState(null)
    const [flyDubaiCartResponse, setflyDubaiCartResponse] = useState(null)
    const [ndcPriceAfterHold, setndcPriceAfterHold] = useState(null)
    const [ndcRealPriceAfterHold, setndcRealPriceAfterHold] = useState(null)
    const [bookingStatus, setBookingStatus] = useState("")
    const [initialState, setInitialState] = useState({
        phoneCode: null,
        phoneCodeInput: "",
        phoneCodeInputOpen: false,
        phoneNumber: "",
        email: "",
        passgeners: [],
        bookingReferenceEnabled: true,
        bookingReferenceNote: '',
        baggageAndMealsOpen: true,
        ...((queryParams?.source === 'air-arabia' || queryParams?.source === 'akasa-air' || queryParams?.source === 'verteil' || queryParams?.source === 'aljazeera') && {
            addressCountry: null,
            addressCountryInput: "",
            addressCountryInputOpen: false,
            addressCity: ""
        }),
        ...((queryParams?.source === 'akasa-air' || queryParams?.source === 'verteil' || queryParams?.source === 'aljazeera') && {
            addressOne: null,
            addressState: "",
            addressStateInput: "",
            addressStateInputOpen: false,
            postalCode: ""
        })
    });
    const [formSchema, setFormSchema] = useState({});
    const [seatMapCache, setSeatMapCache] = useState({});
    const [seatRequired, setSeatRequired] = useState(false);
    const [stripeModalShow, setStripeModalShow] = useState(false);

    const TEMPORARY_PROVIDER_ISSUE_MESSAGE = "We're unable to complete this booking right now due to a temporary issue with the service provider. Please try again later or contact support.";
    const INSUFFICIENT_BALANCE_KEYWORDS = [
        'fund is not sufficient for booking',
        'insufficient agent available credit',
        'you have insufficient wallet balance',
        'insufficient credit',
        'fund not available',
        'insufficient balance',
        'insufficient wallet balance',
        'insufficient funds',
        'not enough funds available',
        'agency account credit insufficient for payment'
    ];

    const getBookingErrorMessage = (errorInput, fallbackMessage = 'Something went wrong!') => {
        const errorText = Array.isArray(errorInput)
            ? errorInput.join(' ')
            : typeof errorInput === 'object' && errorInput !== null
                ? Object.values(errorInput).join(' ')
                : String(errorInput || '');

        const normalizedErrorText = errorText.toLowerCase();
        const isInsufficientBalanceError = INSUFFICIENT_BALANCE_KEYWORDS.some((keyword) => normalizedErrorText.includes(keyword));

        if (isInsufficientBalanceError) {
            return TEMPORARY_PROVIDER_ISSUE_MESSAGE;
        }

        return errorInput || fallbackMessage;
    };

    const formik = useFormik({
        initialValues: initialState,
        validationSchema: formSchema,
        enableReinitialize: true,
        validateOnChange: false,
        validateOnBlur: false,
        validateOnMount: false,
        onSubmit: () => {
            step1ContinueBtnFn()
        }
    });

    useEffect(() => {
        if (queryParams?.priceId && !isExpiredSearch && !onLoadLoader && !stripeModalShow) {
            const endTime = Date.now() + timeRemaining * 1000;
            intervalRef.current = setInterval(() => {
                const newTimeRemaining = Math.max(Math.floor((endTime - Date.now()) / 1000), 0);
                if (newTimeRemaining !== timeRemaining) {
                    setTimeRemaining(newTimeRemaining);
                }
                if (newTimeRemaining === 0) {
                    setIsExpiredSearch(true);
                    setShowSessionExpired(true);
                    clearInterval(intervalRef.current);
                }
            }, 1000);
        }
        return () => clearInterval(intervalRef.current);
    }, [onLoadLoader, stripeModalShow]);

    const buildSeatMapPayload = (echoToken, transactionId, rphCode, tripInfos, tripIndex, flightIndex, source, extra = {}) => {
        if (source === 'air-arabia') {
            const segment = tripInfos[tripIndex]?.segments[flightIndex];
            let refList = []
            formik?.values?.passgeners?.map((passenger, index) => {
                const paxType = passenger?.passengerType || '';
                let refListNum = `${paxType?.charAt(0)}${index + 1}`;

                if (paxType === 'ADULT' || paxType === 'CHILD') {
                    refList.push(refListNum);
                }
            }
            )

            let flight = {
                airline: segment?.airline?.code,
                from: segment?.departure?.airportCode,
                to: segment?.arrival?.airportCode,
                fromTerminal: segment?.departure?.terminal,
                toTerminal: segment?.arrival?.terminal,
                departure: segment?.departure?.departureTime,
                arrival: segment?.arrival?.arrivalTime,
                flightnumber: segment?.flightNumber,
                passenger: refList.join(" "),
                equipmentType: segment?.equipmentType,
            }
            return {
                activeCurrency: agentActiveCurrency,
                // RPH: extraData?.rphCode[segment?.flightNumber],
                RPH: rphCode[segment?.flightNumber],
                EchoToken: echoToken,
                TransactionIdentifier: transactionId,
                flight: flight,
                source: source
            };
        }
        if (source === 'aljazeera') {
            // Navitaire only needs the opaque segmentKey — the seat map is read from
            // the booking-in-state that /flight-review's TripSell already created on
            // the shared token (same mechanism as meals/baggage via /flight-ssr-data).
            const segment = tripInfos?.[tripIndex]?.segments?.[flightIndex];
            if (!segment?.segmentKey) return {};
            return {
                activeCurrency: agentActiveCurrency,
                baseCurrency: segment?.baseCurrency || 'AED',
                segmentKey: segment?.segmentKey,
                flightDHTRId: queryParams?.flightId,
                source: source
            };
        }
        return {}
    };

    // Pre-load one seat map per segment into seatMapCache, keyed "DEP-ARR" (the key
    // FlightBookingDetailsComponent looks up). Vendor-agnostic: buildSeatMapPayload
    // decides the payload and returns {} for sources without a seat map, which we skip.
    const prefetchSeatMapsFn = async (tripInfos, source, extra = {}) => {
        if (!Array.isArray(tripInfos) || !tripInfos.length) return;
        const newCache = {};
        for (let j = 0; j < tripInfos.length; j++) {
            const segments = tripInfos[j]?.segments || [];
            for (let i = 0; i < segments.length; i++) {
                const segment = segments[i];
                const segKey = `${segment?.departure?.airportCode}-${segment?.arrival?.airportCode}`;
                if (seatMapCache[segKey] || newCache[segKey]) continue;
                const payload = buildSeatMapPayload(
                    extra?.echoToken, extra?.transactionId, extra?.rphCodes || {},
                    tripInfos, j, i, source
                );
                if (!payload || !Object.keys(payload).length) continue;
                if (extra?.jSessionCookieId) payload.jSessionCookieId = extra.jSessionCookieId;
                try {
                    const response = await ApiCall("POST", "/flights/get-flight-seatmap", payload, { authorization: userToken });
                    newCache[segKey] = response?.data?.data;
                } catch (error) {
                    newCache[segKey] = null;
                    console.error("Error preloading seat map:", error);
                }
            }
        }
        if (Object.keys(newCache).length > 0) {
            setSeatMapCache(prev => ({ ...prev, ...newCache }));
        }
    };

    useEffect(() => {
        if (queryParams?.priceId) {
            window.scrollTo(0, 0)
            getFlightDetails().catch((error) => {
                console.error('Flight review error', error);
                handleReviewError(null);
            })
        }
    }, [queryParams?.priceId])
 
    useEffect(() => {
        if (flightPriceChangeCheckedRef.current) return;
        const newTotalFare = Number(flightDataPriceObj?.totalFare);
        if (!Number.isFinite(newTotalFare) || newTotalFare <= 0) return;
        flightPriceChangeCheckedRef.current = true;
        const source = queryParams?.source;
        const priceIdInUrl = queryParams?.priceId;
        if (!source || !priceIdInUrl) return;
        if (isBookedFlightPriceChangeAcknowledgedFn(source, priceIdInUrl)) return;
        const captured = getCapturedBookedFlightPriceFn(source, priceIdInUrl);
        const capturedPrice = Number(captured?.price);
        if (!Number.isFinite(capturedPrice) || capturedPrice <= 0) return;
        const diff = newTotalFare - capturedPrice;
        // Ignore tiny rounding differences (< AED 1).
        if (Math.abs(diff) < 1) return;
        setFlightPriceChangeInfo({
            show: true,
            oldPrice: capturedPrice,
            newPrice: newTotalFare,
            currency: captured?.currency || 'AED',
            direction: diff > 0 ? 'up' : 'down',
            diff: Math.abs(diff)
        });
    }, [flightDataPriceObj?.totalFare, queryParams?.source, queryParams?.priceId]);

    const dismissFlightPriceChangePopupFn = () => {
        setFlightPriceChangeInfo((prev) => ({ ...prev, show: false }));
        acknowledgeBookedFlightPriceChangeFn(queryParams?.source, queryParams?.priceId);
    };

    // getFlightDetails — shared helpers (defined here so they close over state)

    /** Show the error modal with a message from the API response (or fallback). */
    const handleReviewError = (errorData) => {
        setOnLoadLoader(false);
        setShowBaggageDetailsModal(true);
        setflightShowErrorMessage(errorData || 'Something went wrong!');
    };

    /**
     * Apply the common state setters that every successful review response shares.
     * Pass `passengerArg` if you've already resolved it (e.g. from session-storage);
     * pass `searchQuery` when you need to call setSearchQueryObj too.
     */
    const setCommonFlightState = (flightDetailsData, { passengerArg, conditions, passKeys, passengerBreakDown, skipSearchQuery } = {}) => {
        const passengers = passengerArg ?? flightDetailsData?.searchQuery?.passengers;
        const conds      = conditions      ?? flightDetailsData?.conditions;
        setPassengerDetailsFn(passengers, conds, passKeys, passengerBreakDown);
        setFlightDetails(flightDetailsData?.tripInfos);
        setFlightDataPriceObj(flightDetailsData?.totalPrice);
        if (!skipSearchQuery) setSearchQueryObj(flightDetailsData?.searchQuery);
        setFinalAmount(flightDetailsData?.totalPrice?.totalFare);
        setOnLoadLoader(false);
    };

    /**
     * Merge SSR data (baggage + meal) into each segment's specialServices.
     * `matchFn(ssrEntry, segment)` returns true when the entry belongs to that segment.
     * `pickServices(ssrEntry)` returns `{ BAGGAGE, MEAL }` for that entry.
     * Returns the updated tripInfos array (does not mutate the original).
     */
    const mergeSSRIntoSegments = (tripInfos, ssrList, matchFn, pickServices) => {
        return tripInfos.map((segmentData) => {
            if (!Array.isArray(segmentData?.segments)) return segmentData;
            const updatedSegments = segmentData.segments.map((segment) => {
                const ssrEntry = ssrList.find(entry => matchFn(entry, segment));
                if (!ssrEntry) return segment;
                const services = pickServices(ssrEntry, segment);
                return {
                    ...segment,
                    specialServices: {
                        ...(segment.specialServices || {}),
                        ...services,
                    },
                };
            });
            return { ...segmentData, segments: updatedSegments };
        });
    };

    // getFlightDetails — fetches review data for the current vendor on page-load

    const getFlightDetails = async () => {
        if (queryParams?.priceId && queryParams?.source) {
            if (queryParams?.source === 'tripjack') {
                const flightReviewData = await ApiCall('POST', '/flights/flight-review', {
                    priceId: queryParams?.priceId ? queryParams?.priceId?.split(',') : [queryParams?.priceId],
                    activeCurrency: "AED",
                    flightDHTRId: queryParams?.flightId,
                }, { authorization: userToken });
                if (flightReviewData?.status === 200) {
                    let flightDetailsData = flightReviewData?.data?.data?.data;
                    setFlightOnHoldCondition(flightDetailsData?.conditions?.holdBooking);
                    setCommonFlightState(flightDetailsData);
                    setTripJackBookingId(flightDetailsData?.bookingId);
                } else {
                    let errorData = flightReviewData?.data?.data?.[0]?.message;
                    handleReviewError(errorData);
                }
            } else if (queryParams?.source === 'amadeus') {
                let amaduesPayload = {
                    source: "amadeus",
                    activeCurrency: agentActiveCurrency,
                    priceDetails: {
                        sid: queryParams?.sid,
                        Token: queryParams?.token,
                        flightOption: [
                            {
                                Type: queryParams?.type,
                                key: queryParams?.priceId
                            }
                        ]
                    }
                }
                const flightReviewData = await ApiCall('POST', '/flights/flight-review', amaduesPayload, { authorization: userToken });
                if (flightReviewData?.status === 200) {
                    let flightDetailsData = flightReviewData?.data?.data?.data;
                    setCommonFlightState(flightDetailsData);
                } else {
                    let errorData = flightReviewData?.data?.data?.[0]?.message;
                    handleReviewError(errorData);
                }

            } else if (queryParams?.source === 'travel-fusion') {
                let travelFusionPayload = {
                    source: queryParams?.source,
                    activeCurrency: "AED",
                    routingId: queryParams?.priceId,
                    outwardId: queryParams?.outwardId,
                    returnId: queryParams?.returnId,
                    flightDHTRId: queryParams?.flightId,
                }
                const flightReviewData = await ApiCall('POST', '/flights/flight-review', travelFusionPayload, { authorization: userToken });
                if (flightReviewData?.status === 200) {
                    let flightDetailsData = flightReviewData?.data?.data?.data;
                    setTravelFusionRoutingId(flightDetailsData?.routingId)
                    setCommonFlightState(flightDetailsData);
                    setFareRuleData(flightDetailsData?.fareRules)
                    setUsePreRegisteredSupplier(flightDetailsData?.usePreRegisteredSupplier)
                    setTravelfusionparameters(flightDetailsData?.requiredParameters)
                    setSeatRequired(Boolean(flightDetailsData?.seatRequired))
                    // setShowTravelFusionNote(true);
                } else {
                    let errorData = flightReviewData?.data?.data?.[0]?.message;
                    handleReviewError(errorData);
                }

            } else if (queryParams?.source === 'verteil') {
                let priceId = getSessionStorage(`verteil-${queryParams?.priceId}`);
                let getCookieData = getSessionStorage(`verteil-${priceId}-${queryParams?.searchData}`);
                if (getCookieData && Object?.keys(getCookieData)?.length) {
                    let payloadData = {
                        source: queryParams?.source,
                        activeCurrency: "AED",
                        session: getCookieData,
                        flightDHTRId: queryParams?.flightId,
                    }
                    const flightReviewVertielData = await ApiCall('POST', '/flights/flight-review', payloadData, { authorization: userToken });
                    if (flightReviewVertielData?.status === 200) {
                        let flightVertielDetailsData = flightReviewVertielData?.data?.data?.data?.data;
                        setOrderCreateRq(flightReviewVertielData?.data?.data?.data?.orderCreateRq)
                        // Verteil uses fareDetails for passenger counts instead of searchQuery.passengers
                        let passengerData = flightVertielDetailsData?.tripInfos?.[0]?.totalPriceList?.[0]?.fareDetails.reduce((acc, curr) => {
                            acc[curr.passengerType] = curr.passengerCount;
                            return acc;
                        }, {});
                        setCommonFlightState(flightVertielDetailsData, { passengerArg: passengerData, skipSearchQuery: true });

                        // Process verteil fare rules
                        if (flightVertielDetailsData?.segmentPenaltyArr) {
                            const processedFareRules = processVerteilFareRules(flightVertielDetailsData?.segmentPenaltyArr, flightVertielDetailsData?.tripInfos);
                            setFareRuleData(processedFareRules);

                            // Set initial fare rule active index to the first segment
                            if (processedFareRules && Object.keys(processedFareRules).length > 0) {
                                const firstSegmentKey = Object.keys(processedFareRules)[0];
                                setFareRuleActiveIndex(firstSegmentKey);
                            }
                        }
                    } else {
                        let errorData = flightReviewVertielData?.data?.data?.[0]?.message;
                        handleReviewError(errorData);
                    }
                } else {
                    handleReviewError(null);
                }

            } else if (queryParams?.source === 'fly-dubai') {
                let getCookieData = getSessionStorage(`fly-dubai-${queryParams?.priceId}-${queryParams?.searchData}`);
                let getFlyDubaiToken = getCookie(`dahr--fly_dubaiToken`);
                let segements = getCookieData?.segements
                if (getCookieData && Object?.keys(getCookieData)?.length) {
                    let sessionData = getCookieData?.sessionData;
                    let searchData = atob(queryParams?.searchData);
                    const params = new URLSearchParams(searchData.startsWith("?") ? searchData.slice(1) : searchData);
                    const adult = parseInt(params.get("ADT") || "0", 10);
                    const child = parseInt(params.get("CHD") || "0", 10);
                    const infant = parseInt(params.get("INF") || "0", 10);
                    let payloadData = {
                        source: queryParams?.source,
                        activeCurrency: "AED",
                        session: sessionData,
                        flightDHTRId: queryParams?.flightId,
                        token: getFlyDubaiToken,
                        adult, child, infant, segements
                    }
                    const flightReviewFlyDubaiData = await ApiCall('POST', '/flights/flight-review', payloadData, { authorization: userToken });
                    if (flightReviewFlyDubaiData?.status === 200) {
                        let flightFlyDubaiData = flightReviewFlyDubaiData?.data?.data;
                        setPassengerDetailsFn(getCookieData?.passengers)
                        setFlightDetails(flightFlyDubaiData?.tripInfos)
                        setFlightDataPriceObj(flightFlyDubaiData?.totalPrice)
                        setFinalAmount(flightFlyDubaiData?.totalPrice?.totalFare)
                        setflyDubaiCartResponse(flightFlyDubaiData?.flyDubaiCartResponse)
                        setFareRuleData(flightFlyDubaiData?.fareRulesResponse?.data?.fareRule)
                        let ancillaryPayload = {
                            source: queryParams?.source,
                            activeCurrency: "AED",
                            ancillaryPayload: flightFlyDubaiData?.ancillaryPayload,
                            token: getFlyDubaiToken,
                            baggaeCodes: flightFlyDubaiData?.totalPrice?.baggageCodes,
                            flightDHTRId: queryParams?.flightId,
                        }
                        let baggageMealData = await ApiCall('POST', '/flights/flight-ssr-data', ancillaryPayload, { authorization: userToken });
                        if (baggageMealData?.status === 200) {
                            let data = baggageMealData?.data?.data;
                            const pfIDServicesMap = {};
                            for (let pfID of Object?.keys(data)) {
                                let mealData = data[pfID]?.Meal;
                                let baggageData = data[pfID]?.Baggage;
                                let allData = data[pfID]
                                const formattedMealData = mealData.map(meal => ({
                                    code: meal.code,
                                    name: meal.description,
                                    description: meal.description,
                                    amount: meal.amount,
                                    currency: meal.currency,
                                    ssrType: 'MEAL',
                                    categoryID: meal.categoryID,
                                    cutoffHours: meal.cutoffHours,
                                    redeemMiles: meal.redeemMiles,
                                    ruleID: meal.ruleID,
                                    ruleDesc: meal.ruleDesc,
                                    maxCountFlightLevel: meal.maxCountFlightLevel,
                                    maxCountServiceLevel: meal.maxCountServiceLevel,
                                    quantity: meal.quantity,
                                    pfId: pfID,
                                    depDate: allData?.depDate
                                }));

                                const formattedBaggageData = baggageData.map(baggage => ({
                                    code: baggage.code,
                                    name: baggage.description,
                                    description: baggage.description,
                                    amount: baggage.amount,
                                    currency: baggage.currency,
                                    ssrType: 'BAGGAGE',
                                    categoryID: baggage.categoryID,
                                    cutoffHours: baggage.cutoffHours,
                                    redeemMiles: baggage.redeemMiles,
                                    ruleID: baggage.ruleID,
                                    ruleDesc: baggage.ruleDesc,
                                    maxCountFlightLevel: baggage.maxCountFlightLevel,
                                    maxCountServiceLevel: baggage.maxCountServiceLevel,
                                    quantity: baggage.quantity,
                                    lfID: allData?.lfID,
                                    depDate: allData?.depDate
                                }));
                                pfIDServicesMap[pfID] = {
                                    MEAL: formattedMealData,
                                    BAGGAGE: formattedBaggageData
                                };
                            }
                            setFlightDetails(prevFlightDetails => {
                                return prevFlightDetails.map((tripData, index) => {
                                    if (tripData?.segments) {
                                        const updatedSegments = tripData.segments.map((segment, segmentIndex) => {
                                            // console.log("Segment : ", segment)
                                            const segmentPfID = Object.keys(pfIDServicesMap)[index] || Object.keys(pfIDServicesMap)[0];
                                            const specialServices = pfIDServicesMap[segment?.pfID] || { MEAL: [], BAGGAGE: [] };

                                            // console.log(`Segment ${segmentIndex} using pfID: ${segmentPfID}`, specialServices);

                                            return {
                                                ...segment,
                                                specialServices: specialServices
                                            };
                                        });
                                        return {
                                            ...tripData,
                                            segments: updatedSegments
                                        };
                                    }
                                    return tripData;
                                });
                            });
                        }
                    } else {
                        let errorData = flightReviewFlyDubaiData?.data?.data?.[0]?.message;
                        handleReviewError(errorData);
                    }
                    setOnLoadLoader(false);
                } else {
                    handleReviewError(null);
                }
            } else if (queryParams?.source === 'air-arabia') {
                let getCookieData = getSessionStorage(`airArabia-${queryParams?.priceId}`);
                if (getCookieData) {
                    let flightData = getCookieData;
                    let selectedBundle = null;
                    let bundleData = null;
                    if (flightData?.bundleData && flightData?.bundleData?.length && Array.isArray(flightData?.bundleData)) {
                        bundleData = flightData?.bundleData;
                        selectedBundle = flightData?.bundleData?.map(item => item?.serviceId);
                    }

                    let airArabiaPayload = {
                        source: "air-arabia",
                        activeCurrency: "AED",
                        flightSegment: flightData?.flightSegment,
                        passenger: flightData?.passenger,
                        pricingObj: flightData?.pricingObj,
                        directionType: flightData?.directionType,
                        totalDuration: flightData?.totalDuration,
                        selectedBundle: bundleData,
                        // transactionId : flightData?.transactionId
                    }
                    setairArabiaBundle(bundleData)
                    const flightReviewData = await ApiCall('POST', '/flights/flight-review', airArabiaPayload, { authorization: userToken });
                    if (flightReviewData?.status === 200) {
                        let flightDetailsData = flightReviewData?.data?.data;
                        setechoToken(flightDetailsData?.echoToken)
                        settransactionId(flightDetailsData?.transactionId)
                        let rphCodes = {}
                        flightDetailsData?.flightDetails?.map((f) => {
                            rphCodes[f?.flightNumber] = f?.rphCode
                        })
                        setrphcode(rphCodes)
                        let tripInfos = flightDetailsData?.tripInfos;
                        setFlightOnHoldCondition(true);
                        let baggageAAPayload = {
                            source: "air-arabia",
                            activeCurrency: agentActiveCurrency,
                            flightSegment: flightDetailsData?.flightDetails,
                            transactionId: flightDetailsData?.transactionId,
                            jSessionCookieId: flightDetailsData?.jSessionCookieId
                        }
                        const [flightBaggageData, flightMealData] = await Promise.all([
                            ApiCall('POST', '/flights/flight-baggage-data', baggageAAPayload, { authorization: userToken }),
                            ApiCall('POST', '/flights/flight-meal-data', baggageAAPayload, { authorization: userToken })
                        ]);

                        const newCache = {};
                        for (let j = 0; j < tripInfos.length; j++) {
                            for (let i = 0; i < tripInfos[j].segments.length; i++) {
                                const segment = tripInfos[j].segments[i];
                                const segKey = `${segment.departure.airportCode}-${segment.arrival.airportCode}`;
                                if (!seatMapCache[segKey]) {
                                    let payload = buildSeatMapPayload(flightDetailsData?.echoToken, flightDetailsData?.transactionId, rphCodes, tripInfos, j, i, queryParams?.source);
                                    payload.jSessionCookieId = flightDetailsData?.jSessionCookieId;
                                    try {
                                        const response = await ApiCall(
                                            "POST",
                                            "/flights/get-flight-seatmap",
                                            payload,
                                            { authorization: userToken }
                                        );
                                        const normalized = response?.data?.data;
                                        newCache[segKey] = normalized;
                                    } catch (error) {
                                        newCache[segKey] = null;
                                        console.error("Error preloading seat map:", error);
                                    }
                                }
                            }
                        }
                        if (Object.keys(newCache).length > 0) {
                            setSeatMapCache(prev => ({ ...prev, ...newCache }));
                        }

                        const hasValidBaggageData = flightBaggageData?.status === 200 && !flightBaggageData?.data?.data?.data?.errors && Array.isArray(flightBaggageData?.data?.data?.data?.baggageInformation) && flightBaggageData?.data?.data?.data?.baggageInformation.length > 0;
                        const hasValidMealData = flightMealData?.status === 200 && !flightMealData?.data?.data?.data?.errors && Array.isArray(flightMealData?.data?.data?.data?.mealInformation) && flightMealData?.data?.data?.data?.mealInformation.length > 0;

                        if ((hasValidBaggageData || hasValidMealData) && tripInfos?.length) {
                            let mealData = flightMealData?.data?.data?.data?.mealInformation;
                            let baggageData = flightBaggageData?.data?.data?.data?.baggageInformation;
                            tripInfos = tripInfos.map((segmentData) => {
                                if (!Array.isArray(segmentData?.segments)) {
                                    return segmentData;
                                }
                                const updatedSegments = segmentData.segments.map((segment) => {
                                    const existingSpecialServices = segment.specialServices || {};
                                    const mealInformation = mealData.find(meal => meal.flightNumber === segment?.flightNumber);
                                    const baggageInformation = baggageData?.find(baggage => baggage.flightNumber === segment?.flightNumber)
                                    const updatedSpecialServices = {
                                        ...existingSpecialServices,
                                        ...(hasValidBaggageData && {
                                            BAGGAGE: baggageInformation?.baggageData,
                                        }),
                                        ...(hasValidMealData && {
                                            MEAL: mealInformation?.mealData,
                                        }),
                                    };
                                    return {
                                        ...segment,
                                        specialServices: updatedSpecialServices,
                                    };
                                });
                                return {
                                    ...segmentData,
                                    segments: updatedSegments,
                                };
                            });
                        }
                        setCommonFlightState({ ...flightDetailsData, tripInfos });
                        setAirArabiaFlightData({
                            echoToken: flightDetailsData?.echoToken,
                            flightDetails: flightDetailsData?.flightDetails,
                            flightDataforBooking: flightDetailsData?.segmentInfo,
                            transactionId: flightDetailsData?.transactionId,
                            destinationOption: flightDetailsData?.destinationOption,
                            directionId: flightDetailsData?.directionId,
                            jSessionCookieId: flightDetailsData?.jSessionCookieId
                        });
                        if (flightDetailsData?.bundle?.length > 0) {
                            setAirArabiaBundleMessage(true)
                        }

                    } else {
                        handleReviewError(null);
                    }
                } else {
                    handleReviewError(null);
                }
            } else if (queryParams?.source === 'akasa-air') {
                let passengerTypes = parsePassengerString(queryParams?.pass);
                let infant = passengerTypes.find(pass => pass?.type === 'INF');
                if (infant) {
                    infant = infant?.count;
                    const index = passengerTypes.findIndex(pass => pass?.type === 'INF');
                    if (index !== -1) {
                        passengerTypes.splice(index, 1);
                    }
                }
                let keys = []

                if (queryParams?.priceId?.includes(',')) {
                    let pricingId = queryParams?.priceId?.split(',');
                    if (pricingId?.length) {
                        keys = pricingId.map(item => {
                            let [journeyKey, priceId] = item.split('|');
                            return {
                                journeyKey: journeyKey,
                                fareAvailabilityKey: priceId
                            };
                        });
                    }
                } else {
                    keys = [{
                        journeyKey: queryParams?.jKey,
                        fareAvailabilityKey: queryParams?.priceId
                    }];
                }

                let payload = {
                    source: queryParams?.source,
                    keys: keys,
                    flightDHTRId: queryParams?.flightId,
                    passengers: {
                        types: passengerTypes,
                    },
                    currencyCode: "AED",
                    promotionCode: null,
                    ...(infant && { infantCount: infant }),
                }

                let flightReviewData = await ApiCall('POST', '/flights/flight-review', payload, { authorization: userToken });
                if (flightReviewData?.status === 200) {
                    const flightDetailsData = flightReviewData?.data?.data;
                    let tripInfos = flightDetailsData?.tripInfos;
                    let passengers = flightDetailsData?.searchQuery?.passengers
                    let payloadSSRs = {
                        payload: {
                            trips: flightDetailsData?.trips,
                            passengerKeys: flightDetailsData?.passegerKey,
                            currencyCode: "AED"
                        },
                        flightDHTRId: queryParams?.flightId,
                        source: queryParams?.source,
                        akasaAirDataToken: flightDetailsData?.akasaAirDataToken
                    }
                    setAkasaAirToken(flightDetailsData?.akasaAirDataToken)
                    getFareRulesDataFn(flightDetailsData?.akasaAirDataToken, queryParams?.source, tripInfos, passengers)
                    let ssrData = await ApiCall('POST', '/flights/flight-ssr-data', payloadSSRs, { authorization: userToken });
                    if (ssrData?.status === 200) {
                        let baggageMealData = ssrData?.data?.data;
                        if (baggageMealData?.length) {
                            tripInfos = mergeSSRIntoSegments(
                                tripInfos,
                                baggageMealData,
                                (entry, segment) => (
                                    entry?.flights?.flightCode === segment?.airline?.code &&
                                    entry?.flights?.flightNumber === segment.flightNumber &&
                                    entry?.flights?.origin === segment.departure?.airportCode &&
                                    entry?.flights?.destination === segment.arrival?.airportCode
                                ),
                                (entry) => ({
                                    BAGGAGE: entry?.BAGGAGE,
                                    MEAL: entry?.MEAL,
                                })
                            );
                        }
                    }
                    setPassengerDetailsFn(flightDetailsData?.searchQuery?.passengers, flightDetailsData?.conditions, flightDetailsData?.searchQuery?.passKeys);
                    setFlightDetails(tripInfos);
                    setFlightDataPriceObj(flightDetailsData?.totalPrice);
                    setSearchQueryObj(flightDetailsData?.searchQuery);
                    setFinalAmount(flightDetailsData?.totalPrice?.totalFare);
                    setOnLoadLoader(false);
                } else {
                    const errorData = flightReviewData?.data?.data?.[0]?.message;
                    handleReviewError(errorData);
                }
            } else if (queryParams?.source === 'ndc-portal') {
                let originalData = JSON.parse(sessionStorage.getItem('ndcData'))
                let selectedBundle = JSON.parse(sessionStorage.getItem('ndcDataBundle'))
                let payload = {
                    source: queryParams?.source,
                    OfferId: queryParams?.priceId?.split(','),
                    flightDHTRId: queryParams?.flightId,
                    originalData: originalData,
                    selectedBundle: selectedBundle
                }
                let flightReviewData = await ApiCall('POST', '/flights/flight-review', payload, { authorization: userToken });
                if (flightReviewData?.status === 200) {
                    let flightDetailsData = flightReviewData?.data?.data;
                    setPassengerDetailsFn(flightDetailsData?.searchQuery?.passengers, flightDetailsData?.conditions, {}, flightDetailsData?.searchQuery?.passengerBreakDown)
                    setFlightDetails(flightDetailsData?.tripInfos)
                    setFlightDataPriceObj(flightDetailsData?.totalPrice)
                    setSearchQueryObj(flightDetailsData?.searchQuery)
                    setFinalAmount(flightDetailsData?.totalPrice?.totalFare)
                    setOnLoadLoader(false);
                    setFlightOnHoldCondition(flightDetailsData?.flightOnHoldCondition)
                    setNdcFlightId(flightDetailsData?.flightDHTRId)
                    // setFareRuleData(flightDetailsData?.tripInfos[0]?.totalPriceList[0]?.fares)
                } else {
                    handleReviewError(null);
                }
            } else if (queryParams?.source === 'aljazeera') {
                let payload = getSessionStorage(`aljazeera-${queryParams?.priceId}`)
                let payloadData = {
                    source: queryParams?.source,
                    activeCurrency: "AED",
                    baseCurrency: payload?.baseCurrency || agentActiveCurrency,
                    details: payload,
                    flightDHTRId: queryParams?.flightId,
                }
                let ancillaryPayload = {
                    source: queryParams?.source,
                    activeCurrency: "AED", // fetch SSR prices in AED; formatPrice converts for display (no double conversion)
                    // Origin currency the SSRs are priced in (same as TripSell) so backend
                    // can normalize AvailableSSRs prices to AED for display.
                    baseCurrency: payload?.baseCurrency || agentActiveCurrency,
                    flightDHTRId: queryParams?.flightId,
                }
                let flightReviewData = await ApiCall('POST', '/flights/flight-review', payloadData, { authorization: userToken });
                if (flightReviewData?.status === 200) {
                    let flightDetailsData = flightReviewData?.data?.data?.data;
                    // Capture outbound/inbound flight dates so infant age validation can be checked
                    // against the flight dates (Jazeera rules), not today's date.
                    const aljazeeraTripInfos = Array.isArray(flightDetailsData?.tripInfos) ? flightDetailsData.tripInfos : [];
                    const aljazeeraInboundTrip = aljazeeraTripInfos.length > 1 ? aljazeeraTripInfos[aljazeeraTripInfos.length - 1] : aljazeeraTripInfos[0];
                    aljazeeraFlightDatesRef.current = {
                        outbound: aljazeeraTripInfos?.[0]?.segments?.[0]?.departure?.time || null,
                        inbound: aljazeeraInboundTrip?.segments?.[0]?.departure?.time || null,
                    };
                    setPassengerDetailsFn(flightDetailsData?.searchQuery?.passengers, flightDetailsData?.conditions, {}, flightDetailsData?.searchQuery?.passengerBreakDown)
                    setFlightDetails(flightDetailsData?.tripInfos)
                    setFlightDataPriceObj(flightDetailsData?.totalPrice)
                    setSearchQueryObj(flightDetailsData?.searchQuery)
                    setFareRuleData(flightDetailsData?.fareRules)
                    setFinalAmount(flightDetailsData?.totalPrice?.totalFare)
                    setOnLoadLoader(false);
                    setFlightOnHoldCondition(flightDetailsData?.conditions?.holdBooking)
                    // Seat maps are read off the same booking-in-state that this review's
                    // TripSell created, so fetch them here alongside the SSRs.
                    await prefetchSeatMapsFn(flightDetailsData?.tripInfos, queryParams?.source);
                    let baggageMealData = await ApiCall('POST', '/flights/flight-ssr-data', ancillaryPayload, { authorization: userToken });
                    if (baggageMealData?.status === 200) {
                        const ssrData = baggageMealData?.data?.data;
                        const baggageList = ssrData?.baggage || [];
                        const mealList = ssrData?.meals || [];

                        // Normalize an aljazeera SSR option into the shape the UI/select expects
                        const mapAljazeeraOption = (option, type) => ({
                            code: option?.ssrCode,
                            ssrCode: option?.ssrCode,
                            value: option?.ssrCode,
                            name: option?.name,
                            description: option?.name,
                            amount: option?.passengers?.[0]?.price,
                            originalAmount: option?.passengers?.[0]?.originalPrice,
                            currency: agentActiveCurrency,
                            ssrType: type, // 'BAGGAGE' | 'MEAL'
                            feeCode: option?.feeCode,
                            nest: option?.nest,
                            weightKg: option?.weightKg,
                            category: option?.category,
                            limitPerPassenger: option?.limitPerPassenger,
                            available: option?.available,
                            ssrKey: option?.passengers?.[0]?.ssrKey,
                            // keep per-passenger keys/prices so booking can pick the right ssrKey per passenger
                            passengers: option?.passengers,
                        });

                        // Normalize values before comparing — Navitaire identifiers can
                        // carry leading/trailing spaces (e.g. " 402" in journey keys)
                        // which break strict String equality.
                        const normSsrVal = (v) => String(v ?? '').trim();

                        // Match an SSR entry to a segment by carrier + flight number + route
                        const matchEntry = (entries, segment) =>
                            entries?.find(entry =>
                                normSsrVal(entry?.carrierCode) === normSsrVal(segment?.airline?.code) &&
                                normSsrVal(entry?.flightNumber) === normSsrVal(segment?.flightNumber) &&
                                entry?.origin === segment?.departure?.airportCode &&
                                entry?.destination === segment?.arrival?.airportCode
                            );

                        if (baggageList?.length || mealList?.length) {
                            setFlightDetails(prevFlightDetails => {
                                if (!Array.isArray(prevFlightDetails)) return prevFlightDetails;
                                return prevFlightDetails.map((tripData) => {
                                    if (!Array.isArray(tripData?.segments) || !tripData.segments.length) return tripData;
                                    // Baggage entries are JOURNEY level: their origin/destination
                                    // span the whole journey (e.g. BOM -> JED for BOM-KWI-JED),
                                    // so on connecting flights they never match an individual
                                    // segment. Match per trip — by journeyKey when available,
                                    // else by first-segment origin + last-segment destination —
                                    // and attach the options to the first segment of the trip.
                                    const firstSeg = tripData.segments[0];
                                    const lastSeg = tripData.segments[tripData.segments.length - 1];
                                    const journeyBaggageEntry = baggageList?.find(entry =>
                                        (tripData?.journeyKey && entry?.journeyKey === tripData.journeyKey) ||
                                        (
                                            normSsrVal(entry?.carrierCode) === normSsrVal(firstSeg?.airline?.code) &&
                                            normSsrVal(entry?.flightNumber) === normSsrVal(firstSeg?.flightNumber) &&
                                            entry?.origin === firstSeg?.departure?.airportCode &&
                                            entry?.destination === lastSeg?.arrival?.airportCode
                                        )
                                    );
                                    const updatedSegments = tripData.segments.map((segment, segmentIdx) => {
                                        const baggageEntry = matchEntry(baggageList, segment) ||
                                            (segmentIdx === 0 ? journeyBaggageEntry : null);
                                        const mealEntry = matchEntry(mealList, segment);
                                        if (!baggageEntry && !mealEntry) return segment;
                                        return {
                                            ...segment,
                                            specialServices: {
                                                BAGGAGE: (baggageEntry?.options || []).map(opt => mapAljazeeraOption(opt, 'BAGGAGE')),
                                                MEAL: (mealEntry?.options || []).map(opt => mapAljazeeraOption(opt, 'MEAL')),
                                            },
                                        };
                                    });
                                    return { ...tripData, segments: updatedSegments };
                                });
                            });
                        }
                    } else {
                        let errorData = baggageMealData?.data?.data?.[0]?.message;
                        handleReviewError(errorData);
                    }
                    setOnLoadLoader(false);
                    // setFareRuleData(flightDetailsData?.tripInfos[0]?.totalPriceList[0]?.fares)
                } else {
                    handleReviewError(null);
                }
            }
        }
    }

    const getFareRulesDataFn = async (token = '', source, tripInfos = [], passengers = {}) => {
        if (source === 'akasa-air') {
            let segmentDataArr = []
            const passengerMap = {
                ADULT: "ADT",
                CHILD: "CHD",
                INFANT: "INF"
            };
            const passengerArray = Object.entries(passengers || {})
                .filter(([key, value]) => passengerMap[key] && value > 0)
                .map(([key, value]) => ({
                    passengerType: passengerMap[key],
                    passengerDiscountCode: null,
                    passengerCount: value
                }));
            let fareAvailabilityKey = '';
            let roundTripData = [];
            if (queryParams?.priceId?.includes(',')) {
                let pricingId = queryParams?.priceId?.split(',');
                if (pricingId?.length) {
                    pricingId.map(item => {
                        let [journeyKey, priceId] = item.split('|');
                        roundTripData.push({
                            journeyKey: journeyKey,
                            fareAvailabilityKey: priceId
                        })
                    });
                }
            } else {
                fareAvailabilityKey = queryParams?.priceId;
            }

            tripInfos?.map((tripData) => {
                return tripData?.segments?.map((segmentData) => {
                    if (!fareAvailabilityKey) {
                        let tripWiseData = roundTripData.find(trip => trip.journeyKey === tripData?.journeyKey);
                        fareAvailabilityKey = tripWiseData?.fareAvailabilityKey
                    }
                    segmentDataArr.push({
                        url: `/nsk/v1/fareRules/category50/journeys/${tripData?.journeyKey}/segments/${segmentData?.segementKey}`,
                        key: `${segmentData?.departure?.airportCode}-${segmentData?.arrival?.airportCode}`,
                        fareAvailabilityKey: fareAvailabilityKey,
                    })
                })
            })

            if (segmentDataArr?.length) {
                const fareRuleDataAPI = await ApiCall('POST', '/flights/fare-rules', {
                    source,
                    token,
                    segmentDataArr,
                    flightDHTRId: queryParams?.flightId,
                    passengerPriceTypes: passengerArray,
                }, { authorization: userToken });
                if (fareRuleDataAPI?.status === 200 && fareRuleDataAPI?.data?.statusCode === 200 && fareRuleDataAPI?.data?.data) {
                    let flightFareRuleData = fareRuleDataAPI?.data?.data;
                    if (flightFareRuleData && Object?.keys(flightFareRuleData)?.length > 0) {
                        setFareRuleData(flightFareRuleData)
                    }
                }
            }
        }
    }

    // processVerteilFareRules — extracted to ./PassengerListPage/utils/verteilHelpers.js
    // parsePassengerString — extracted to ./PassengerListPage/utils/bookingHelpers.js
    // getAljazeeraInfantDobError — extracted to ./PassengerListPage/utils/bookingHelpers.js

    const setPassengerDetailsFn = (passengersDetails, condition, passKeys = {}, passengerBreakDown = {}) => {
        let passenger_data = [];
        const ageLookup = (queryParams?.source === 'aljazeera')
            ? {
                ADULT: '(12+ Yrs)',
                CHILD: '(2 - 12 Yrs)',
                INFANT: '(14 Days - 2 Yrs)',
                HELD_INFANT: '(14 Days - 2 Yrs)'
            }
            : {
                ADULT: '(12+ Yrs)',
                CHILD: '(2 - 12 Yrs)',
                INFANT: '(0 - 2 Yrs)',
                HELD_INFANT: '(0 - 2 Yrs)'
            };
        if (Object.keys(passengersDetails).length) {
            Object.keys(passengersDetails)?.map((passengers, passIndex) => {
                const keys = passKeys?.[passengers] || [];
                for (let i = 1; i <= passengersDetails[passengers]; i++) {
                    let keyIndex = i - 1;
                    const age = ageLookup[passengers];
                    passenger_data.push({
                        title: `${passengers.charAt(0)}${passengers.slice(1).toLowerCase()} ${i} : ${age}`,
                        originalTitle: `${passengers.charAt(0)}${passengers.slice(1).toLowerCase()} ${i}`,
                        passengerType: passengers,
                        open: passIndex === 0,
                        keys: keys?.[keyIndex] || undefined,
                        // passportRequired: condition.passportRequired,
                        passportRequired: true,
                        gender: "",
                        firstName: "",
                        lastName: "",
                        selectedCountryOption: null,
                        countryInput: "",
                        countryInputOpen: false,
                        passportNumber: "",
                        passportDOB: null,
                        passportIssueDate: null,
                        passportExpiryDate: null,
                        ...((queryParams?.source === 'ndc-portal' && passengerBreakDown) && {
                            passengerDiscountAmount: passengerBreakDown?.[passengers]?.passengerDiscountAmount,
                            passengerServiceChargeAmount: passengerBreakDown?.[passengers]?.passengerServiceChargeAmount,
                        }),
                      
                    });
                }
            })
        }
        const passengerSchemas = Yup.array().of(
            Yup.object().shape({
                gender: Yup.string().required('Gender is required.'),
                firstName: Yup.string().required('First Name is required.'),
                lastName: Yup.string().required('Last Name is required.'),
                dateOfBirth: Yup.date()
                    .when(['passportRequired', 'passengerType'], {
                        is: (passportRequired, passengerType) =>
                            (!passportRequired && (passengerType === 'CHILD' || passengerType === 'INFANT' || passengerType === 'HELD_INFANT')),
                        then: (schema) => {
                            return schema
                                .required('Date of Birth is required.')
                                .test('age-validation', '', function (value) {
                                    const today = moment();
                                    const { passengerType } = this.parent;
                                    if (!value) {
                                        return this.createError({ message: 'Date of Birth is required.' });
                                    }
                                    const birthDate = moment(value);

                                    // const age = moment(today).diff(moment(value), 'years', true);
                                    if (passengerType === 'CHILD') {
                                        const minChildAge = today.clone().subtract(12, 'years');
                                        const maxChildAge = today.clone().subtract(2, 'years');
                                        if (!birthDate.isBetween(minChildAge, maxChildAge, 'day', '[]')) {
                                            return this.createError({
                                                message: 'Child must be between 2 and 12 years old.',
                                            });
                                        }
                                    } else if (passengerType === 'INFANT' || passengerType === 'HELD_INFANT') {
                                        const aljazeeraDates = queryParams?.source === 'aljazeera' ? aljazeeraFlightDatesRef.current : null;
                                        if (aljazeeraDates?.outbound) {
                                            const aljazeeraError = getAljazeeraInfantDobError(birthDate, aljazeeraDates);
                                            if (aljazeeraError) {
                                                return this.createError({ message: aljazeeraError });
                                            }
                                        } else {
                                            const maxInfantAge = today.clone().subtract(2, 'years');
                                            if (birthDate.isBefore(maxInfantAge, 'day')) {
                                                return this.createError({
                                                    message: 'Infant must be younger than 2 years.',
                                                });
                                            }
                                        }
                                    }
                                    return true;
                                });
                        },
                        otherwise: (schema) => schema
                    }),
                selectedCountryOption: Yup.object().shape({
                    value: Yup.string().when('passportRequired', {
                        is: true,
                        then: (schema) => schema.required('Nationality is required.'),
                        otherwise: (schema) => schema,
                    })
                }).required('Nationality is required'),
                passportDOB: Yup.date()
                    .when(['passportRequired', 'passengerType'], {
                        is: (passportRequired) => passportRequired === true,
                        then: (schema) => schema
                            .required('DOB is required.')
                            .test('age-validation', '', function (value) {
                                if (!value) {
                                    return this.createError({ message: 'DOB is required' });
                                }
                                const today = moment();
                                const { passengerType } = this.parent;
                                const birthDate = moment(value);
                                if (passengerType === 'CHILD') {
                                    const minChildAge = today.clone().subtract(12, 'years');
                                    const maxChildAge = today.clone().subtract(2, 'years');
                                    if (!birthDate.isBetween(minChildAge, maxChildAge, 'day', '[]')) {
                                        return this.createError({
                                            message: 'Child must be between 2 and 12 years old.',
                                        });
                                    }
                                } else if (passengerType === 'INFANT' || passengerType === 'HELD_INFANT') {
                                    const aljazeeraDates = queryParams?.source === 'aljazeera' ? aljazeeraFlightDatesRef.current : null;
                                    if (aljazeeraDates?.outbound) {
                                        const aljazeeraError = getAljazeeraInfantDobError(birthDate, aljazeeraDates);
                                        if (aljazeeraError) {
                                            return this.createError({ message: aljazeeraError });
                                        }
                                    } else {
                                        const maxInfantAge = today.clone().subtract(2, 'years');
                                        if (birthDate.isBefore(maxInfantAge, 'day')) {
                                            return this.createError({
                                                message: 'Infant must be younger than 2 years.',
                                            });
                                        }
                                    }
                                } else if (passengerType === 'ADULT') {
                                    const minAdultAge = today.clone().subtract(12, 'years');
                                    if (birthDate.isAfter(minAdultAge, 'day')) {
                                        return this.createError({
                                            message: 'Adult must be at least 12 years old.',
                                        });
                                    }
                                }
                                return true;
                            }),
                        otherwise: (schema) => schema.notRequired(),
                    }),
                passportNumber: Yup.string().when('passportRequired', {
                    is: true,
                    then: (schema) =>
                        schema
                            .required('Passport Number is required.')
                            .min(6, 'Passport number must be at least 6 characters.')
                            .max(15, 'Passport number must be at most 15 characters.')
                            .matches(/^[A-Z0-9]+$/, 'Passport number must contain only letters and numbers (A–Z, 0–9).'),
                    otherwise: (schema) => schema,
                }),
                passportIssueDate: Yup.date().when('passportRequired', {
                    is: true,
                    then: (schema) => schema.required('Passport Issue Date is required.'),
                    otherwise: (schema) => schema,
                }),
                passportExpiryDate: Yup.date().when('passportRequired', {
                    is: true,
                    then: (schema) =>
                        schema
                            .required('Passport Expiry Date is required.')
                            .test(
                                'min-expiry-date',
                                'Passport expiry date must be at least 6 months from today.',
                                function (value) {
                                    const today = new Date();
                                    const minExpiryDate = new Date(
                                        today.getFullYear(),
                                        today.getMonth() + 6,
                                        today.getDate()
                                    );
                                    return value && value >= minExpiryDate;
                                }
                            ),
                    otherwise: (schema) => schema,
                }),
            })
        );
        setFormSchema(Yup.object().shape({
            phoneCode: Yup.object().shape({
                value: Yup.string().required('Phone Code is required.'),
            }).required('Phone Code is required'),
            phoneNumber: Yup.string()
                .matches(/^[0-9]+$/, 'Phone number must contain only digits')
                .min(7, 'Phone number must be at least 7 digits')
                .max(15, 'Phone number must be no more than 15 digits')
                .required('Phone Number is required.'),
            email: Yup.string()
                .required("Email is required")
                .email("Please enter a valid email")
                .matches(/^\S+@\S+\.\S+$/, "Please enter a valid email")
                .matches(/^\S*$/, "No spaces allowed"),
            passgeners: passengerSchemas,
            ...((queryParams?.source === 'air-arabia' || queryParams?.source === 'akasa-air' || queryParams?.source === 'verteil' || queryParams?.source === 'aljazeera') && {
                addressCountry: Yup.object().nullable().required('Country is required.'),
                addressCity: Yup.string().required('City is required.')
            }),
            ...((queryParams?.source === 'akasa-air' || queryParams?.source === 'verteil' || queryParams?.source === 'aljazeera') && {
                addressOne: Yup.string().required('Address is required.'),
                postalCode: queryParams?.source === 'aljazeera'
                    ? Yup.string().max(10, 'Postal Code must be 10 characters or less.').required('Postal Code is required.')
                    : Yup.string().required('Postal Code is required.'),
                addressState: Yup.object().nullable().required('State is required.'),
            })
        }))
        setInitialState({ ...initialState, passgeners: passenger_data })
    }


    useEffect(() => {
        if (countryWithDialCodeArr?.length) {
            let countryDialCodeArr = [...countryWithDialCodeArr];
            const country_data = countryDialCodeArr.map((items) => ({
                value: items.country_code,
                label: items.country_name,
            }));
            const country_dial_data = countryDialCodeArr.map((items) => ({
                value: items.country_dial_code,
                label: `${items?.country_code?.toUpperCase()} (${items.country_dial_code})`,
                country_code: items.country_code
            }));
            if (JSON.stringify(country_dial_data) !== JSON.stringify(countryDialCodeData)) {
                setCountryDialCodeData(country_dial_data);
            }

            if (JSON.stringify(country_data) !== JSON.stringify(countryData)) {
                setCountryData(country_data);
            }
        }
    }, [countryWithDialCodeArr]);

    useEffect(() => {
        let formikErrors = formik?.errors?.passgeners;
        if (formikErrors?.length) {
            formikErrors.forEach((error, index) => {
                if (error && typeof error === 'object' && Object.keys(error).length > 0) {
                    formik.setFieldValue(`passgeners[${index}].open`, true);
                }
            });
            setTimeout(() => {
                const errorElement = document.querySelector('.hw-p-error-cls');
                if (errorElement) {
                    errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 100);
        }
    }, [formik?.errors?.passgeners]);

    const step1ContinueBtnFn = () => {
        if (queryParams?.source === 'air-arabia') {
           
            const flightsWithBundle = airArabiaBundle?.filter(bundle => "serviceId" in bundle) || []
            const nonInfantPassengers = formik.values.passgeners.filter(p => p.passengerType !== 'INFANT');
            const totalseatstoselect = flightsWithBundle.length * nonInfantPassengers.length;
            let selectedSeats = 0;
            nonInfantPassengers.forEach(p => {
                if (p.SEATS && p.SEATS.length > 0) selectedSeats += p.SEATS.length;
            });

            let errorMessage = "";
            flightsWithBundle.forEach(bundle => {
                nonInfantPassengers.forEach(p => {
                    const seats = Array.isArray(p.SEATS) ? p.SEATS : [];
                    const hasSeatForThisFlight = seats.some(seat => seat?.path?.toUpperCase() === bundle?.direction?.toUpperCase());
                    if (!hasSeatForThisFlight) {
                        errorMessage = `Please select seat for all passengers on the ${bundle?.direction} bundled flight.`;
                    }
                });
            });

            if (errorMessage) {
                formik.setFieldValue('seatMapOpen', true);
                setSectionError({
                    ...sectionError,
                    seatError: errorMessage
                });
                return;
            } else {
                setSectionError({ ...sectionError, seatError: '' });
            }
        } else if (queryParams?.source === 'travel-fusion' && seatRequired) {
            const nonInfantPassengers = formik.values.passgeners.filter(p => p.passengerType !== 'INFANT');
            const seatSegmentKeys = (flightDetails || [])
                .flatMap(trip => trip?.segments || [])
                .filter(seg => seg?.specialServices?.SEAT?.rows?.length)
                .map(seg => `${seg?.departure?.airportCode}-${seg?.arrival?.airportCode}`);

            let missing = false;
            for (const p of nonInfantPassengers) {
                const seats = Array.isArray(p?.SEAT) ? p.SEAT : [];
                if (seatSegmentKeys.some(segKey => !seats.some(s => s?.segmentKey === segKey))) {
                    missing = true;
                    break;
                }
            }

            if (seatSegmentKeys.length && missing) {
                setSectionError({ ...sectionError, seatError: 'Please select a seat for all passengers.' });
                setTimeout(() => {
                    const el = document.querySelector('.hw-passenger--fareShow__widget');
                    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 100);
                return;
            } else {
                setSectionError({ ...sectionError, seatError: '' });
            }
        }
        let tabsCurrent = { ...currentTab };
        tabsCurrent['1'].active = false;
        tabsCurrent['1'].success = true;
        tabsCurrent['2'].active = true;
        setCurrentTab(tabsCurrent);
        setTab2SubStep('review'); // always land on the Review step first (UI only)
    }

    const headerBackButtonFn = () => {
        setCheckboxAndWalletError("")
        let tabsCurrent = { ...currentTab };
        // Back on the Payment step just returns to Review — no tab/logic change.
        if (tabsCurrent['2'].active && tab2SubStep === 'payment') {
            setTab2SubStep('review');
            window.scrollTo(0, 0);
            return;
        }
        if (tabsCurrent['2'].active) {
            tabsCurrent['2'].active = false;
            tabsCurrent['1'].active = true;
            tabsCurrent['1'].success = false;
            setCurrentTab(tabsCurrent);
            setShowDiscounts(false);
            setCouponCodeError('')
            setCouponCodeInput('')
            setActiveCouponCodeData({
                coupon_code: '',
                discount_type: '',
                discount_value: ''
            });
            let totalAmount = (parseFloat(flightDataPriceObj?.totalFare) || 0);
            setFinalAmount(totalAmount)
            sessionStorage.removeItem('ndcData')
            sessionStorage.removeItem('ndcDataBundle')
        } else if (tabsCurrent['1'].active) {
            sessionStorage.removeItem('ndcData')
            sessionStorage.removeItem('ndcDataBundle')
            const getlastQueryParamsFlightData = getCookie('lastQueryParamsFlight');
            navigate(`/flight/list${getlastQueryParamsFlightData}`, { state: new Date().getTime() });
        }
    }

    const backtoSearchButtonFn = () => {
        sessionStorage.removeItem('ndcData')
        sessionStorage.removeItem('ndcDataBundle')
        setShowBaggageDetailsModal(false);
        setflightShowErrorMessage('');
        const getlastQueryParamsFlightData = getCookie('lastQueryParamsFlight');
        navigate(`/flight/list${getlastQueryParamsFlightData}`, { state: new Date().getTime() });
    }

    const generateNonceForTranscationFn = async (transcationType = 'wallet', type = 'debit') => {
        let nonceToken = '';
        const nonceData = await GetApiCall('GET', `wp-json/dahr/v1/generate-nonce?userToken=${userToken}&transaction_type=${type}&type=${transcationType}`, {}, 'wordpress');
        if (nonceData?.status === 200) {
            nonceToken = nonceData?.data?.nonce;
        }
        return nonceToken;
    }

    // Sync queryParams from URL when location.search changes
    useEffect(() => {
        setQueryParams(getBookingQueryParams(location.search) || {});
    }, [location.search]);

    useEffect(() => {
        if (queryParams?.bookingId || queryParams?.refreshPage) {
            let tabsCurrent = { ...currentTab };
            tabsCurrent['1'].active = false;
            tabsCurrent['2'].active = false;
            tabsCurrent['3'].active = true;
            setCurrentTab(tabsCurrent);
            setOnLoadLoader(true);
            bookingDataDetailsFn()
            window.scrollTo(0, 0)
        }
    }, [queryParams?.bookingId, queryParams?.refreshPage])

    const bookingDataDetailsFn = async (attempt = 0) => {
        if (queryParams?.bookingId) {

            let payload = {
                bookingId: queryParams?.bookingId,
                type: queryParams?.source,
                activeCurrency: "AED",
                fromDatabase:
                    queryParams?.source === "aljazeera"
                        ? !!(
                            queryParams?.status !== "HOLD" ||
                            queryParams?.status !== "HOLD_RELEASE" &&
                            queryParams?.detail
                        )
                        : !!(
                            queryParams?.status !== "HOLD" &&
                            queryParams?.detail
                        ),
            };
            if (queryParams.source === 'ndc-portal') {
                payload['tripIdentifier'] = getCookie('ndcIdentifier')
            }
            if (queryParams?.source === 'fly-dubai') {
                payload['priceInfo'] = { ...flightDataPriceObj, finalAmount }
            }
            const bookingData = await ApiCall('POST', '/flights/flight-booking-details', payload, { authorization: userToken });
            if (bookingData?.status === 200) {
                let flightDetailsData = bookingData?.data?.data?.data;

                const priceInfo = flightDetailsData?.totalPriceInfo;
                const priceNotReady = !Number(priceInfo?.totalFare) && !Number(priceInfo?.baseFare);
                if (queryParams?.source === 'aljazeera' && queryParams?.freshBooking && priceNotReady && attempt < 5) {
                    setOnLoadLoader(true);
                    setTimeout(() => bookingDataDetailsFn(attempt + 1), 1500);
                    return;
                }

                if (queryParams?.status?.toUpperCase() === "HOLD") {
                    const status = flightDetailsData?.bookingStatus?.toUpperCase();

                    if (status === "CONFIRMED") {
                        setQueryParams(prev => ({ ...prev, status: "confirmed" }));
                    } else if (status === "PENDING") {
                        setQueryParams(prev => ({ ...prev, status: "PENDING" }));
                    } else if (status === "HOLD_RELEASE") {
                        setQueryParams(prev => ({ ...prev, status: "HOLD_RELEASE" }));
                    } else if (status === "HOLD-RELEASE") {
                        setQueryParams(prev => ({ ...prev, status: "hold-release" }));
                    } else if (status === "ABORTED") {
                        setQueryParams(prev => ({ ...prev, status: "ABORTED" }));
                    } else if (status === "FAILED") {
                        setQueryParams(prev => ({ ...prev, status: "FAILED" }));
                    } else if (status === "UNCONFIRMED") {
                        setQueryParams(prev => ({ ...prev, status: "UNCONFIRMED" }));
                    }
                }
                setBookingOtherData(flightDetailsData)
                setBookingStatus(flightDetailsData?.bookingStatus)
                setSearchQueryObj(flightDetailsData?.searchQuery || {})
                setFlightDetails(flightDetailsData?.tripInfos)
                if (queryParams?.source === 'travel-fusion') {
                    setFareRuleDataBookingPage(flightDetailsData?.fareData)
                }
                if (queryParams?.source === 'tripjack') {
                    getFareRuleDataFn(queryParams?.bookingId)
                }
                if (queryParams?.source === 'verteil' && flightDetailsData?.segmentPenaltyArr) {
                    const processedFareRules = processVerteilFareRules(flightDetailsData?.segmentPenaltyArr, flightDetailsData?.tripInfos);
                    setFareRuleDataBookingPage(processedFareRules);

                    if (processedFareRules && Object.keys(processedFareRules).length > 0) {
                        const firstSegmentKey = Object.keys(processedFareRules)[0];
                        setFareRuleActiveIndex(firstSegmentKey);
                    }
                }
            }
        }
        setOnLoadLoader(false);
    }

    const getFareRuleDataFn = async (bookingId) => {
        const fareRuleData = await ApiCall('POST', '/flights/fare-rules', {
            source: 'tripjack',
            priceId: bookingId,
            type: "BOOKING_DETAIL",
            activeCurrency: agentActiveCurrency,
        }, { authorization: userToken });
        if (fareRuleData?.status === 200 && fareRuleData?.data?.statusCode === 200 && fareRuleData?.data?.data?.data?.fareRule) {
            let flightFareRuleData = fareRuleData?.data?.data?.data?.fareRule;
            if (flightFareRuleData && Object?.keys(flightFareRuleData)?.length > 1) {
                setFareRuleActiveIndex(Object?.keys(flightFareRuleData)?.[0])
            }
            setFareRuleDataBookingPage(flightFareRuleData)
        }
    }

    const unHoldTicketFn = async () => {
        setUnHoldButtonLoader(true);

        try {
            let pnrDetails = [];
            if (bookingOtherData?.travellerInfos?.length) {
                pnrDetails = [...new Set(
                    bookingOtherData?.travellerInfos.flatMap(passenger =>
                        Object.values(passenger?.pnrDetails || {})
                    )
                )];
            }

            if (!pnrDetails.length) {
                setUnHoldButtonLoader(false);
                return;
            }

            const queryPayload = {
                bookingId: queryParams?.bookingId,
                pnrs: pnrDetails,
                source: queryParams?.source
            };

            const flightReleaseBooking = await ApiCall(
                'POST',
                '/flights/release-booking',
                queryPayload,
                { authorization: userToken }
            );

            if (
                flightReleaseBooking?.status === 200 &&
                flightReleaseBooking?.data?.statusCode === 200
            ) {
                const releasedBookingId = flightReleaseBooking?.data?.data;

                navigate(
                    `/flight/booking?bookingId=${queryParams?.bookingId}&source=${toUrlSource(queryParams?.source)}&status=HOLD_RELEASE&refresh=1`
                );
            } else {
                setCheckboxAndWalletError(flightReleaseBooking?.data?.message || 'Something went wrong.')
            }
        } catch (error) {
            console.error('Release booking failed:', error);
            setCheckboxAndWalletError('Something went wrong.');
        } finally {
            setUnHoldButtonLoader(false);
        }

    }

    const holdTicketConfirmFn = async () => {
        setPayNowBtnLoader(true);
        setOnLoadLoader(false);
        let payload = {
            source: queryParams?.source,
            bookingId: queryParams?.bookingId
        }
        if (queryParams?.source === 'ndc-portal') {
            payload.total = bookingOtherData?.totalPriceInfo?.totalFare
            payload.agentActiveCurrency = "AED";
        }
        const flightBooking = await ApiCall('POST', `/flights/validate-booking`, payload, { authorization: userToken });
        if (flightBooking?.status === 200 && flightBooking?.data?.statusCode === 200 && flightBooking?.data?.data?.bookingId) {
            if (selectPaymentMethod === 1) {
                setPayNowBtnLoader(false);
                setOnLoadLoader(false);
                setndcPriceAfterHold(flightBooking?.data?.data?.totalAmount)
                setndcRealPriceAfterHold(flightBooking?.data?.data?.originalAmount)
                setStripeModalShow(true);
            } else {
                setPayNowBtnLoader(true);
                setOnLoadLoader(false);
                const walletBalanceData = await GetApiCall('GET', `wp-json/dahr/v1/user-wallet-balance?userToken=${userToken}&activeUserCurrency=${agentActiveCurrency}`, {}, 'wordpress');
                if (walletBalanceData?.status === 200) {
                    let walletBalance = walletBalanceData?.data?.wallet_balance;
                    let totalPrice = bookingOtherData?.totalPriceInfo?.totalFare;
                    if (bookingOtherData?.totalPriceInfo?.couponData?.finalAmount) {
                        totalPrice = bookingOtherData?.totalPriceInfo?.couponData?.finalAmount;
                    }
                    if (queryParams.source === 'ndc-portal' && flightBooking?.data?.data?.totalAmount) {
                        totalPrice = flightBooking?.data?.data?.totalAmount;
                    }
                    totalPrice = parseFloat(totalPrice) || 0;
                    if (parseFloat(walletBalance) >= parseFloat(totalPrice)) {
                        let nonceToken = await generateNonceForTranscationFn('wallet', 'debit');
                        const deductBalanceFromWallet = await ApiCall('POST', `wp-json/dahr/v1/wallet-transaction`, {
                            userToken: userToken,
                            activeUserCurrency: agentActiveCurrency,
                            display_currency: getActiveCode(),
                            conversion_rate: getActiveRate(),
                            transaction_type: "debit",
                            payment_mode: "wallet",
                            amount: totalPrice,
                            nonce: nonceToken,
                            transaction_comment: `Debited Towards : Flight Booking`
                        }, {}, 'wordpress');
                        if ((deductBalanceFromWallet?.status === 200 && deductBalanceFromWallet?.data?.success && deductBalanceFromWallet?.data?.transaction_id) || (activeCouponCodeData?.discount_value && totalPrice === 0)) {
                            let queryPayload;
                            let bookingId;
                            if (queryParams?.source === 'tripjack') {
                                bookingId = bookingOtherData?.orders?.bookingId;
                                queryPayload = {
                                    type: "tripjack",
                                    bookingId: bookingOtherData?.orders?.bookingId,
                                    paymentInfos: [{
                                        amount: bookingOtherData?.orders?.amount
                                    }],
                                    paymentMode: 'WALLET',
                                    transcationId: deductBalanceFromWallet?.data?.transaction_id
                                }
                            } else {
                                bookingId = queryParams?.bookingId;
                                queryPayload = {
                                    type: queryParams?.source,
                                    bookingId: bookingId,
                                    paymentMode: 'WALLET',
                                    transcationId: deductBalanceFromWallet?.data?.transaction_id
                                };
                            }
                            if(flightBooking?.data?.data?.originalAmount) {
                                queryPayload.originalAmount = flightBooking?.data?.data?.originalAmount;
                            }
                            const flightBooking = await ApiCall('POST', `/flights/flight-confirm-booking`, { ...queryPayload, activeCurrency: "AED", agentActiveCurrency: "AED", display_currency: bookingOtherData?.currency || agentActiveCurrency }, { authorization: userToken });
                            if (flightBooking?.status === 200 && flightBooking?.data?.statusCode === 200 && !flightBooking?.data?.data?.errors) {
                                let bookingReferenceNumber;
                                let createFlightBookingZohoInvoice = await ApiCall('POST', `wp-json/dahrEmaarApi/v1/createFlightBookingZohoInvoice`, {
                                    totalPrice: totalPrice,
                                    bookingReference: bookingId,
                                    "paymentMode": "WALLET",
                                }, {}, 'wordpress');
                                let nonceToken = await generateNonceForTranscationFn('loyalty', 'credit');
                                ApiCall('POST', `wp-json/dahr/v1/loyalty-points-transaction`, {
                                    userToken: userToken,
                                    amount: totalPrice,
                                    booking_type: "vendor_flight_booking",
                                    booking_id: bookingId,
                                    transaction_comment: `Credited Towards: Flight Booking`,
                                    nonce: nonceToken
                                }, {}, 'wordpress');
                                setPayNowBtnLoader(false);
                                setOnLoadLoader(false);
                                navigate(`/flight/booking?bookingId=${bookingId}&source=${toUrlSource(queryParams?.source)}&bookingReferenceNumber=${bookingReferenceNumber}&refresh=1`);
                            } else {
                                setPayNowBtnLoader(false);
                                setOnLoadLoader(false);
                                setCheckboxAndWalletError(getBookingErrorMessage(flightBooking?.data?.data?.errors, 'Something went wrong.'))
                                let nonceToken = await generateNonceForTranscationFn('wallet', 'credit');
                                await ApiCall('POST', `wp-json/dahr/v1/wallet-transaction`, {
                                    userToken: userToken,
                                    activeUserCurrency: agentActiveCurrency,
                                    display_currency: getActiveCode(),
                                    conversion_rate: getActiveRate(),
                                    transaction_type: "credit",
                                    payment_mode: "wallet",
                                    amount: totalPrice,
                                    nonce: nonceToken,
                                    transaction_comment: `Credited Towards: Flight Booking Error`
                                }, {}, 'wordpress')
                            }
                        } else {
                            setPayNowBtnLoader(false);
                            setOnLoadLoader(false);
                            setCheckboxAndWalletError('Wallet Balance not deduct.')
                        }
                    } else {
                        setPayNowBtnLoader(false);
                        setOnLoadLoader(false);
                        setCheckboxAndWalletError(`Insufficient Balance. Your Total Balance is: ${walletBalance} <br/>
                        <a target="_blank" href="${process.env.wordpressApiEndPoint}dashboard/?tab=new-balance-request" class="hw-link--line">Add your Balance</a>`);
                    }
                } else {
                    setPayNowBtnLoader(false);
                    setOnLoadLoader(false);
                    setCheckboxAndWalletError('Something went wrong.')
                }
            }
        } else {
            setPayNowBtnLoader(false);
            setOnLoadLoader(false);
            setCheckboxAndWalletError(flightBooking?.data?.message || 'Something went wrong.')
        }
    }

    const step2PayNowBtnFn = async (hold, checkBooking = true) => {
        if (!iAcceptCheckBox) {
            setTermsError('Please accept the Terms &amp; Conditions to continue.')
            return
        } else {
            clearInterval(intervalRef.current)
            setCheckboxAndWalletError('')
            setTermsError('')
        }
        if (hold) {
            setHoldButtonLoader(true);
            setOnLoadLoader(false);

            if (queryParams?.source === 'aljazeera') {
                const chargeablePax = (formik?.values?.passgeners || []).filter(
                    (p) => p?.passengerType !== 'INFANT',
                ).length;
                const estimatedHoldFee = ALJAZEERA_HOLD_FEE_PER_PAX * chargeablePax;
                const walletBalanceData = await GetApiCall(
                    'GET',
                    `wp-json/dahr/v1/user-wallet-balance?userToken=${userToken}&activeUserCurrency=${agentActiveCurrency}`,
                    {},
                    'wordpress',
                );
                if (walletBalanceData?.status !== 200) {
                    setHoldButtonLoader(false);
                    setOnLoadLoader(false);
                    setCheckboxAndWalletError('Unable to verify wallet balance. Please try again.');
                    return;
                }
                const walletBalance = parseFloat(walletBalanceData?.data?.wallet_balance) || 0;
                if (walletBalance < estimatedHoldFee) {
                    setHoldButtonLoader(false);
                    setOnLoadLoader(false);
                    setCheckboxAndWalletError(`Insufficient Balance for the hold fee (approx. ${estimatedHoldFee}). Your Total Balance is: ${walletBalance} <br/>
                        <a target="_blank" href="${process.env.wordpressApiEndPoint}dashboard/?tab=new-balance-request" class="hw-link--line">Add your Balance</a>`);
                    return;
                }
            }

            let contactNumber = `${formik.values.phoneCode?.value}${formik.values.phoneNumber}`
            let queryPayload;
            if (queryParams?.source === 'air-arabia') {
                let haveIncludedService = false
                let baggageData = [];
                let mealData = [];
                let seatmapdata = []
                let travellerInfo = []
                const adultRefs = [];
                formik?.values?.passgeners?.map((passenger, index) => {
                    const paxType = passenger?.passengerType || '';
                    let refListNum = `${paxType?.charAt(0)}${index + 1}`;

                    if (paxType === 'ADULT') {
                        adultRefs.push(refListNum);
                    }

                    if (passenger?.passengerType === 'INFANT') {
                        const adultIndex = adultRefs[travellerInfo.length % adultRefs.length] || adultRefs[0] || 'A1';
                        refListNum = `${paxType.charAt(0)}${index + 1}/${adultIndex}`;
                    }
                    if (passenger?.BAGGAGE?.length) {
                        passenger?.BAGGAGE?.map((baggage) => {
                            baggageData.push({
                                ...baggage,
                                refListNum
                            })
                        })
                    }
                    if (passenger?.MEAL?.length) {
                        passenger?.MEAL?.map((meal) => {
                            mealData.push({
                                ...meal,
                                refListNum
                            })
                        })
                    }
                    if (passenger?.SEATS?.length) {
                        passenger?.SEATS?.map((seat) => {
                            seatmapdata.push({
                                seatnumber: seat?.seatNumber,
                                rphCode: seat?.rphCode,
                                travelerRef: seat?.travelerRef,
                                price: parseFloat(seat?.price) || 0,
                                originalAmount: parseFloat(seat?.originalAmount) || 0,
                            })
                        })
                    }
                    travellerInfo.push({
                        title: passenger?.gender === 'Mr' ? 'Mr' : passenger?.gender === 'Ms' ? 'ms' : passenger?.gender === 'Mrs' ? 'Mrs' : passenger?.gender === 'Master' ? 'Master' : 'Miss',
                        firstName: passenger?.firstName?.trim() || '',
                        lastName: passenger?.lastName?.trim() || '',
                        paxType: passenger?.passengerType || '',
                        dateOfBirth: passenger?.dateOfBirth || '',
                        dob: passenger?.passportDOB || '',
                        passportNumber: passenger?.passportNumber?.trim() || '',
                        passportExpiryDate: passenger?.passportExpiryDate || '',
                        passportNationality: passenger?.selectedCountryOption?.value?.toUpperCase() || '',
                        passportIssueDate: passenger?.passportIssueDate || '',
                        refListNum: refListNum
                    })
                })

                queryPayload = {
                    type: 'air-arabia',
                    travellerInfo: travellerInfo,
                    searchQuery: searchQueryObj,
                    tripInfo: flightDetails,
                    originalAmount: flightDataPriceObj?.totalFare,
                    email: formik.values.email,
                    countryCode: formik.values.phoneCode?.value,
                    mobileNumber: formik.values.phoneNumber,
                    information: airArabiaFlightData,
                    baggageData: baggageData,
                    mealData: mealData,
                    addressCountry: formik?.values?.addressCountry,
                    addressCity: formik?.values?.addressCity,
                    seatmapdata: seatmapdata,
                    bundleSelection: airArabiaBundle
                }
            } else if (queryParams?.source === 'ndc-portal') {
                let passengerData = {}
                let index = 0
                let adulRefs = []
                let travellerInfo = [];
                for (let passenger of formik?.values?.passgeners) {
                    const paxType = passenger?.passengerType || '';
                    let paxKey = `Pax${index + 1}`
                    if (passenger?.passengerType === 'ADULT') {
                        adulRefs.push(paxKey)
                    }
                    let parentRef = null;
                    if (paxType === 'INFANT') {
                        parentRef = adulRefs[travellerInfo.length % adulRefs.length] || adulRefs[0] || 'Pax1';
                    }

                    let countryISOCode = passenger?.selectedCountryOption?.value;
                    if (countryISOCode === 'uk') {
                        countryISOCode = 'gb';
                    } else if (countryISOCode === 'uae') {
                        countryISOCode = 'ae';
                    }

                    passengerData[paxKey] = {
                        PassengerTypeCode: passenger?.passengerType === 'ADULT' ? 'ADT' : passenger?.passengerType === 'CHILD' ? 'CHD' : 'INF',
                        Title: getTitleFromGenderLower(passenger?.gender),
                        Gender: getGenderFromTitle(passenger?.gender),
                        Name: {
                            First: passenger?.firstName?.trim() || '',
                            Middle: "",
                            Last: passenger?.lastName?.trim() || ''
                        },
                        BirthDate: passenger?.passportDOB || '',
                        NationalityCountryCode: countryISOCode?.toUpperCase() || '',
                        ResidenceCountryCode: countryISOCode?.toUpperCase() || '',
                        ParentPassengerReferenceId: parentRef,
                        TravelDocument: {
                            DocumentNumber: passenger?.passportNumber?.trim() || '',
                            DocumentType: "Passport",
                            Name: {
                                First: passenger?.firstName?.trim() || '',
                                Middle: "",
                                Last: passenger?.lastName?.trim() || ''
                            },
                            Gender: getGenderFromTitle(passenger?.gender),
                            BirthDate: passenger?.passportDOB || '',
                            ExpirationDate: passenger?.passportExpiryDate || '',
                            IssuanceDate: passenger?.passportIssueDate || '',
                            BirthCountryCode: countryISOCode?.toUpperCase() || '',
                            NationalityCountryCode: countryISOCode?.toUpperCase() || '',
                            IssuanceCountryCode: countryISOCode?.toUpperCase() || ''
                        },
                        PassengerDiscountAmount: passenger?.passengerDiscountAmount,
                        PassengerServiceChargeAmount: passenger?.passengerServiceChargeAmount,
                        Contact: {
                            Email: formik.values.email,
                            Phone: {
                                CountryDialingCode: formik.values.phoneCode?.value,
                                PhoneNumber: formik.values.phoneNumber,
                                Type: "Personal" // Mobile
                            },
                            Address: {
                                CountryCode: countryISOCode?.toUpperCase() || '',
                                CityCode: passenger?.selectedCountryOption?.label?.toUpperCase() || '',
                                Line1: countryISOCode?.toUpperCase() || '',
                                Line2: passenger?.selectedCountryOption?.label?.toUpperCase() || ''
                            }
                        }
                    }
                    travellerInfo.push({
                        title: getTitleFromGender(passenger?.gender),
                        firstName: passenger?.firstName?.trim() || '',
                        lastName: passenger?.lastName?.trim() || '',
                        paxType: paxType,
                        dateOfBirth: passenger?.dateOfBirth || '',
                        dob: passenger?.passportDOB || '',
                        passportNumber: passenger?.passportNumber?.trim() || '',
                        passportExpiryDate: passenger?.passportExpiryDate || '',
                        passportNationality: countryISOCode?.toUpperCase() || '',
                        passportIssueDate: passenger?.passportIssueDate || '',
                        refListNum: paxKey
                    });
                    index++;
                }
                setCookie('ndcIdentifier', flightDetails?.[0]?.totalPriceList?.[0]?.fareIdentifier)
                queryPayload = {
                    type: queryParams?.source,
                    travellerInfo: passengerData,
                    offerId: queryParams?.priceId,
                    searchQuery: searchQueryObj,
                    tripInfo: flightDetails,
                    selectedBundles: JSON.parse(sessionStorage.getItem('ndcDataBundle')) || [],
                    agentActiveCurrency,
                    flightDHTRId: ndcFlightId,
                    email: formik.values.email,
                }
            } else if (queryParams?.source === 'fly-dubai') {
                // Format passenger data for Fly Dubai hold booking
                let travellerInfo = [];
                let baggageData = [];
                let mealData = [];

                formik?.values?.passgeners?.map((passenger, index) => {
                    const paxType = passenger?.passengerType || '';
                    let refListNum = `${paxType?.charAt(0)}${index + 1}`;

                    // Format passenger basic info
                    let traveller = {
                        title: getTitleFromStoredGender(passenger?.gender),
                        firstName: passenger?.firstName?.trim() || '',
                        lastName: passenger?.lastName?.trim() || '',
                        paxType: passenger?.passengerType || '',
                        dateOfBirth: passenger?.dateOfBirth || '',
                        dob: passenger?.passportDOB || '',
                        passportNumber: passenger?.passportNumber?.trim() || '',
                        passportExpiryDate: passenger?.passportExpiryDate || '',
                        passportNationality: passenger?.selectedCountryOption?.value?.toUpperCase() || '',
                        passportIssueDate: passenger?.passportIssueDate || '',
                        refListNum: refListNum,
                        MEAL: {},
                        BAGGAGE: {}
                    };

                    if (passenger?.MEAL?.length) {
                        passenger?.MEAL?.forEach((meal) => {
                            const mealKey = meal?.pfId
                            if (mealKey) {
                                traveller.MEAL[mealKey] = {
                                    code: meal?.code || meal?.value,
                                    categoryID: meal?.categoryID || 121,
                                    cutoffHours: meal?.cutoffHours || 24,
                                    currency: meal?.currency || 'AED',
                                    description: meal?.description,
                                    amount: meal?.amount || meal?.price || 0,
                                    redeemMiles: meal?.redeemMiles || 0,
                                    ruleID: meal?.ruleID || '',
                                    ruleDesc: meal?.ruleDesc || '',
                                    maxCountFlightLevel: meal?.maxCountFlightLevel || 200,
                                    maxCountServiceLevel: meal?.maxCountServiceLevel || 200,
                                    quantity: meal?.quantity || 200,
                                    pfID: mealKey,
                                    lfID: meal?.lfID || meal?.flightId,
                                    depDate: meal?.depDate || ''
                                };
                            }
                        });
                    }

                    if (passenger?.BAGGAGE?.length) {
                        passenger?.BAGGAGE?.forEach((baggage) => {
                            const baggageKey = baggage?.lfID || baggage?.flightId;
                            if (baggageKey) {
                                traveller.BAGGAGE[baggageKey] = {
                                    code: baggage?.code || baggage?.value,
                                    categoryID: baggage?.categoryID || 99,
                                    cutoffHours: baggage?.cutoffHours || -1,
                                    currency: baggage?.currency || 'AED',
                                    description: baggage?.description,
                                    amount: baggage?.amount || baggage?.price || 0,
                                    redeemMiles: baggage?.redeemMiles || 0,
                                    ruleID: baggage?.ruleID || '',
                                    ruleDesc: baggage?.ruleDesc || '',
                                    maxCountFlightLevel: baggage?.maxCountFlightLevel || 120,
                                    maxCountServiceLevel: baggage?.maxCountServiceLevel || 120,
                                    quantity: baggage?.quantity || 120,
                                    lfID: baggage?.lfID || baggage?.flightId,
                                    depDate: baggage?.depDate || ''
                                };
                            }
                        });
                    }

                    travellerInfo.push(traveller);
                });

                queryPayload = {
                    type: 'fly-dubai',
                    token: getCookie(`dahr--fly_dubaiToken`),
                    flightDHTRId: queryParams?.flightId,
                    travellerInfo: travellerInfo,
                    finalAmount: finalAmount,
                    originalAmount: flightDataPriceObj?.originalPrice || flightDataPriceObj?.totalFare,
                    email: formik.values.email,
                    countryCode: formik.values.phoneCode?.value,
                    mobileNumber: formik.values.phoneNumber,
                    baggageData: baggageData,
                    mealData: mealData,
                    addressCountry: formik?.values?.addressCountry,
                    addressCity: formik?.values?.addressCity,
                    flyDubaiCartResponse: flyDubaiCartResponse
                };
            } else if (queryParams?.source === 'aljazeera') {
                // mapAljazeeraGenderTitle imported from utils/bookingHelpers.js
                const allPax = formik?.values?.passgeners || [];
                const infants = allPax.filter(p => p?.passengerType === 'INFANT');
                let infantIndex = 0;
                let travellerInfo = [];
                let ssrData = [];
                let seatmapdata = [];

                allPax.forEach((passenger) => {
                    if (passenger?.passengerType === 'INFANT') return;

                    // collect this passenger's selected SSRs (baggage + meal) by per-passenger ssrKey
                    (passenger?.BAGGAGE || []).forEach((b) => {
                        if (b?.ssrKey) ssrData.push({ ssrKey: b.ssrKey, count: 1, note: '' });
                    });
                    (passenger?.MEAL || []).forEach((m) => {
                        if (m?.ssrKey) ssrData.push({ ssrKey: m.ssrKey, count: 1, note: '' });
                    });
                    // Selected seats. travelerIndex is re-derived from the position in
                    // travellerInfo (infants excluded) because the server maps seats onto
                    // TripSell's passengerKeys by that same ordering — the index captured
                    // at selection time counts infants and would drift.
                    (passenger?.SEATS || []).forEach((s) => {
                        if (!s?.unitKey || !s?.vendorSegmentKey) return;
                        seatmapdata.push({
                            unitKey: s.unitKey,
                            vendorSegmentKey: s.vendorSegmentKey,
                            // Our own "DEP-ARR" route key — used server-side to build the
                            // seatInfo map saved on passenger_details.
                            segmentKey: s?.segmentKey,
                            travelerIndex: travellerInfo.length,
                            seatNumber: s?.seatNumber,
                            price: s?.price,
                            originalAmount: s?.originalAmount,
                            waiveFee: !!s?.waiveFee,
                        });
                    });

                    const { gender, title } = mapAljazeeraGenderTitle(passenger?.gender);
                    let traveller = {
                        paxType: passenger?.passengerType || '',
                        title,
                        firstName: passenger?.firstName?.trim() || '',
                        middleName: '',
                        lastName: passenger?.lastName?.trim() || '',
                        gender,
                        dob: passenger?.passportDOB || passenger?.dateOfBirth || '',
                        passportNationality: passenger?.selectedCountryOption?.value?.toUpperCase() || '',
                        passportNumber: passenger?.passportNumber?.trim() || '',
                        passportExpiryDate: passenger?.passportExpiryDate || '',
                        passportIssueDate: passenger?.passportIssueDate || '',
                    };

                    if (passenger?.passengerType === 'ADULT' && infantIndex < infants.length) {
                        const inf = infants[infantIndex];
                        const infMap = mapAljazeeraGenderTitle(inf?.gender);
                        traveller.infant = {
                            title: infMap.title,
                            firstName: inf?.firstName?.trim() || '',
                            middleName: '',
                            lastName: inf?.lastName?.trim() || '',
                            gender: infMap.gender,
                            dob: inf?.passportDOB || inf?.dateOfBirth || '',
                            passportNationality: inf?.selectedCountryOption?.value?.toUpperCase() || '',
                        };
                        infantIndex++;
                    }

                    travellerInfo.push(traveller);
                });

                queryPayload = {
                    type: 'aljazeera',
                    flightDHTRId: queryParams?.flightId,
                    details: getSessionStorage(`aljazeera-${queryParams?.priceId}`),
                    adult: allPax.filter(p => p?.passengerType === 'ADULT').length,
                    child: allPax.filter(p => p?.passengerType === 'CHILD').length,
                    infant: infants.length,
                    baseCurrency: getSessionStorage(`aljazeera-${queryParams?.priceId}`)?.baseCurrency || agentActiveCurrency,
                    travellerInfo: travellerInfo,
                    email: formik.values.email,
                    mobileNumber: `${formik.values.phoneCode?.value}-${formik.values.phoneNumber}`,
                    addressOne: formik?.values?.addressOne || '',
                    addressTwo: '',
                    addressCity: formik?.values?.addressCity || '',
                    provinceState: formik?.values?.addressState?.value || '',
                    addressCountry: formik?.values?.addressCountry?.value?.toUpperCase() || '',
                    postalCode: formik?.values?.postalCode || '',
                    seatmapdata: seatmapdata,
                    ssrData: ssrData,
                    notifyContacts: false,
                    searchQuery: searchQueryObj,
                    tripInfo: flightDetails,
                };
            }
            else {
                queryPayload = {
                    type: 'tripjack',
                    bookingId: tripJackBookingId,
                    flightDHTRId: queryParams?.flightId,
                    travellerInfo: formik?.values?.passgeners?.map((passenger) => ({
                        title: getTitleFromGenderMsFallback(passenger?.gender),
                        firstName: passenger?.firstName?.trim() || '',
                        lastName: passenger?.lastName?.trim() || '',
                        dateOfBirth: passenger?.dateOfBirth || '',
                        paxType: passenger?.passengerType || '',
                        dob: passenger?.passportDOB || '',
                        passportNumber: passenger?.passportNumber?.trim() || '',
                        passportExpiryDate: passenger?.passportExpiryDate || '',
                        passportNationality: passenger?.selectedCountryOption?.value?.toUpperCase() || '',
                        passportIssueDate: passenger?.passportIssueDate || '',
                        ssrBaggageInfos: passenger?.['BAGGAGE'] && passenger?.['BAGGAGE']?.length ? passenger?.['BAGGAGE']?.map((baggageData) => ({
                            code: baggageData?.value,
                            key: baggageData?.flightId
                        })) : [],
                        ssrMealInfos: passenger?.['MEAL'] && passenger?.['MEAL']?.length ? passenger?.['MEAL']?.map((mealData) => ({
                            code: mealData?.value,
                            key: mealData?.flightId
                        })) : []
                    })) || [],
                    deliveryInfo: {
                        emails: [
                            formik.values.email
                        ],
                        contacts: [
                            contactNumber
                        ]
                    },
                    activeCurrency: agentActiveCurrency,
                }
            }

            if (showDiscounts) {
                queryPayload.couponCodeData = activeCouponCodeData
            }
            if (formik.values.bookingReferenceNote) {
                queryPayload.bookingReferenceNote = formik.values.bookingReferenceNote;
            }
            const flightHoldBooking = await ApiCall('POST', `/flights/flight-hold-booking`, { ...queryPayload, activeCurrency: "AED", agentActiveCurrency: "AED", display_currency: bookingOtherData?.currency || agentActiveCurrency }, { authorization: userToken });
            if (flightHoldBooking?.status === 200 && flightHoldBooking?.data?.statusCode === 200 && flightHoldBooking?.data?.data?.bookingId) {
                // console.log(flightHoldBooking?.data, 'flightHoldBooking?.data?.data?.bookingId')
                let bookingId = flightHoldBooking?.data?.data?.bookingId;
                let aljazeeraHoldFee = parseFloat(flightHoldBooking?.data?.data?.amountPaid) || 0;
                if (queryParams?.source === 'aljazeera' && aljazeeraHoldFee > 0) {
                    let nonceToken = await generateNonceForTranscationFn('wallet', 'debit');

                    const payload = {
                        userToken: userToken,
                        activeUserCurrency: agentActiveCurrency,
                        display_currency: getActiveCode(),
                        conversion_rate: getActiveRate(),
                        transaction_type: "debit",
                        payment_mode: "wallet",
                        nonce: nonceToken,
                        amount: aljazeeraHoldFee,
                        transaction_comment: `Debited Towards : Flight Hold Fee (${bookingId})`
                    }

                    await ApiCall('POST', `wp-json/dahr/v1/wallet-transaction`, payload, {}, 'wordpress');

                    // Generate the hold invoice on the WordPress side.
                    ApiCall('POST', `wp-json/dahr/v1/create-flight-hold-invoice`, {
                        bookingReference: bookingId,
                        holdPrice: aljazeeraHoldFee,
                        holdCost: aljazeeraHoldFee,
                        vendorName: "aljazeera",
                        paymentMode: "WALLET"
                    }, {}, 'wordpress').catch(() => { });
                }
                setHoldButtonLoader(false);
                setOnLoadLoader(false);
                navigate(`/flight/booking?bookingId=${bookingId}&source=${toUrlSource(queryParams?.source)}&status=HOLD`);
            } else {
                let errorData = flightHoldBooking?.data?.data?.errors || flightHoldBooking?.data?.data?.[0]?.message;
                setCheckboxAndWalletError(errorData || 'Something went wrong!');
                setHoldButtonLoader(false);
                setOnLoadLoader(false);
            }
        } else {
            setPayNowBtnLoader(true);
            setOnLoadLoader(false);
            let totalPrice = showDiscounts ? parseFloat(finalAmount) : (parseFloat(finalAmount) + parseFloat(extraChargePrice?.total || 0) + parseFloat(extraChargePrice?.seat || 0));
            if (checkPriceBeforeBooking?.showForm) {
                totalPrice = checkPriceBeforeBooking?.amount?.originalAmount
            }
            let originalAirArabiaAmount = checkPriceBeforeBooking?.showForm ? checkPriceBeforeBooking?.amount?.totalAmount : flightDataPriceObj?.originalPrice;
            let extraService = checkPriceBeforeBooking?.showForm ? checkPriceBeforeBooking?.extraService : flightDataPriceObj?.originalPrice
            if (queryParams?.source === 'air-arabia' && checkBooking) {
                let baggageData = [];
                let mealData = [];
                let travellerInfo = []
                let seatmapdata = []
                const adultRefs = [];
                formik?.values?.passgeners?.map((passenger, index) => {
                    const paxType = passenger?.passengerType || '';
                    let refListNum = `${paxType?.charAt(0)}${index + 1}`;

                    if (paxType === 'ADULT') {
                        adultRefs.push(refListNum);
                    }

                    if (passenger?.passengerType === 'INFANT') {
                        const adultIndex = adultRefs[travellerInfo.length % adultRefs.length] || adultRefs[0] || 'A1';
                        refListNum = `${paxType.charAt(0)}${index + 1}/${adultIndex}`;
                    }
                    if (passenger?.BAGGAGE?.length) {
                        passenger?.BAGGAGE?.map((baggage) => {
                            baggageData.push({
                                ...baggage,
                                refListNum
                            })
                        })
                    }
                    if (passenger?.MEAL?.length) {
                        passenger?.MEAL?.map((meal) => {
                            mealData.push({
                                ...meal,
                                refListNum
                            })
                        })
                    }
                    if (passenger?.SEATS?.length) {
                        passenger?.SEATS?.map((seat) => {
                            seatmapdata.push({
                                seatnumber: seat?.seatNumber,
                                rphCode: seat?.rphCode,
                                travelerRef: seat?.travelerRef,
                                price: parseFloat(seat?.price) || 0,
                                originalAmount: parseFloat(seat?.originalAmount) || 0,
                            })
                        })
                    }
                    travellerInfo.push({
                        title: getTitleFromGenderLower(passenger?.gender),
                        firstName: passenger?.firstName?.trim() || '',
                        lastName: passenger?.lastName?.trim() || '',
                        paxType: passenger?.passengerType || '',
                        dateOfBirth: passenger?.dateOfBirth || '',
                        dob: passenger?.passportDOB || '',
                        passportNumber: passenger?.passportNumber?.trim() || '',
                        passportExpiryDate: passenger?.passportExpiryDate || '',
                        passportNationality: passenger?.selectedCountryOption?.value?.toUpperCase() || '',
                        passportIssueDate: passenger?.passportIssueDate || '',
                        refListNum: refListNum
                    })
                })

                let finalSendAmount = totalPrice;
                let onlineServiceFeeAmount = 0;
                if (selectPaymentMethod === 1) {
                    onlineServiceFeeAmount = ((finalSendAmount * onineServicesFees) / 100)
                    finalSendAmount += onlineServiceFeeAmount;
                }

                let queryPayload = {
                    type: 'air-arabia',
                    travellerInfo: travellerInfo,
                    activeCouponCodeData,
                    searchQuery: searchQueryObj,
                    tripInfo: flightDetails,
                    finalAmount: finalSendAmount,
                    originalAmount: flightDataPriceObj?.originalPrice,
                    email: formik.values.email,
                    countryCode: formik.values.phoneCode?.value,
                    mobileNumber: formik.values.phoneNumber,
                    information: airArabiaFlightData,
                    baggageData: baggageData,
                    mealData: mealData,
                    seatmapdata: seatmapdata,
                    addressCountry: formik?.values?.addressCountry,
                    addressCity: formik?.values?.addressCity,
                    bundleSelection: airArabiaBundle,
                    selectPaymentMethod,
                    onineServicesFees
                }
                const flightCheckBooking = await ApiCall('POST', `/flights/check-price-before-booking`, queryPayload, { authorization: userToken });
                if (flightCheckBooking?.status === 200 && flightCheckBooking?.data?.statusCode === 200 && !flightCheckBooking?.data?.data?.errors && !flightCheckBooking?.data?.data?.checked) {
                    if (flightCheckBooking?.data?.data?.showForm) {
                        setCheckPriceBeforeBooking(flightCheckBooking?.data?.data);
                        setPayNowBtnLoader(false);
                        setOnLoadLoader(false);
                        return false;
                    } else {
                        originalAirArabiaAmount = flightCheckBooking?.data?.data?.amount?.totalAmount;
                        extraService = flightCheckBooking?.data?.data?.amount?.extraService
                    }
                } else {
                    // Stop on ANY error: an HTTP 200 carrying an `errors` body must not fall
                    // through to the wallet debit below.
                    if (flightCheckBooking?.data?.data?.errors || flightCheckBooking?.data?.statusCode !== 200 || flightCheckBooking?.status !== 200) {
                        let errorData = flightCheckBooking?.data?.data?.errors || flightCheckBooking?.data?.message;
                        setCheckboxAndWalletError(errorData || 'Something went wrong!');
                        setPayNowBtnLoader(false);
                        setOnLoadLoader(false);
                        setCheckPriceBeforeBooking({})
                        return false;
                    }
                }
            }

            if (queryParams?.source === 'amadeus' && checkBooking) {
                setPayNowBtnLoader(true);
                let amadeusFlightData = flightDetails?.[0];
                let contactNumber = `${formik.values.phoneCode?.value}${formik.values.phoneNumber}`;
                let travellerInfo = formik?.values?.passgeners?.map((passenger) => ({
                    title: getTitleFromGenderLower(passenger?.gender),
                    firstName: passenger?.firstName?.trim() || '',
                    lastName: passenger?.lastName?.trim() || '',
                    paxType: passenger?.passengerType || '',
                    dateOfBirth: passenger?.dateOfBirth || '',
                    dob: passenger?.passportDOB || '',
                    gender: getGenderFromTitle(passenger?.gender),
                    passportNumber: passenger?.passportNumber?.trim() || '',
                    passportExpiryDate: passenger?.passportExpiryDate || '',
                    passportNationality: passenger?.selectedCountryOption?.value?.toUpperCase() || '',
                    passportIssueDate: passenger?.passportIssueDate || '',
                    documentId: ""
                })) || [];

                let queryPayload = {
                    type: 'amadeus',
                    sessionId: amadeusFlightData?.sessionId,
                    tokenId: amadeusFlightData?.tokenId,
                    sessionType: amadeusFlightData?.sessionType,
                    fareKey: amadeusFlightData?.fareKey,
                    travellerInfo: travellerInfo,
                    activeCouponCodeData,
                    searchQuery: searchQueryObj,
                    tripInfo: flightDetails,
                    finalAmount: totalPrice,
                    originalAmount: flightDataPriceObj?.originalAmount,
                    email: formik.values.email,
                    countryCode: formik.values.phoneCode?.value,
                    mobileNumber: formik.values.phoneNumber,
                    deliveryInfo: {
                        address: "",
                        email: formik.values.email,
                        contactNumber: contactNumber
                    },
                    selectPaymentMethod,
                    onineServicesFees
                };

                const flightCheckBooking = await ApiCall('POST', `/flights/check-price-before-booking`, queryPayload, { authorization: userToken });
                const amadeusCheckData = flightCheckBooking?.data?.data;

                // Fare no longer available -> tell the user and send them back to the results.
                // Checked BEFORE the generic error guard: the sold-out payload also carries
                // `errors`, so testing that first would swallow the redirect.
                if (amadeusCheckData?.soldOut) {
                    setCheckboxAndWalletError(amadeusCheckData?.errors || 'This fare is no longer available. Please search again and select another flight.');
                    setPayNowBtnLoader(false);
                    setOnLoadLoader(false);
                    setCheckPriceBeforeBooking({});
                    amadeusReconfirmRef.current = {};
                    setTimeout(() => {
                        const getlastQueryParamsFlightData = getCookie('lastQueryParamsFlight');
                        navigate(`/flight/list${getlastQueryParamsFlightData}`, { state: new Date().getTime() });
                    }, 2500);
                    return false;
                }

                const amadeusCheckOk = flightCheckBooking?.status === 200
                    && flightCheckBooking?.data?.statusCode === 200
                    && !amadeusCheckData?.errors;

                if (!amadeusCheckOk) {
                    // Any error at all stops the booking — never fall through to a wallet debit.
                    setCheckboxAndWalletError(amadeusCheckData?.errors || flightCheckBooking?.data?.message || 'Something went wrong!');
                    setPayNowBtnLoader(false);
                    setOnLoadLoader(false);
                    setCheckPriceBeforeBooking({});
                    amadeusReconfirmRef.current = {};
                    return false;
                }

                // Carry the created + reconfirmed order ids so booking only ISSUES (no second create-order).
                amadeusReconfirmRef.current = {
                    bookingId: amadeusCheckData?.amadeusBookingId,
                    sessionId: amadeusCheckData?.amadeusSessionId
                };

                if (amadeusCheckData?.showForm) {
                    // Price changed -> show the "Price Updated" popup and stop; the order is
                    // already created and reconfirmed at the new fare, so confirming from the
                    // popup only has to issue it.
                    setCheckPriceBeforeBooking(amadeusCheckData);
                    setPayNowBtnLoader(false);
                    setOnLoadLoader(false);
                    return false;
                }
            }

            totalPrice = parseFloat(totalPrice) || 0;
            if (selectPaymentMethod === 1) {
                setPayNowBtnLoader(false);
                setOnLoadLoader(false);
                setStripeModalShow(true);
                if (checkPriceBeforeBooking?.amount) {
                    setCheckPriceBeforeBooking((prev) => ({
                        ...prev,
                        showForm: false,
                        onlineForm: true
                    }));
                }
            } else {
                setPayNowBtnLoader(true);
                setOnLoadLoader(false);
                const walletBalanceData = await GetApiCall('GET', `wp-json/dahr/v1/user-wallet-balance?userToken=${userToken}&activeUserCurrency=${agentActiveCurrency}`, {}, 'wordpress');
                if (walletBalanceData?.status === 200) {
                    let walletBalance = walletBalanceData?.data?.wallet_balance;
                    if (parseFloat(walletBalance) >= parseFloat(totalPrice)) {
                        let nonceToken = await generateNonceForTranscationFn('wallet', 'debit');
                        const deductBalanceFromWallet = await ApiCall('POST', `wp-json/dahr/v1/wallet-transaction`, {
                            userToken: userToken,
                            activeUserCurrency: agentActiveCurrency,
                            display_currency: getActiveCode(),
                            conversion_rate: getActiveRate(),
                            transaction_type: "debit",
                            payment_mode: "wallet",
                            nonce: nonceToken,
                            amount: totalPrice,
                            transaction_comment: `Debited Towards : Flight Booking`
                        }, {}, 'wordpress');
                        if ((deductBalanceFromWallet?.status === 200 && deductBalanceFromWallet?.data?.success && deductBalanceFromWallet?.data?.transaction_id) || (activeCouponCodeData?.discount_value && totalPrice === 0)) {
                            let queryPayload = {};
                            // console.log('queryPayload: ', queryPayload);
                            let flightData = flightDetails?.[0];
                            let contactNumber = `${formik.values.phoneCode?.value}${formik.values.phoneNumber}`
                            if (queryParams?.source === 'amadeus') {
                                queryPayload = {
                                    type: "amadeus",
                                    // Order already created + reconfirmed in check-price-before-booking -> issue only
                                    amadeusBookingId: amadeusReconfirmRef.current?.bookingId,
                                    amadeusSessionId: amadeusReconfirmRef.current?.sessionId,
                                    sessionId: flightData?.sessionId,
                                    tokenId: flightData?.tokenId,
                                    sessionType: flightData?.sessionType,
                                    fareKey: flightData?.fareKey,
                                    travellerInfo: formik?.values?.passgeners?.map((passenger) => ({
                                        title: getTitleFromGenderLower(passenger?.gender),
                                        firstName: passenger?.firstName?.trim() || '',
                                        lastName: passenger?.lastName?.trim() || '',
                                        paxType: passenger?.passengerType || '',
                                        dateOfBirth: passenger?.dateOfBirth || '',
                                        dob: passenger?.passportDOB || '',
                                        gender: getGenderFromTitle(passenger?.gender),
                                        passportNumber: passenger?.passportNumber?.trim() || '',
                                        passportExpiryDate: passenger?.passportExpiryDate || '',
                                        passportNationality: passenger?.selectedCountryOption?.value?.toUpperCase() || '',
                                        passportIssueDate: passenger?.passportIssueDate || '',
                                        documentId: ""
                                    })) || [],
                                    deliveryInfo: {
                                        address: "",
                                        email: formik.values.email,
                                        contactNumber: contactNumber
                                    },
                                    originalAmount : flightDataPriceObj?.originalAmount,
                                }
                            } else if (queryParams?.source === 'air-arabia') {
                                let baggageData = [];
                                let mealData = [];
                                let travellerInfo = []
                                let seatmapdata = []
                                const adultRefs = [];
                                formik?.values?.passgeners?.map((passenger, index) => {
                                    const paxType = passenger?.passengerType || '';
                                    let refListNum = `${paxType?.charAt(0)}${index + 1}`;

                                    if (paxType === 'ADULT') {
                                        adultRefs.push(refListNum);
                                    }

                                    if (passenger?.passengerType === 'INFANT') {
                                        const adultIndex = adultRefs[travellerInfo.length % adultRefs.length] || adultRefs[0] || 'A1';
                                        refListNum = `${paxType.charAt(0)}${index + 1}/${adultIndex}`;
                                    }
                                    if (passenger?.BAGGAGE?.length) {
                                        passenger?.BAGGAGE?.map((baggage) => {
                                            baggageData.push({
                                                ...baggage,
                                                refListNum
                                            })
                                        })
                                    }
                                    if (passenger?.MEAL?.length) {
                                        passenger?.MEAL?.map((meal) => {
                                            mealData.push({
                                                ...meal,
                                                refListNum
                                            })
                                        })
                                    }
                                    if (passenger?.SEATS?.length) {
                                        passenger?.SEATS?.map((seat) => {
                                            seatmapdata.push({
                                                seatnumber: seat?.seatNumber,
                                                rphCode: seat?.rphCode,
                                                travelerRef: seat?.travelerRef,
                                                price: parseFloat(seat?.price) || 0,
                                                originalAmount: parseFloat(seat?.originalAmount) || 0,
                                            })
                                        })
                                    }
                                    travellerInfo.push({
                                        title: getTitleFromGender(passenger?.gender),
                                        firstName: passenger?.firstName?.trim() || '',
                                        lastName: passenger?.lastName?.trim() || '',
                                        paxType: passenger?.passengerType || '',
                                        dateOfBirth: passenger?.dateOfBirth || '',
                                        dob: passenger?.passportDOB || '',
                                        passportNumber: passenger?.passportNumber?.trim() || '',
                                        passportExpiryDate: passenger?.passportExpiryDate || '',
                                        passportNationality: passenger?.selectedCountryOption?.value?.toUpperCase() || '',
                                        passportIssueDate: passenger?.passportIssueDate || '',
                                        refListNum: refListNum
                                    })
                                })
                                queryPayload = {
                                    type: 'air-arabia',
                                    travellerInfo: travellerInfo,
                                    searchQuery: searchQueryObj,
                                    tripInfo: flightDetails,
                                    finalAmount: totalPrice,
                                    extraService: extraService,
                                    originalAmount: originalAirArabiaAmount,
                                    email: formik.values.email,
                                    countryCode: formik.values.phoneCode?.value,
                                    mobileNumber: formik.values.phoneNumber,
                                    information: airArabiaFlightData,
                                    baggageData: baggageData,
                                    mealData: mealData,
                                    seatmapdata: seatmapdata,
                                    addressCountry: formik?.values?.addressCountry,
                                    addressCity: formik?.values?.addressCity,
                                    bundleSelection: airArabiaBundle
                                }
                            } else if (queryParams?.source === 'akasa-air') {
                                let baggageMealData = [];
                                let travellerInfo = []
                                let infants = formik?.values?.passgeners.filter(p => p?.passengerType === "INFANT");
                                let infantIndex = 0;
                                formik?.values?.passgeners?.map((passenger, index) => {
                                    if (passenger?.passengerType === "INFANT") return;


                                    if (passenger?.BAGGAGE?.length) {
                                        passenger?.BAGGAGE?.map((baggage) => {
                                            baggageMealData.push(baggage)
                                        })
                                    }
                                    if (passenger?.MEAL?.length) {
                                        passenger?.MEAL?.map((meal) => {
                                            baggageMealData.push(meal)
                                        })
                                    }

                                    const { gender, title } = getGenderTitleUppercase(passenger?.gender);


                                    let traveller = {
                                        keys: passenger?.keys,
                                        title: title,
                                        gender: gender,
                                        firstName: passenger?.firstName?.trim() || '',
                                        lastName: passenger?.lastName?.trim() || '',
                                        paxType: passenger?.passengerType || '',
                                        dateOfBirth: passenger?.dateOfBirth || '',
                                        dob: passenger?.passportDOB || '',
                                        passportNumber: passenger?.passportNumber?.trim() || '',
                                        passportExpiryDate: passenger?.passportExpiryDate || '',
                                        passportNationality: passenger?.selectedCountryOption?.value?.toUpperCase() || '',
                                        passportIssueDate: passenger?.passportIssueDate || '',
                                    }

                                    if (passenger?.passengerType === "ADULT" && infantIndex < infants.length) {
                                        const { gender: infantGender, title: infantTitle } = getGenderTitleUppercase(infants[infantIndex]?.gender);

                                        traveller.infant = {
                                            keys: infants[infantIndex]?.keys,
                                            title: infantTitle,
                                            gender: infantGender,
                                            firstName: infants[infantIndex]?.firstName?.trim() || '',
                                            lastName: infants[infantIndex]?.lastName?.trim() || '',
                                            paxType: infants[infantIndex]?.passengerType || '',
                                            dateOfBirth: infants[infantIndex]?.dateOfBirth || '',
                                            dob: infants[infantIndex]?.passportDOB || '',
                                            passportNumber: infants[infantIndex]?.passportNumber?.trim() || '',
                                            passportExpiryDate: infants[infantIndex]?.passportExpiryDate || '',
                                            passportNationality: infants[infantIndex]?.selectedCountryOption?.value?.toUpperCase() || '',
                                            passportIssueDate: infants[infantIndex]?.passportIssueDate || '',
                                        };
                                        infantIndex++;
                                    }
                                    travellerInfo.push(traveller)
                                })
                                queryPayload = {
                                    type: 'akasa-air',
                                    travellerInfo: travellerInfo,
                                    searchQuery: searchQueryObj,
                                    tripInfo: flightDetails,
                                    flightDHTRId: queryParams?.flightId,
                                    finalAmount: totalPrice,
                                    originalAmount: flightDataPriceObj?.originalPrice,
                                    email: formik.values.email,
                                    countryCode: formik.values.phoneCode?.value,
                                    mobileNumber: formik.values.phoneNumber,
                                    baggageMealData: baggageMealData,
                                    addressCountry: formik?.values?.addressCountry?.value?.toUpperCase(),
                                    addressOne: formik?.values?.addressOne,
                                    provinceState: formik?.values?.addressState?.value,
                                    postalCode: formik?.values?.postalCode,
                                    addressCity: formik?.values?.addressCity,
                                    akasaAirToken: akasaAirToken
                                }
                            } else if (queryParams?.source === 'travel-fusion') {
                                const lastFlight = flightDetails?.[flightDetails.length - 1];
                                const lastSegment = lastFlight?.segments?.[lastFlight.segments.length - 1];
                                const returnDate = lastSegment?.arrival?.time;
                                queryPayload = {
                                    type: queryParams?.source,
                                    routingId: travelFusionRoutingId,
                                    flightDHTRId: queryParams?.flightId,
                                    singleTrip: flightDetails?.length === 1,
                                    singleTripData: {
                                        cabinBaggage: flightDetails?.[0]?.totalPriceList?.[0]?.fareDetails?.[0]?.baggageInfo?.cabinBaggage ? flightDetails?.[0]?.totalPriceList?.[0]?.fareDetails?.[0]?.baggageInfo?.cabinBaggage : 'N/A',
                                        checkinBaggageData: flightDetails?.[0]?.segments?.[0]?.specialServices?.['BAGGAGE'] ? flightDetails?.[0]?.segments?.[0]?.specialServices?.['BAGGAGE'] : []
                                    },
                                    roundTripData: {
                                        cabinBaggage: flightDetails?.[1]?.totalPriceList?.[0]?.fareDetails?.[0]?.baggageInfo?.cabinBaggage ? flightDetails?.[1]?.totalPriceList?.[0]?.fareDetails?.[0]?.baggageInfo?.cabinBaggage : 'N/A',
                                        checkinBaggageData: flightDetails?.[1]?.segments?.[0]?.specialServices?.['BAGGAGE'] ? flightDetails?.[1]?.segments?.[0]?.specialServices?.['BAGGAGE'] : []
                                    },
                                    travellerInfo: formik?.values?.passgeners?.map((passenger) => {
                                        let baggageData = [];
                                        let mealData = []
                                        if (passenger?.BAGGAGE?.length) {
                                            passenger?.BAGGAGE?.map((baggage) => {
                                                baggageData.push(baggage)
                                            })
                                        }
                                        if (passenger?.MEAL?.length) {
                                            passenger?.MEAL?.map((meal) => {
                                                mealData.push(meal)
                                            })
                                        }
                                        let seatData = [];
                                        if (passenger?.SEAT?.length) {
                                            passenger?.SEAT?.map((seat) => {
                                                seatData.push(seat)
                                            })
                                        }
                                        let countryISOCode = countryCommonFn(passenger?.selectedCountryOption?.value);
                                        return {
                                            title: getSimpleTitle(passenger?.gender),
                                            firstName: passenger?.firstName?.trim() || '',
                                            lastName: passenger?.lastName?.trim() || '',
                                            paxType: passenger?.passengerType || '',
                                            dateOfBirth: passenger?.dateOfBirth || '',
                                            dob: passenger?.passportDOB || '',
                                            gender: getGenderFromTitle(passenger?.gender),
                                            passportNumber: passenger?.passportNumber?.trim() || '',
                                            passportExpiryDate: passenger?.passportExpiryDate || '',
                                            passportNationality: countryISOCode?.toUpperCase() || '',
                                            passportIssueDate: passenger?.passportIssueDate || '',
                                            documentId: "",
                                            baggage: baggageData,
                                            meal: mealData,
                                            seat: seatData
                                        }
                                    }) || [],
                                    deliveryInfo: {
                                        address: "",
                                        email: formik.values.email,
                                        contactNumber: contactNumber
                                    },
                                    usePreRegisteredSupplier: usePreRegisteredSupplier,
                                    requiredParameters: travelfusionparameters,
                                    routingIds: {
                                        outwardId: queryParams?.outwardId,
                                        returnId: queryParams?.returnId
                                    },
                                    returnDate,
                                }
                            } else if (queryParams?.source === 'ndc-portal') {
                                let passengerData = {}
                                let adulRefs = []
                                let index = 0
                                let travellerInfo = [];
                                for (let passenger of formik?.values?.passgeners) {
                                    // console.log("adulRefs : ", adulRefs)
                                    const paxType = passenger?.passengerType || '';
                                    let paxKey = `Pax${index + 1}`
                                    if (passenger?.passengerType === 'ADULT') {
                                        adulRefs.push(paxKey)
                                    }
                                    let parentRef = null;
                                    if (paxType === 'INFANT') {
                                        parentRef = adulRefs[travellerInfo.length % adulRefs.length] || adulRefs[0] || 'Pax1';
                                    }

                                    let countryISOCode = passenger?.selectedCountryOption?.value;
                                    if (countryISOCode === 'uk') {
                                        countryISOCode = 'gb';
                                    } else if (countryISOCode === 'uae') {
                                        countryISOCode = 'ae';
                                    }

                                    passengerData[paxKey] = {
                                        PassengerTypeCode: passenger?.passengerType === 'ADULT' ? 'ADT' : passenger?.passengerType === 'CHILD' ? 'CHD' : 'INF',
                                        title: getTitleFromGender(passenger?.gender),
                                        gender: getGenderFromTitle(passenger?.gender),
                                        Name: {
                                            First: passenger?.firstName?.trim() || '',
                                            Middle: "",
                                            Last: passenger?.lastName?.trim() || ''
                                        },
                                        BirthDate: passenger?.passportDOB || '',
                                        NationalityCountryCode: countryISOCode?.toUpperCase() || '',
                                        ResidenceCountryCode: countryISOCode?.toUpperCase() || '',
                                        ParentPassengerReferenceId: parentRef,
                                        TravelDocument: {
                                            DocumentNumber: passenger?.passportNumber?.trim() || '',
                                            DocumentType: "Passport",
                                            Name: {
                                                First: passenger?.firstName?.trim() || '',
                                                Middle: "",
                                                Last: passenger?.lastName?.trim() || ''
                                            },
                                            Gender: getGenderFromTitle(passenger?.gender),
                                            BirthDate: passenger?.passportDOB || '',
                                            ExpirationDate: passenger?.passportExpiryDate || '',
                                            IssuanceDate: passenger?.passportIssueDate || '',
                                            BirthCountryCode: countryISOCode?.toUpperCase() || '',
                                            NationalityCountryCode: countryISOCode?.toUpperCase() || '',
                                            IssuanceCountryCode: countryISOCode?.toUpperCase() || ''
                                        },
                                        PassengerDiscountAmount: passenger?.passengerDiscountAmount,
                                        PassengerServiceChargeAmount: passenger?.passengerServiceChargeAmount,
                                        Contact: {
                                            Email: formik.values.email,
                                            Phone: {
                                                CountryDialingCode: formik.values.phoneCode?.value,
                                                PhoneNumber: formik.values.phoneNumber,
                                                Type: "Personal" // Mobile
                                            },
                                            Address: {
                                                CountryCode: countryISOCode?.toUpperCase() || '',
                                                CityCode: passenger?.selectedCountryOption?.label?.toUpperCase() || '',
                                                Line1: countryISOCode?.toUpperCase() || '',
                                                Line2: passenger?.selectedCountryOption?.label?.toUpperCase() || ''
                                            }
                                        }
                                    }
                                    travellerInfo.push({
                                        title: getTitleFromStoredGender(passenger?.gender),
                                        firstName: passenger?.firstName?.trim() || '',
                                        lastName: passenger?.lastName?.trim() || '',
                                        paxType: paxType,
                                        dateOfBirth: passenger?.dateOfBirth || '',
                                        dob: passenger?.passportDOB || '',
                                        passportNumber: passenger?.passportNumber?.trim() || '',
                                        passportExpiryDate: passenger?.passportExpiryDate || '',
                                        passportNationality: countryISOCode?.toUpperCase() || '',
                                        passportIssueDate: passenger?.passportIssueDate || '',
                                        refListNum: paxKey
                                    });
                                    index++;
                                }
                                // console.log("Payload : ", passengerData)
                                setCookie('ndcIdentifier', flightDetails?.[0]?.totalPriceList?.[0]?.fareIdentifier)
                                queryPayload = {
                                    type: queryParams?.source,
                                    travellerInfo: passengerData,
                                    offerId: queryParams?.priceId,
                                    selectedBundles: JSON.parse(sessionStorage.getItem('ndcDataBundle')) || [],
                                    tripIdentifier: flightDetails?.[0]?.totalPriceList?.[0]?.fareIdentifier,
                                    flightDHTRId: ndcFlightId,
                                    email: formik.values.email,
                                    originalAmount : flightDataPriceObj?.originalAmount,
                                }
                            } else if (queryParams?.source === 'verteil') {
                                let payloadParam = { ...orderCreateRq };
                                let originalData = payloadParam?.Query?.Passengers?.Passenger;
                                let formikData = formik?.values?.passgeners;
                                const categorizedFormik = {
                                    ADULT: [],
                                    CHILD: [],
                                    INFANT: [],
                                };
                                formikData.forEach(p => {
                                    categorizedFormik[p?.passengerType].push(p);
                                });
                                const adultOriginalPassengers = originalData.filter(p => p?.PTC?.value === 'ADT');
                                let adultIndexForInfant = 0;
                                payloadParam.Query.Passengers.Passenger = originalData.map((original, index) => {
                                    const passengerType = original.PTC.value === 'ADT' ? 'ADULT'
                                        : original.PTC.value === 'CHD' ? 'CHILD'
                                            : 'INFANT';

                                    const matchingFormik = categorizedFormik?.[passengerType]?.shift();

                                    if (!matchingFormik) return original;
                                    const titleName = getNdcTitle(matchingFormik?.gender, original.PTC.value === 'ADT');
                                    const updated = {
                                        ...original,
                                        Name: {
                                            Title: titleName,
                                            Surname: { value: matchingFormik?.lastName },
                                            Given: [{ value: matchingFormik?.firstName }],
                                        },
                                        Age: {

                                            BirthDate: { value: formatDateToDDMMYYYY(matchingFormik?.passportDOB) },
                                        },
                                        Gender: { value: getGenderFromTitle(matchingFormik?.gender) },
                                        PassengerIDInfo: {
                                            AllowDocumentInd: 'true',
                                            PassengerDocument: [
                                                {
                                                    Type: 'PT',
                                                    ID: matchingFormik?.passportNumber,
                                                    DateOfIssue: formatDateToDDMMYYYY(matchingFormik?.passportIssueDate),
                                                    DateOfExpiration: formatDateToDDMMYYYY(matchingFormik?.passportExpiryDate),
                                                    CountryOfIssuance: matchingFormik?.selectedCountryOption?.value?.toUpperCase(),
                                                    CountryOfResidence: matchingFormik?.selectedCountryOption?.value?.toUpperCase(),
                                                },
                                            ],
                                        },
                                    };

                                    if (passengerType === 'ADULT' && index === 0) {
                                        updated.Contacts = {
                                            Contact: [
                                                {
                                                    AddressContact: {
                                                        Street: [formik?.values?.addressOne],
                                                        CityName: formik?.values?.addressCity,
                                                        PostalCode: formik?.values?.postalCode,
                                                        CountryCode: { value: formik?.values?.addressCountry?.value?.toUpperCase() },
                                                    },
                                                    EmailContact: {
                                                        Address: { value: formik.values.email },
                                                    },
                                                    PhoneContact: {
                                                        Application: 'Home',
                                                        Number: [
                                                            {
                                                                value: formik?.values?.phoneNumber,
                                                                CountryCode: formik.values.phoneCode?.value?.replace("+", ""),
                                                            },
                                                        ],
                                                    },
                                                },
                                            ],
                                        };
                                    }

                                    // Associate INFANT with next available ADULT ObjectKey
                                    if (passengerType === 'INFANT' && adultOriginalPassengers[adultIndexForInfant]) {
                                        updated.PassengerAssociation = adultOriginalPassengers[adultIndexForInfant].ObjectKey;
                                        adultIndexForInfant = (adultIndexForInfant + 1) % adultOriginalPassengers.length;
                                    }

                                    return updated;
                                });
                                queryPayload = {
                                    session: payloadParam,
                                    originalAmount : flightDataPriceObj?.netFare,
                                    type: queryParams?.source,
                                    flightDHTRId: queryParams?.flightId,
                                }
                            } else if (queryParams?.source === 'fly-dubai') {
                                // Format passenger data for Fly Dubai booking
                                let travellerInfo = [];
                                let baggageData = [];
                                let mealData = [];

                                formik?.values?.passgeners?.map((passenger, index) => {
                                    const paxType = passenger?.passengerType || '';
                                    let refListNum = `${paxType?.charAt(0)}${index + 1}`;

                                    // Format passenger basic info
                                    let traveller = {
                                        title: getTitleFromGender(passenger?.gender),
                                        firstName: passenger?.firstName?.trim() || '',
                                        lastName: passenger?.lastName?.trim() || '',
                                        paxType: passenger?.passengerType || '',
                                        dateOfBirth: passenger?.dateOfBirth || '',
                                        dob: passenger?.passportDOB || '',
                                        passportNumber: passenger?.passportNumber?.trim() || '',
                                        passportExpiryDate: passenger?.passportExpiryDate || '',
                                        passportNationality: passenger?.selectedCountryOption?.value?.toUpperCase() || '',
                                        passportIssueDate: passenger?.passportIssueDate || '',
                                        refListNum: refListNum,
                                        MEAL: {},
                                        BAGGAGE: {}
                                    };
                                    // Process meal selections
                                    if (passenger?.MEAL?.length) {
                                        passenger?.MEAL?.forEach((meal) => {
                                            const mealKey = meal?.pfId;
                                            if (mealKey) {
                                                traveller.MEAL[mealKey] = {
                                                    code: meal?.code || meal?.value,
                                                    categoryID: meal?.categoryID || 121,
                                                    cutoffHours: meal?.cutoffHours || 24,
                                                    currency: meal?.currency || 'AED',
                                                    description: meal?.description,
                                                    amount: meal?.amount || meal?.price || 0,
                                                    redeemMiles: meal?.redeemMiles || 0,
                                                    ruleID: meal?.ruleID || '',
                                                    ruleDesc: meal?.ruleDesc || '',
                                                    maxCountFlightLevel: meal?.maxCountFlightLevel || 200,
                                                    maxCountServiceLevel: meal?.maxCountServiceLevel || 200,
                                                    quantity: meal?.quantity || 200,
                                                    pfID: mealKey,
                                                    lfID: meal?.lfID || meal?.flightId,
                                                    depDate: meal?.depDate || ''
                                                };
                                            }
                                        });
                                    }

                                    // Process baggage selections
                                    if (passenger?.BAGGAGE?.length) {
                                        passenger?.BAGGAGE?.forEach((baggage) => {
                                            const baggageKey = baggage?.lfID || baggage?.flightId;
                                            if (baggageKey) {
                                                traveller.BAGGAGE[baggageKey] = {
                                                    code: baggage?.code || baggage?.value,
                                                    categoryID: baggage?.categoryID || 99,
                                                    cutoffHours: baggage?.cutoffHours || -1,
                                                    currency: baggage?.currency || 'AED',
                                                    description: baggage?.description,
                                                    amount: baggage?.amount || baggage?.price || 0,
                                                    redeemMiles: baggage?.redeemMiles || 0,
                                                    ruleID: baggage?.ruleID || '',
                                                    ruleDesc: baggage?.ruleDesc || '',
                                                    maxCountFlightLevel: baggage?.maxCountFlightLevel || 120,
                                                    maxCountServiceLevel: baggage?.maxCountServiceLevel || 120,
                                                    quantity: baggage?.quantity || 120,
                                                    lfID: baggage?.lfID || baggage?.flightId,
                                                    depDate: baggage?.depDate || ''
                                                };
                                            }
                                        });
                                    }

                                    travellerInfo.push(traveller);
                                });

                                queryPayload = {
                                    type: 'fly-dubai',
                                    token: getCookie(`dahr--fly_dubaiToken`),
                                    flightDHTRId: queryParams?.flightId,
                                    travellerInfo: travellerInfo,
                                    finalAmount: totalPrice,
                                    originalAmount: flightDataPriceObj?.originalPrice || flightDataPriceObj?.totalFare,
                                    email: formik.values.email,
                                    countryCode: formik.values.phoneCode?.value,
                                    mobileNumber: formik.values.phoneNumber,
                                    baggageData: baggageData,
                                    mealData: mealData,
                                    addressCountry: formik?.values?.addressCountry,
                                    addressCity: formik?.values?.addressCity,
                                    paymentMode: 'WALLET',
                                    transcationId: deductBalanceFromWallet?.data?.transaction_id,
                                    activeCurrency: agentActiveCurrency,
                                    flyDubaiCartResponse: flyDubaiCartResponse,
                                };
                            } else if (queryParams?.source === 'aljazeera') {
                                // mapAljazeeraGenderTitle imported from utils/bookingHelpers.js
                                const allPax = formik?.values?.passgeners || [];
                                const infants = allPax.filter(p => p?.passengerType === 'INFANT');
                                let infantIndex = 0;
                                let travellerInfo = [];
                                let ssrData = [];
                                let seatmapdata = [];

                                allPax.forEach((passenger) => {
                                    if (passenger?.passengerType === 'INFANT') return;

                                    // collect this passenger's selected SSRs (baggage + meal) by per-passenger ssrKey
                                    (passenger?.BAGGAGE || []).forEach((b) => {
                                        if (b?.ssrKey) ssrData.push({ ssrKey: b.ssrKey, count: 1, note: '' });
                                    });
                                    (passenger?.MEAL || []).forEach((m) => {
                                        if (m?.ssrKey) ssrData.push({ ssrKey: m.ssrKey, count: 1, note: '' });
                                    });
                                    // Selected seats -> Navitaire seatsAssignment. travelerIndex is the
                                    // position in travellerInfo (infants excluded), which is how the
                                    // server maps seats onto TripSell's passengerKeys.
                                    (passenger?.SEATS || []).forEach((s) => {
                                        if (!s?.unitKey || !s?.vendorSegmentKey) return;
                                        seatmapdata.push({
                                            unitKey: s.unitKey,
                                            vendorSegmentKey: s.vendorSegmentKey,
                                            // Our own "DEP-ARR" route key — used server-side to build the
                                            // seatInfo map saved on passenger_details.
                                            segmentKey: s?.segmentKey,
                                            travelerIndex: travellerInfo.length,
                                            seatNumber: s?.seatNumber,
                                            price: s?.price,
                                            originalAmount: s?.originalAmount,
                                            waiveFee: !!s?.waiveFee,
                                        });
                                    });

                                    const { gender, title } = mapAljazeeraGenderTitle(passenger?.gender);
                                    let traveller = {
                                        paxType: passenger?.passengerType || '',
                                        title,
                                        firstName: passenger?.firstName?.trim() || '',
                                        middleName: '',
                                        lastName: passenger?.lastName?.trim() || '',
                                        gender,
                                        dob: passenger?.passportDOB || passenger?.dateOfBirth || '',
                                        passportNationality: passenger?.selectedCountryOption?.value?.toUpperCase() || '',
                                        passportNumber: passenger?.passportNumber?.trim() || '',
                                        passportExpiryDate: passenger?.passportExpiryDate || '',
                                        passportIssueDate: passenger?.passportIssueDate || '',
                                    };

                                    if (passenger?.passengerType === 'ADULT' && infantIndex < infants.length) {
                                        const inf = infants[infantIndex];
                                        const infMap = mapAljazeeraGenderTitle(inf?.gender);
                                        traveller.infant = {
                                            title: infMap.title,
                                            firstName: inf?.firstName?.trim() || '',
                                            middleName: '',
                                            lastName: inf?.lastName?.trim() || '',
                                            gender: infMap.gender,
                                            dob: inf?.passportDOB || inf?.dateOfBirth || '',
                                            passportNationality: inf?.selectedCountryOption?.value?.toUpperCase() || '',
                                            passportNumber: inf?.passportNumber?.trim() || '',
                                            passportExpiryDate: inf?.passportExpiryDate || '',
                                            passportIssueDate: inf?.passportIssueDate || '',
                                        };
                                        infantIndex++;
                                    }

                                    travellerInfo.push(traveller);
                                });

                                queryPayload = {
                                    type: 'aljazeera',
                                    flightDHTRId: queryParams?.flightId,
                                    details: getSessionStorage(`aljazeera-${queryParams?.priceId}`),
                                    adult: allPax.filter(p => p?.passengerType === 'ADULT').length,
                                    child: allPax.filter(p => p?.passengerType === 'CHILD').length,
                                    infant: infants.length,
                                    baseCurrency: getSessionStorage(`aljazeera-${queryParams?.priceId}`)?.baseCurrency || agentActiveCurrency,
                                    travellerInfo: travellerInfo,
                                    email: formik.values.email,
                                    mobileNumber: `${formik.values.phoneCode?.value}-${formik.values.phoneNumber}`,
                                    addressOne: formik?.values?.addressOne || '',
                                    addressTwo: '',
                                    addressCity: formik?.values?.addressCity || '',
                                    provinceState: formik?.values?.addressState?.value || '',
                                    addressCountry: formik?.values?.addressCountry?.value?.toUpperCase() || '',
                                    postalCode: formik?.values?.postalCode || '',
                                    seatmapdata: seatmapdata,
                                    ssrData: ssrData,
                                    notifyContacts: false,
                                    searchQuery: searchQueryObj,
                                    tripInfo: flightDetails,
                                };
                            } else {
                                let tripJackOriginalAmount = flightDataPriceObj?.originalPrice;
                                if (extraChargePrice?.total > 0) {
                                    formik?.values?.passgeners?.map((passenger) => {
                                        if (passenger?.['MEAL'] && passenger?.['MEAL']?.length) {
                                            passenger?.['MEAL']?.map((mealData) => {
                                                let mealPrice = parseFloat(mealData?.originalprice) || 0;
                                                tripJackOriginalAmount += mealPrice;
                                            })
                                        }
                                        if (passenger?.['BAGGAGE'] && passenger?.['BAGGAGE']?.length) {
                                            passenger?.['BAGGAGE']?.map((baggageData) => {
                                                let baggagePrice = parseFloat(baggageData?.originalprice) || 0;
                                                tripJackOriginalAmount += baggagePrice;
                                            })
                                        }
                                    })
                                }
                                queryPayload = {
                                    type: "tripjack",
                                    bookingId: tripJackBookingId,
                                    flightDHTRId: queryParams?.flightId,
                                    paymentInfos: [
                                        {
                                            amount: tripJackOriginalAmount
                                        }
                                    ],
                                    travellerInfo: formik?.values?.passgeners?.map((passenger) => ({
                                        title: getTitleFromGenderMsFallbackUpper(passenger?.gender),
                                        firstName: passenger?.firstName?.trim() || '',
                                        lastName: passenger?.lastName?.trim() || '',
                                        paxType: passenger?.passengerType || '',
                                        dateOfBirth: passenger?.dateOfBirth || '',
                                        dob: passenger?.passportDOB || '',
                                        passportNumber: passenger?.passportNumber?.trim() || '',
                                        passportExpiryDate: passenger?.passportExpiryDate || '',
                                        passportNationality: passenger?.selectedCountryOption?.value?.toUpperCase() || '',
                                        passportIssueDate: passenger?.passportIssueDate || '',
                                        ssrBaggageInfos: passenger?.['BAGGAGE'] && passenger?.['BAGGAGE']?.length ? passenger?.['BAGGAGE']?.map((baggageData) => ({
                                            code: baggageData?.value,
                                            key: baggageData?.flightId
                                        })) : [],
                                        ssrMealInfos: passenger?.['MEAL'] && passenger?.['MEAL']?.length ? passenger?.['MEAL']?.map((mealData) => ({
                                            code: mealData?.value,
                                            key: mealData?.flightId
                                        })) : []
                                    })) || [],
                                    deliveryInfo: {
                                        emails: [
                                            formik.values.email
                                        ],
                                        contacts: [
                                            contactNumber
                                        ]
                                    },
                                }
                            }
                            queryPayload.paymentMode = 'WALLET';
                            queryPayload.transcationId = deductBalanceFromWallet?.data?.transaction_id;
                            queryPayload.activeCurrency = agentActiveCurrency;
                            if (formik.values.bookingReferenceNote) {
                                queryPayload.bookingReferenceNote = formik.values.bookingReferenceNote;
                            }

                            if (showDiscounts) {
                                queryPayload.couponCodeData = activeCouponCodeData
                                if (checkPriceBeforeBooking?.showForm) {
                                    let originalAmount = checkPriceBeforeBooking?.amount?.originalAmount;
                                    queryPayload.couponCodeData.finalAmount = originalAmount;
                                    let totalDiscount = 0;
                                    if (activeCouponCodeData?.discount_type === "percentage") {
                                        totalDiscount = (originalAmount * (parseFloat(activeCouponCodeData?.discount_value) / 100));
                                    } else if (activeCouponCodeData?.discount_type === "fixed") {
                                        totalDiscount = parseFloat(activeCouponCodeData?.discount_value);
                                    }
                                    queryPayload.couponCodeData.totalDiscount = totalDiscount;
                                }
                            }
                            const flightBooking = await ApiCall('POST', `/flights/flight-booking`, { ...queryPayload, activeCurrency: "AED", agentActiveCurrency: "AED", display_currency: bookingOtherData?.currency || agentActiveCurrency }, { authorization: userToken });
                            if (flightBooking?.status === 200 && flightBooking?.data?.statusCode === 200 && !flightBooking?.data?.data?.errors) {
                                let bookingReferenceNumber;
                                let bookingId;
                                if (queryParams?.source === 'amadeus') {
                                    bookingId = flightBooking?.data?.data?.orderList?.[0]?.bookingID;
                                    bookingReferenceNumber = flightBooking?.data?.data?.bookingReferenceNumber;
                                } else if (queryParams?.source === 'tripjack') {
                                    bookingId = flightBooking?.data?.data?.bookingId;
                                } else if (queryParams?.source === 'air-arabia') {
                                    bookingId = flightBooking?.data?.data?.bookingId;
                                } else if (queryParams?.source === 'akasa-air') {
                                    bookingId = flightBooking?.data?.data?.bookingId;
                                } else if (queryParams?.source === 'travel-fusion') {
                                    bookingId = flightBooking?.data?.data?.CommandList?.StartBooking?.TFBookingReference;
                                } else if (queryParams?.source === 'ndc-portal') {
                                    bookingId = flightBooking?.data?.data?.ndcBookingReference;
                                } else if (queryParams?.source === 'verteil') {
                                    bookingId = flightBooking?.data?.data?.Response?.Order?.[0]?.OrderID?.value;
                                } else if (queryParams?.source === 'fly-dubai') {
                                    bookingId = flightBooking?.data?.data?.ViewPNR?.ConfirmationNumber;
                                    bookingReferenceNumber = flightBooking?.data?.data?.ViewPNR?.BookingReferenceNumber;
                                } else if (queryParams?.source === 'aljazeera') {
                                    bookingId = flightBooking?.data?.data?.recordLocator || flightBooking?.data?.data?.bookingId;
                                }
                                if (bookingId) {
                                    let createFlightBookingZohoInvoice = await ApiCall('POST', `wp-json/dahrEmaarApi/v1/createFlightBookingZohoInvoice`, {
                                        totalPrice: totalPrice,
                                        bookingReference: bookingId,
                                        "paymentMode": "WALLET",
                                    }, {}, 'wordpress');
                                    let nonceToken = await generateNonceForTranscationFn('loyalty', 'credit');
                                    ApiCall('POST', `wp-json/dahr/v1/loyalty-points-transaction`, {
                                        userToken: userToken,
                                        amount: totalPrice,
                                        booking_type: "vendor_flight_booking",
                                        booking_id: bookingId,
                                        transaction_comment: `Credited Towards: Flight Booking`,
                                        nonce: nonceToken
                                    }, {}, 'wordpress');
                                    setPayNowBtnLoader(false);
                                    setOnLoadLoader(false);
                                    setCheckPriceBeforeBooking({})
                                    navigate(`/flight/booking?bookingId=${bookingId}&source=${toUrlSource(queryParams?.source)}&bookingReferenceNumber=${bookingReferenceNumber}${queryParams?.source === 'aljazeera' ? '&freshBooking=1' : ''}`);
                                } else {
                                    let errorData = flightBooking?.data?.data?.errors || flightBooking?.data?.message;
                                    setCheckboxAndWalletError(getBookingErrorMessage(errorData, 'Something went wrong!'));
                                    setPayNowBtnLoader(false);
                                    setOnLoadLoader(false);
                                    setCheckPriceBeforeBooking({})
                                    let nonceToken = await generateNonceForTranscationFn('wallet', 'credit');
                                    await ApiCall('POST', `wp-json/dahr/v1/wallet-transaction`, {
                                        userToken: userToken,
                                        activeUserCurrency: agentActiveCurrency,
                                        display_currency: getActiveCode(),
                                        conversion_rate: getActiveRate(),
                                        transaction_type: "credit",
                                        payment_mode: "wallet",
                                        amount: totalPrice,
                                        nonce: nonceToken,
                                        transaction_comment: `Credited Towards: Flight Booking Error`
                                    }, {}, 'wordpress')
                                }
                            } else {
                                let errorData = flightBooking?.data?.data?.errors || flightBooking?.data?.message;
                                setCheckboxAndWalletError(getBookingErrorMessage(errorData, 'Something went wrong!'));
                                setPayNowBtnLoader(false);
                                setOnLoadLoader(false);
                                setCheckPriceBeforeBooking({})
                                let nonceToken = await generateNonceForTranscationFn('wallet', 'credit');
                                await ApiCall('POST', `wp-json/dahr/v1/wallet-transaction`, {
                                    userToken: userToken,
                                    activeUserCurrency: agentActiveCurrency,
                                    display_currency: getActiveCode(),
                                    conversion_rate: getActiveRate(),
                                    transaction_type: "credit",
                                    payment_mode: "wallet",
                                    amount: totalPrice,
                                    nonce: nonceToken,
                                    transaction_comment: `Credited Towards: Flight Booking Error`
                                }, {}, 'wordpress')
                            }
                        } else {
                            setPayNowBtnLoader(false);
                            setOnLoadLoader(false);
                            setCheckPriceBeforeBooking({})
                            setCheckboxAndWalletError('Wallet Balance not deduct.')
                        }
                    } else {
                        setPayNowBtnLoader(false);
                        setOnLoadLoader(false);
                        setCheckPriceBeforeBooking({})
                        setCheckboxAndWalletError(`Insufficient Balance. Your Total Balance is: ${walletBalance} <br/>
                    <a target="_blank" href="${process.env.wordpressApiEndPoint}dashboard/?tab=new-balance-request" class="hw-link--line">Add your Balance</a>`);
                    }
                } else {
                    setPayNowBtnLoader(false);
                    setOnLoadLoader(false);
                    setCheckPriceBeforeBooking({})
                    setCheckboxAndWalletError('Something went wrong.')
                }

            }
        }


    }

    // formatDateToDDMMYYYY — extracted to ./PassengerListPage/utils/bookingHelpers.js
    // calculateDifference — extracted to ./PassengerListPage/utils/bookingHelpers.js

    const downLoadTicketFn = async (withFare, openMarkup, markupPrice) => {
        let ticketName;
        if (withFare) {
            if (openMarkup) {
                setDownloadTicketWithMarkupLoader(true)
            } else {
                setDownloadTicketWithFareLoader(true);
            }

            ticketName = `flight-booking-${queryParams?.bookingId}.pdf`;
        } else {
            setDownloadTicketWithOutFareLoader(true)
            ticketName = `flight-booking-${queryParams?.bookingId}.pdf`;
        }
        const res = await ApiCall('POST', '/flights/download-ticket', {
            withFare: withFare,
            activeCurrency: agentActiveCurrency,
            source: queryParams?.source,
            bookingId: queryParams?.bookingId,
            responseType: 'blob',
            ...(queryParams?.bookingReferenceNumber && { bookingReferenceNumber: queryParams?.bookingReferenceNumber }),
            ...((openMarkup && markupPrice) && { markupPrice: markupPrice })
        }, { authorization: userToken });
        if (res?.status === 200) {
            const blob = new Blob([res?.data], { type: 'application/pdf' });
            const disposition = res.headers['content-disposition'];
            let fileName = ticketName;
            if (disposition && disposition.includes('filename=')) {
                fileName = disposition
                    .split('filename=')[1]
                    .replace(/"/g, '');
            }
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
        setDownloadTicketWithFareLoader(false);
        setDownloadTicketWithOutFareLoader(false);
        setDownloadTicketWithMarkupLoader(false)
    }

    const couponCodeApplyBtnFn = async () => {
        setCouponCodeLoader(true);
        if (couponCodeInput) {
            let totalAmount = (parseFloat(flightDataPriceObj?.totalFare) || 0) + (parseFloat(extraChargePrice?.total) || 0) + (parseFloat(extraChargePrice?.seat) || 0);
            const applyCouponCode = await GetApiCall('GET', `wp-json/dahr/v1/apply-coupon?userToken=${userToken}&activeUserCurrency=${agentActiveCurrency}&coupon_code=${couponCodeInput}&totalAmount=${totalAmount}`, {}, 'wordpress');
            if (applyCouponCode?.status === 200) {
                setCouponCodeError('');
                setCouponCodeInput('');
                setActiveCouponCodeData(applyCouponCode?.data)
                setFinalAmount(applyCouponCode?.data?.finalAmount)
                setShowDiscounts(true);
                setCouponCodeLoader(false);
            } else {
                setCouponCodeError(applyCouponCode?.data?.message || 'Something went wrong.')
                setCouponCodeInput('')
                setActiveCouponCodeData({
                    coupon_code: '',
                    discount_type: '',
                    discount_value: ''
                });
                setShowDiscounts(false);
                setCouponCodeLoader(false);
            }
        } else {
            setCouponCodeError('Please Enter Coupon Code.')
            setCouponCodeInput('')
            setActiveCouponCodeData({
                coupon_code: '',
                discount_type: '',
                discount_value: ''
            });
            setShowDiscounts(false);
            setCouponCodeLoader(false);
        }
    }

    const removeCoupnCodeFn = () => {
        setShowDiscounts(false);
        setCouponCodeError('')
        setCouponCodeInput('')
        setActiveCouponCodeData({
            coupon_code: '',
            discount_type: '',
            discount_value: ''
        });
        let totalAmount = (parseFloat(flightDataPriceObj?.totalFare) || 0);
        setFinalAmount(totalAmount)
    }

    const viewBaggageDetailsFn = (passengerData, flightDetails, flightDetailsIndex) => {
        setflightShowErrorMessage('')
        setShowBaggageDetailsModal(true);
        setBaggageDetailsPassengerData(passengerData);
        setBaggageDetailsFlightDetails(flightDetails);
        setBaggageDetailsFlightDetailsIndex(flightDetailsIndex);
    }

    const setPassangerExtraServiceFn = (event, passengerIndex, departureCode, arrivalCode, itemList, flightId, flightNumber = '', segementData, source, flights) => {
        const value = event?.target?.value;
        const description = event.target?.selectedOptions[0]?.dataset?.desc || '';
        const price = event.target?.selectedOptions[0]?.dataset?.price;
        const originalprice = event.target?.selectedOptions[0]?.dataset?.originalprice;
        let originalData = event.target?.selectedOptions[0]?.dataset?.originaldata;
        const passKey = event.target?.selectedOptions[0]?.dataset?.passkey;
        const ssrType = event.target?.selectedOptions[0]?.dataset?.ssrtype;

        if (source === 'air-arabia' && itemList === 'BAGGAGE') {

            const existingList = formik.values?.passgeners?.[passengerIndex]?.[itemList] || [];

            const baggageUpdates = segementData.map((flights, index) => {
                let flightSegment = '';
                let flightBaggagePrice = index === 0 ? price : 0;
                let flightbaggageOriginalPrice = index === 0 ? originalprice : 0;
                const flightId = flights?.id || flights?.flightNumber;
                const existingIndex = existingList.findIndex(item => item.flightId === flights?.flightNumber);
                let rphFlightData = airArabiaFlightData?.flightDetails?.find(flightData =>
                    flightData?.arrivalData?.airportCode === flights?.arrival?.airportCode &&
                    flightData?.departureData?.airportCode === flights?.departure?.airportCode &&
                    flightData?.flightNumber === flights?.flightNumber
                );
                formik.setFieldValue(
                    `passgeners[${passengerIndex}][${flights?.departure?.airportCode}-${flights?.arrival?.airportCode}][${itemList}]`,
                    { value, description, flightId }
                );

                if (rphFlightData) {
                    flightSegment = {
                        RPHCode: rphFlightData?.rphCode,
                        departureDateTime: rphFlightData?.departureData?.dateTime,
                        flightNumber: rphFlightData?.flightNumber
                    };
                }
                const newItem = {
                    value,
                    description,
                    price: flightBaggagePrice,
                    flightId,
                    originalprice: flightbaggageOriginalPrice,
                    flightSegment,
                };
                if (existingIndex > -1) {
                    existingList[existingIndex] = newItem;
                } else {
                    existingList.push(newItem);
                }
                return null;
            });
            formik.setFieldValue(`passgeners[${passengerIndex}][${itemList}]`, existingList);
        }
        else if (source === 'fly-dubai') {

            // console.log('item : ', event.target?.selectedOptions[0]?.dataset)
            const globalList = formik.values?.passgeners?.[passengerIndex]?.[itemList] || [];

            let findIndex;
            let data = JSON.parse(event.target?.selectedOptions[0]?.dataset?.originaldata);

            if (itemList === 'BAGGAGE') {
                findIndex = globalList?.findIndex(item => item.lfID === flightId);
                // console.log('Baggage findIndex:', findIndex, 'lfID:', flightId);
            } else if (itemList === 'MEAL') {
                const pfId = data?.pfId;
                findIndex = globalList?.findIndex(item => item.pfId === pfId);
            } else {
                // Default fallback
                findIndex = globalList?.findIndex(item => item.flightId === flightId);
            }

            let newItem;

            if (itemList === 'MEAL') {
                newItem = {
                    value,
                    description,
                    price: parseFloat(price) || 0,
                    originalprice: parseFloat(originalprice) || 0,
                    flightId,
                    pfId: data?.pfId,
                    code: value,
                    categoryID: data?.categoryID,
                    cutoffHours: data?.cutoffHours,
                    currency: 'AED',
                    amount: parseFloat(price) || 0,
                    redeemMiles: data?.redeemMiles,
                    ruleID: data?.ruleID,
                    ruleDesc: data?.ruleDesc,
                    maxCountFlightLevel: 200,
                    maxCountServiceLevel: 200,
                    quantity: data?.quantity,
                    lfID: flightId,
                    depDate: data?.depDate
                };
            } else if (itemList === 'BAGGAGE') {
                newItem = {
                    value,
                    description,
                    price: parseFloat(price) || 0,
                    originalprice: parseFloat(originalprice) || 0,
                    flightId,
                    lfID: flightId,
                    code: value,
                    categoryID: data?.categoryID,
                    cutoffHours: -1,
                    currency: 'AED',
                    amount: parseFloat(price) || 0,
                    redeemMiles: data?.redeemMiles,
                    ruleID: data?.ruleID,
                    ruleDesc: data?.ruleDesc,
                    maxCountFlightLevel: data?.maxCountFlightLevel,
                    maxCountServiceLevel: data?.maxCountServiceLevel,
                    quantity: data?.quantity,
                    depDate: data?.depDate
                };
            } else {
                newItem = { value, description, price, flightId, originalprice };
            }

            // Add or update the item in the global list
            if (findIndex > -1) {
                globalList[findIndex] = newItem;
            } else {
                globalList.push(newItem);
            }

            // Save to formik values
            formik.setFieldValue(`passgeners[${passengerIndex}][${itemList}]`, globalList);

            // Also set the segment-specific value for UI consistency
            formik.setFieldValue(
                `passgeners[${passengerIndex}][${departureCode}-${arrivalCode}][${itemList}]`,
                { value, description, flightId }
            );
        } else if (source === 'travel-fusion' && travelfusionparameters?.luggageTag) {
            flights?.forEach(flight => {
                flight?.segments?.forEach(segment => {
                    const departureCode = segment?.departure?.airportCode;
                    const arrivalCode = segment?.arrival?.airportCode;
                    const flightId = segment?.flightNumber;
                    const segmentKey = `${departureCode}-${arrivalCode}`;
                    const newItem = {
                        value,
                        description,
                        price: price,
                        flightId,
                        originalprice: originalprice,
                    };
                    formik.setFieldValue(
                        `passgeners[${passengerIndex}][${segmentKey}][${itemList}]`,
                        newItem
                    );
                    const existingList = formik.values?.passgeners?.[passengerIndex]?.[itemList] || [];
                    const existingIndex = existingList.findIndex(item => item.flightId === flightId);
                    let updatedList = [...existingList];
                    if (existingIndex > -1) {
                        updatedList[existingIndex] = newItem;
                    } else {
                        updatedList.push(newItem);
                    }
                    formik.setFieldValue(
                        `passgeners[${passengerIndex}][${itemList}]`,
                        updatedList
                    );
                });
            });
        }
        else {
            let flightSegment = '';
            let ssrKey = undefined;
            if (source === 'akasa-air') {
                originalData = JSON.parse(originalData);
                ssrKey = originalData?.passengersAvailability?.[passKey]?.['ssrKey']
            } else if (source === 'aljazeera') {
                // aljazeera SSR options carry a per-passenger `passengers[]` array (passengerKey + ssrKey).
                // Map the current passenger to its entry by non-infant order (ADULT/CHILD first), passengers[0] fallback.
                let parsedAljazeera = originalData ? JSON.parse(originalData) : null;
                const nonInfantIndex = (formik.values?.passgeners || [])
                    .slice(0, passengerIndex + 1)
                    .filter(p => p?.passengerType !== 'INFANT').length - 1;
                ssrKey = parsedAljazeera?.passengers?.[nonInfantIndex]?.ssrKey
                    || parsedAljazeera?.passengers?.[0]?.ssrKey;
            }
            let rphFlightData = airArabiaFlightData?.flightDetails?.find(flightData => flightData?.arrivalData?.airportCode === arrivalCode && flightData?.departureData?.airportCode === departureCode && flightData?.flightNumber === flightNumber);
            if (rphFlightData) {
                flightSegment = {
                    RPHCode: rphFlightData?.rphCode,
                    departureDateTime: rphFlightData?.departureData?.dateTime,
                    flightNumber: rphFlightData?.flightNumber
                }
            }
            formik.setFieldValue(
                `passgeners[${passengerIndex}][${departureCode}-${arrivalCode}][${itemList}]`,
                { value, description, flightId }
            );
            const globalList = formik.values?.passgeners?.[passengerIndex]?.[itemList] || [];
            const findIndex = globalList?.findIndex(item => item.flightId === flightId);
            const newItem = { value, description, price, flightId, originalprice, flightSegment, ssrKey, ssrType };
            if (findIndex > -1) {
                globalList[findIndex] = newItem
            } else {
                globalList.push(newItem)
            }
            formik.setFieldValue(`passgeners[${passengerIndex}][${itemList}]`, globalList);
        }
        setExtraChargePrice(prev => ({
            ...prev,
            show: true,
        }));
    };
 
    useEffect(() => {
        if (queryParams?.source !== 'travel-fusion' || !seatRequired) return;
        if (!sectionError?.seatError) return;

        const nonInfantPassengers = (formik.values?.passgeners || []).filter(p => p.passengerType !== 'INFANT');
        const seatSegmentKeys = (flightDetails || [])
            .flatMap(trip => trip?.segments || [])
            .filter(seg => seg?.specialServices?.SEAT?.rows?.length)
            .map(seg => `${seg?.departure?.airportCode}-${seg?.arrival?.airportCode}`);

        if (!seatSegmentKeys.length) return;

        let missing = false;
        for (const p of nonInfantPassengers) {
            const seats = Array.isArray(p?.SEAT) ? p.SEAT : [];
            if (seatSegmentKeys.some(segKey => !seats.some(s => s?.segmentKey === segKey))) {
                missing = true;
                break;
            }
        }

        if (!missing) {
            setSectionError(prev => ({ ...prev, seatError: '' }));
        }
    }, [formik.values?.passgeners, seatRequired, queryParams?.source, sectionError?.seatError, flightDetails]);

    useEffect(() => {
        let meal = 0, baggage = 0, seat = 0;
        formik.values?.passgeners?.forEach(passenger => {
            if (passenger?.['MEAL'] && passenger?.['MEAL']?.length) {
                passenger?.['MEAL']?.map((mealData) => {
                    let mealPrice = parseFloat(mealData?.price) || 0;
                    meal += mealPrice;
                })
            }
            if (passenger?.['BAGGAGE'] && passenger?.['BAGGAGE']?.length) {
                passenger?.['BAGGAGE']?.map((baggageData) => {
                    let baggagePrice = parseFloat(baggageData?.price) || 0;
                    baggage += baggagePrice;
                })
            }
            if (passenger?.['SEATS'] && passenger?.['SEATS']?.length) {
                passenger?.['SEATS']?.forEach((seatData) => {
                    let seatPrice = parseFloat(seatData?.price) || 0;
                    seat += seatPrice;
                });
            }
            if (passenger?.['SEAT'] && passenger?.['SEAT']?.length) {
                passenger?.['SEAT']?.forEach((seatData) => {
                    let seatPrice = parseFloat(seatData?.price) || 0;
                    seat += seatPrice;
                });
            }
        });

        // Calculate total for baggage & meals only (excluding seat)
        let baggageMealTotal = meal + baggage;
        if (meal >= 0 || baggage >= 0 || baggageMealTotal >= 0 || seat >= 0) {
            setExtraChargePrice(prev => ({
                ...prev,
                meal,
                baggage,
                seat,
                total: baggageMealTotal
            }));
        }

    }, [formik.values?.passgeners]);

    const resetSubmissionState = () => {
        if (hasSubmitted) {
            setHasSubmitted(false);
        }
    }

    const handleStripePaymentSuccess = async (paymentMethod) => {
        setStripeModalShow(false);
        setPayNowBtnLoader(true);
        setOnLoadLoader(false);
        if (paymentMethod?.status === 'requires_capture') {
            let totalPrice = showDiscounts ? parseFloat(finalAmount) : (parseFloat(finalAmount) + parseFloat(extraChargePrice?.total || 0) + parseFloat(extraChargePrice?.seat || 0));
            if (checkPriceBeforeBooking?.showForm || checkPriceBeforeBooking?.onlineForm) {
                totalPrice = checkPriceBeforeBooking?.amount?.originalAmount
            }
            let originalAirArabiaAmount = (checkPriceBeforeBooking?.showForm || checkPriceBeforeBooking?.onlineForm) ? checkPriceBeforeBooking?.amount?.totalAmount : flightDataPriceObj?.originalPrice;
            let extraService = (checkPriceBeforeBooking?.showForm || checkPriceBeforeBooking?.onlineForm) ? checkPriceBeforeBooking?.extraService : flightDataPriceObj?.originalPrice
            if (queryParams?.status === 'HOLD') {
                totalPrice = bookingOtherData?.totalPriceInfo?.totalFare;
                if (bookingOtherData?.totalPriceInfo?.couponData?.finalAmount) {
                    totalPrice = bookingOtherData?.totalPriceInfo?.couponData?.finalAmount;
                }
                if (queryParams.source === 'ndc-portal') {
                    totalPrice = ndcPriceAfterHold;
                }
            }
            let onlineServiceFeeAmount = 0;
            if (selectPaymentMethod === 1) {
                onlineServiceFeeAmount = ((totalPrice * onineServicesFees) / 100)
                totalPrice += onlineServiceFeeAmount;
            }
            if (checkPriceBeforeBooking?.showForm || checkPriceBeforeBooking?.onlineForm) {
                totalPrice = checkPriceBeforeBooking?.amount?.originalAmount
                onlineServiceFeeAmount = parseFloat(checkPriceBeforeBooking?.amount?.onlineServiceFeeAmount);
            }
            totalPrice = parseFloat(totalPrice) || 0;
                if (queryParams?.status === 'HOLD') {
                    let queryPayload;
                    let bookingId;
                    if (queryParams?.source === 'tripjack') {
                        bookingId = bookingOtherData?.orders?.bookingId;
                        queryPayload = {
                            type: queryParams?.source,
                            bookingId: bookingOtherData?.orders?.bookingId,
                            onlineServiceFeeAmount: onlineServiceFeeAmount,
                            paymentInfos: [{
                                "amount": bookingOtherData?.orders?.amount
                            }],
                        };
                    } else {
                        bookingId = queryParams?.bookingId;
                        queryPayload = {
                            type: queryParams?.source,
                            bookingId: queryParams?.bookingId,
                            onlineServiceFeeAmount: onlineServiceFeeAmount,
                            paymentMode: 'ONLINE',
                            transcationId: paymentMethod?.id
                        };
                    }
                    queryPayload.paymentMode = 'ONLINE';
                    queryPayload.transcationId = paymentMethod?.id;
                    if(queryParams?.source === 'ndc-portal' && ndcRealPriceAfterHold !== null) {
                        queryPayload.originalAmount = ndcRealPriceAfterHold;
                    }
                    const flightBooking = await ApiCall('POST', `/flights/flight-confirm-booking`, { ...queryPayload, activeCurrency: "AED", agentActiveCurrency: "AED", display_currency: bookingOtherData?.currency || agentActiveCurrency }, { authorization: userToken });
                    if (flightBooking?.status === 200 && flightBooking?.data?.statusCode === 200 && !flightBooking?.data?.data?.errors) {
                        let bookingReferenceNumber;
                        // await paymentCaptureCommonFn(paymentMethod?.id,userToken);
                        let createFlightBookingZohoInvoice = await ApiCall('POST', `wp-json/dahrEmaarApi/v1/createFlightBookingZohoInvoice`, {
                            totalPrice: totalPrice,
                            bookingReference: bookingId,
                            "paymentMode": "ONLINE",
                        }, {}, 'wordpress');
                        let nonceToken = await generateNonceForTranscationFn('loyalty', 'credit');
                        ApiCall('POST', `wp-json/dahr/v1/loyalty-points-transaction`, {
                            userToken: userToken,
                            amount: totalPrice,
                            booking_type: "vendor_flight_booking",
                            booking_id: bookingId,
                            transaction_comment: `Credited Towards: Flight Booking`,
                            nonce: nonceToken
                        }, {}, 'wordpress');
                        let nonceWalletToken = await generateNonceForTranscationFn('online', 'debit');
                        const deductBalanceFromWallet = await ApiCall('POST', `wp-json/dahr/v1/wallet-transaction`, {
                            userToken: userToken,
                            activeUserCurrency: agentActiveCurrency,
                            display_currency: getActiveCode(),
                            conversion_rate: getActiveRate(),
                            transaction_type: "debit",
                            payment_mode: "online",
                            amount: totalPrice,
                            transaction_comment: `Debited Towards: Flight Booking`,
                            nonce: nonceWalletToken
                        }, {}, 'wordpress');
                        setPayNowBtnLoader(false);
                        setOnLoadLoader(false);
                        navigate(`/flight/booking?bookingId=${bookingId}&source=${toUrlSource(queryParams?.source)}&bookingReferenceNumber=${bookingReferenceNumber}&refresh=1`);
                    } else {
                        setPayNowBtnLoader(false);
                        setOnLoadLoader(false);
                        setCheckboxAndWalletError(getBookingErrorMessage(flightBooking?.data?.data?.errors, 'Something went wrong.'))
                    }
                } else {
                    let queryPayload = {};
                    let flightData = flightDetails?.[0];
                    let contactNumber = `${formik.values.phoneCode?.value}${formik.values.phoneNumber}`
                    if (queryParams?.source === 'amadeus') {
                        queryPayload = {
                            type: "amadeus",
                            // Order already created + reconfirmed in check-price-before-booking -> issue only
                            amadeusBookingId: amadeusReconfirmRef.current?.bookingId,
                            amadeusSessionId: amadeusReconfirmRef.current?.sessionId,
                            sessionId: flightData?.sessionId,
                            tokenId: flightData?.tokenId,
                            sessionType: flightData?.sessionType,
                            fareKey: flightData?.fareKey,
                            travellerInfo: formik?.values?.passgeners?.map((passenger) => ({
                                title: getTitleFromGenderLower(passenger?.gender),
                                firstName: passenger?.firstName?.trim() || '',
                                lastName: passenger?.lastName?.trim() || '',
                                paxType: passenger?.passengerType || '',
                                dateOfBirth: passenger?.dateOfBirth || '',
                                dob: passenger?.passportDOB || '',
                                gender: getGenderFromTitle(passenger?.gender),
                                passportNumber: passenger?.passportNumber?.trim() || '',
                                passportExpiryDate: passenger?.passportExpiryDate || '',
                                passportNationality: passenger?.selectedCountryOption?.value?.toUpperCase() || '',
                                passportIssueDate: passenger?.passportIssueDate || '',
                                documentId: ""
                            })) || [],
                            deliveryInfo: {
                                address: "",
                                email: formik.values.email,
                                contactNumber: contactNumber
                            },
                            originalAmount : flightDataPriceObj?.originalAmount
                        }
                    } else if (queryParams?.source === 'air-arabia') {
                        let baggageData = [];
                        let mealData = [];
                        let travellerInfo = []
                        let seatmapdata = []
                        const adultRefs = [];
                        formik?.values?.passgeners?.map((passenger, index) => {
                            const paxType = passenger?.passengerType || '';
                            let refListNum = `${paxType?.charAt(0)}${index + 1}`;

                            if (paxType === 'ADULT') {
                                adultRefs.push(refListNum);
                            }

                            if (passenger?.passengerType === 'INFANT') {
                                const adultIndex = adultRefs[travellerInfo.length % adultRefs.length] || adultRefs[0] || 'A1';
                                refListNum = `${paxType.charAt(0)}${index + 1}/${adultIndex}`;
                            }
                            if (passenger?.BAGGAGE?.length) {
                                passenger?.BAGGAGE?.map((baggage) => {
                                    baggageData.push({
                                        ...baggage,
                                        refListNum
                                    })
                                })
                            }
                            if (passenger?.MEAL?.length) {
                                passenger?.MEAL?.map((meal) => {
                                    mealData.push({
                                        ...meal,
                                        refListNum
                                    })
                                })
                            }
                            if (passenger?.SEATS?.length) {
                                passenger?.SEATS?.map((seat) => {
                                    seatmapdata.push({
                                        seatnumber: seat?.seatNumber,
                                        rphCode: seat?.rphCode,
                                        travelerRef: seat?.travelerRef,
                                        price: parseFloat(seat?.price) || 0,
                                        originalAmount: parseFloat(seat?.originalAmount) || 0,
                                    })
                                })
                            }
                            travellerInfo.push({
                                title: getTitleFromGender(passenger?.gender),
                                firstName: passenger?.firstName?.trim() || '',
                                lastName: passenger?.lastName?.trim() || '',
                                paxType: passenger?.passengerType || '',
                                dateOfBirth: passenger?.dateOfBirth || '',
                                dob: passenger?.passportDOB || '',
                                passportNumber: passenger?.passportNumber?.trim() || '',
                                passportExpiryDate: passenger?.passportExpiryDate || '',
                                passportNationality: passenger?.selectedCountryOption?.value?.toUpperCase() || '',
                                passportIssueDate: passenger?.passportIssueDate || '',
                                refListNum: refListNum
                            })
                        })
                        queryPayload = {
                            type: 'air-arabia',
                            travellerInfo: travellerInfo,
                            searchQuery: searchQueryObj,
                            tripInfo: flightDetails,
                            finalAmount: totalPrice,
                            extraService: extraService,
                            originalAmount: originalAirArabiaAmount,
                            email: formik.values.email,
                            countryCode: formik.values.phoneCode?.value,
                            mobileNumber: formik.values.phoneNumber,
                            information: airArabiaFlightData,
                            baggageData: baggageData,
                            mealData: mealData,
                            seatmapdata: seatmapdata,
                            addressCountry: formik?.values?.addressCountry,
                            addressCity: formik?.values?.addressCity,
                            bundleSelection: airArabiaBundle
                        }
                    } else if (queryParams?.source === 'akasa-air') {
                        let baggageMealData = [];
                        let travellerInfo = []
                        let infants = formik?.values?.passgeners.filter(p => p?.passengerType === "INFANT");
                        let infantIndex = 0;
                        formik?.values?.passgeners?.map((passenger, index) => {
                            if (passenger?.passengerType === "INFANT") return;


                            if (passenger?.BAGGAGE?.length) {
                                passenger?.BAGGAGE?.map((baggage) => {
                                    baggageMealData.push(baggage)
                                })
                            }
                            if (passenger?.MEAL?.length) {
                                passenger?.MEAL?.map((meal) => {
                                    baggageMealData.push(meal)
                                })
                            }

                            const { gender, title } = getGenderTitleUppercase(passenger?.gender);



                            let traveller = {
                                keys: passenger?.keys,
                                title: title,
                                gender: gender,
                                firstName: passenger?.firstName?.trim() || '',
                                lastName: passenger?.lastName?.trim() || '',
                                paxType: passenger?.passengerType || '',
                                dateOfBirth: passenger?.dateOfBirth || '',
                                dob: passenger?.passportDOB || '',
                                passportNumber: passenger?.passportNumber?.trim() || '',
                                passportExpiryDate: passenger?.passportExpiryDate || '',
                                passportNationality: passenger?.selectedCountryOption?.value?.toUpperCase() || '',
                                passportIssueDate: passenger?.passportIssueDate || '',
                            }

                            if (passenger?.passengerType === "ADULT" && infantIndex < infants.length) {
                                let infantGender = '';
                                let infantTitle = '';
                                if (infants[infantIndex]?.gender === 'Ms') {
                                    infantGender = 'Male';
                                    infantTitle = 'MR';
                                } else if (infants[infantIndex]?.gender === 'Master') {
                                    infantGender = 'Female';
                                    infantTitle = 'MS';
                                } else if (infants[infantIndex]?.gender === 'Male') {
                                    infantTitle = 'MR';
                                } else if (infants[infantIndex]?.gender === 'Female') {
                                    infantTitle = 'MS';
                                }

                                traveller.infant = {
                                    keys: infants[infantIndex]?.keys,
                                    title: infantTitle,
                                    gender: infantGender,
                                    firstName: infants[infantIndex]?.firstName?.trim() || '',
                                    lastName: infants[infantIndex]?.lastName?.trim() || '',
                                    paxType: infants[infantIndex]?.passengerType || '',
                                    dateOfBirth: infants[infantIndex]?.dateOfBirth || '',
                                    dob: infants[infantIndex]?.passportDOB || '',
                                    passportNumber: infants[infantIndex]?.passportNumber?.trim() || '',
                                    passportExpiryDate: infants[infantIndex]?.passportExpiryDate || '',
                                    passportNationality: infants[infantIndex]?.selectedCountryOption?.value?.toUpperCase() || '',
                                    passportIssueDate: infants[infantIndex]?.passportIssueDate || '',
                                };
                                infantIndex++;
                            }
                            travellerInfo.push(traveller)
                        })
                        queryPayload = {
                            type: 'akasa-air',
                            travellerInfo: travellerInfo,
                            searchQuery: searchQueryObj,
                            tripInfo: flightDetails,
                            flightDHTRId: queryParams?.flightId,
                            finalAmount: totalPrice,
                            originalAmount: flightDataPriceObj?.originalPrice,
                            email: formik.values.email,
                            countryCode: formik.values.phoneCode?.value,
                            mobileNumber: formik.values.phoneNumber,
                            baggageMealData: baggageMealData,
                            addressCountry: formik?.values?.addressCountry?.value?.toUpperCase(),
                            addressOne: formik?.values?.addressOne,
                            provinceState: formik?.values?.addressState?.value,
                            postalCode: formik?.values?.postalCode,
                            addressCity: formik?.values?.addressCity,
                            akasaAirToken: akasaAirToken
                        }
                    } else if (queryParams?.source === 'ndc-portal') {
                        let passengerData = {}
                        let adulRefs = []
                        let index = 0
                        let travellerInfo = [];
                        for (let passenger of formik?.values?.passgeners) {
                            // console.log("adulRefs : ", adulRefs)
                            const paxType = passenger?.passengerType || '';
                            let paxKey = `Pax${index + 1}`
                            if (passenger?.passengerType === 'ADULT') {
                                adulRefs.push(paxKey)
                            }
                            let parentRef = null;
                            if (paxType === 'INFANT') {
                                parentRef = adulRefs[travellerInfo.length % adulRefs.length] || adulRefs[0] || 'Pax1';
                            }

                            let countryISOCode = passenger?.selectedCountryOption?.value;
                            if (countryISOCode === 'uk') {
                                countryISOCode = 'gb';
                            } else if (countryISOCode === 'uae') {
                                countryISOCode = 'ae';
                            }

                            passengerData[paxKey] = {
                                PassengerTypeCode: passenger?.passengerType === 'ADULT' ? 'ADT' : passenger?.passengerType === 'CHILD' ? 'CHD' : 'INF',
                                title: getTitleFromGender(passenger?.gender),
                                gender: getGenderFromTitle(passenger?.gender),
                                Name: {
                                    First: passenger?.firstName?.trim() || '',
                                    Middle: "",
                                    Last: passenger?.lastName?.trim() || ''
                                },
                                BirthDate: passenger?.passportDOB || '',
                                NationalityCountryCode: countryISOCode?.toUpperCase() || '',
                                ResidenceCountryCode: countryISOCode?.toUpperCase() || '',
                                ParentPassengerReferenceId: parentRef,
                                TravelDocument: {
                                    DocumentNumber: passenger?.passportNumber?.trim() || '',
                                    DocumentType: "Passport",
                                    Name: {
                                        First: passenger?.firstName?.trim() || '',
                                        Middle: "",
                                        Last: passenger?.lastName?.trim() || ''
                                    },
                                    Gender: getGenderFromTitle(passenger?.gender),
                                    BirthDate: passenger?.passportDOB || '',
                                    ExpirationDate: passenger?.passportExpiryDate || '',
                                    IssuanceDate: passenger?.passportIssueDate || '',
                                    BirthCountryCode: countryISOCode?.toUpperCase() || '',
                                    NationalityCountryCode: countryISOCode?.toUpperCase() || '',
                                    IssuanceCountryCode: countryISOCode?.toUpperCase() || ''
                                },
                                PassengerDiscountAmount: passenger?.passengerDiscountAmount,
                                PassengerServiceChargeAmount: passenger?.passengerServiceChargeAmount,
                                Contact: {
                                    Email: formik.values.email,
                                    Phone: {
                                        CountryDialingCode: formik.values.phoneCode?.value,
                                        PhoneNumber: formik.values.phoneNumber,
                                        Type: "Personal" // Mobile
                                    },
                                    Address: {
                                        CountryCode: countryISOCode?.toUpperCase() || '',
                                        CityCode: passenger?.selectedCountryOption?.label?.toUpperCase() || '',
                                        Line1: countryISOCode?.toUpperCase() || '',
                                        Line2: passenger?.selectedCountryOption?.label?.toUpperCase() || ''
                                    }
                                }
                            }
                            travellerInfo.push({
                                title: getTitleFromStoredGender(passenger?.gender),
                                firstName: passenger?.firstName?.trim() || '',
                                lastName: passenger?.lastName?.trim() || '',
                                paxType: paxType,
                                dateOfBirth: passenger?.dateOfBirth || '',
                                dob: passenger?.passportDOB || '',
                                passportNumber: passenger?.passportNumber?.trim() || '',
                                passportExpiryDate: passenger?.passportExpiryDate || '',
                                passportNationality: countryISOCode?.toUpperCase() || '',
                                passportIssueDate: passenger?.passportIssueDate || '',
                                refListNum: paxKey
                            });
                            index++;
                        }
                        setCookie('ndcIdentifier', flightDetails?.[0]?.totalPriceList?.[0]?.fareIdentifier)
                        queryPayload = {
                            type: queryParams?.source,
                            travellerInfo: passengerData,
                            offerId: queryParams?.priceId,
                            selectedBundles: JSON.parse(sessionStorage.getItem('ndcDataBundle')) || [],
                            tripIdentifier: flightDetails?.[0]?.totalPriceList?.[0]?.fareIdentifier,
                            flightDHTRId: ndcFlightId,
                            originalAmount : flightDataPriceObj?.originalAmount
                        }
                    } else if (queryParams?.source === 'verteil') {
                        let payloadParam = { ...orderCreateRq };
                        let originalData = payloadParam?.Query?.Passengers?.Passenger;
                        let formikData = formik?.values?.passgeners;
                        const categorizedFormik = {
                            ADULT: [],
                            CHILD: [],
                            INFANT: [],
                        };
                        formikData.forEach(p => {
                            categorizedFormik[p?.passengerType].push(p);
                        });
                        const adultOriginalPassengers = originalData.filter(p => p?.PTC?.value === 'ADT');
                        let adultIndexForInfant = 0;
                        payloadParam.Query.Passengers.Passenger = originalData.map((original, index) => {
                            const passengerType = original.PTC.value === 'ADT' ? 'ADULT'
                                : original.PTC.value === 'CHD' ? 'CHILD'
                                    : 'INFANT';

                            const matchingFormik = categorizedFormik?.[passengerType]?.shift();

                            if (!matchingFormik) return original;
                            const titleName = getNdcTitleFromStoredGender(matchingFormik?.gender, original.PTC.value === 'ADT');
                            const updated = {
                                ...original,
                                Name: {
                                    Title: titleName,
                                    Surname: { value: matchingFormik?.lastName },
                                    Given: [{ value: matchingFormik?.firstName }],
                                },
                                Age: {

                                    BirthDate: { value: formatDateToDDMMYYYY(matchingFormik?.passportDOB) },
                                },
                                Gender: { value: getGenderFromTitle(matchingFormik?.gender) },
                                PassengerIDInfo: {
                                    AllowDocumentInd: 'true',
                                    PassengerDocument: [
                                        {
                                            Type: 'PT',
                                            ID: matchingFormik?.passportNumber,
                                            DateOfIssue: formatDateToDDMMYYYY(matchingFormik?.passportIssueDate),
                                            DateOfExpiration: formatDateToDDMMYYYY(matchingFormik?.passportExpiryDate),
                                            CountryOfIssuance: matchingFormik?.selectedCountryOption?.value?.toUpperCase(),
                                            CountryOfResidence: matchingFormik?.selectedCountryOption?.value?.toUpperCase(),
                                        },
                                    ],
                                },
                            };

                            if (passengerType === 'ADULT' && index === 0) {
                                updated.Contacts = {
                                    Contact: [
                                        {
                                            AddressContact: {
                                                Street: [formik?.values?.addressOne],
                                                CityName: formik?.values?.addressCity,
                                                PostalCode: formik?.values?.postalCode,
                                                CountryCode: { value: formik?.values?.addressCountry?.value?.toUpperCase() },
                                            },
                                            EmailContact: {
                                                Address: { value: formik.values.email },
                                            },
                                            PhoneContact: {
                                                Application: 'Home',
                                                Number: [
                                                    {
                                                        value: formik?.values?.phoneNumber,
                                                        CountryCode: formik.values.phoneCode?.value?.replace("+", ""),
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                };
                            }

                            // Associate INFANT with next available ADULT ObjectKey
                            if (passengerType === 'INFANT' && adultOriginalPassengers[adultIndexForInfant]) {
                                updated.PassengerAssociation = adultOriginalPassengers[adultIndexForInfant].ObjectKey;
                                adultIndexForInfant = (adultIndexForInfant + 1) % adultOriginalPassengers.length;
                            }

                            return updated;
                        });
                        queryPayload = {
                            session: payloadParam,
                            type: queryParams?.source,
                            flightDHTRId: queryParams?.flightId,
                        }
                    } else if (queryParams?.source === 'travel-fusion') {
                        const lastFlight = flightDetails?.[flightDetails.length - 1];
                        const lastSegment = lastFlight?.segments?.[lastFlight.segments.length - 1];
                        const returnDate = lastSegment?.arrival?.time;
                        queryPayload = {
                            type: queryParams?.source,
                            routingId: travelFusionRoutingId,
                            flightDHTRId: queryParams?.flightId,
                            singleTrip: flightDetails?.length === 1,
                            singleTripData: {
                                cabinBaggage: flightDetails?.[0]?.totalPriceList?.[0]?.fareDetails?.[0]?.baggageInfo?.cabinBaggage ? flightDetails?.[0]?.totalPriceList?.[0]?.fareDetails?.[0]?.baggageInfo?.cabinBaggage : 'N/A',
                                checkinBaggageData: flightDetails?.[0]?.segments?.[0]?.specialServices?.['BAGGAGE'] ? flightDetails?.[0]?.segments?.[0]?.specialServices?.['BAGGAGE'] : []
                            },
                            roundTripData: {
                                cabinBaggage: flightDetails?.[1]?.totalPriceList?.[0]?.fareDetails?.[0]?.baggageInfo?.cabinBaggage ? flightDetails?.[1]?.totalPriceList?.[0]?.fareDetails?.[0]?.baggageInfo?.cabinBaggage : 'N/A',
                                checkinBaggageData: flightDetails?.[1]?.segments?.[0]?.specialServices?.['BAGGAGE'] ? flightDetails?.[1]?.segments?.[0]?.specialServices?.['BAGGAGE'] : []
                            },
                            travellerInfo: formik?.values?.passgeners?.map((passenger) => {
                                let baggageData = [];
                                let mealData = [];
                                if (passenger?.BAGGAGE?.length) {
                                    passenger?.BAGGAGE?.map((baggage) => {
                                        baggageData.push(baggage)
                                    })
                                }

                                if (passenger?.MEAL?.length) {
                                    passenger?.MEAL?.map((meal) => {
                                        mealData.push(meal)
                                    })
                                }
                                let seatData = [];
                                if (passenger?.SEAT?.length) {
                                    passenger?.SEAT?.map((seat) => {
                                        seatData.push(seat)
                                    })
                                }

                                let countryISOCode = countryCommonFn(passenger?.selectedCountryOption?.value);

                                return {
                                    title: getSimpleTitle(passenger?.gender),
                                    firstName: passenger?.firstName?.trim() || '',
                                    lastName: passenger?.lastName?.trim() || '',
                                    paxType: passenger?.passengerType || '',
                                    dateOfBirth: passenger?.dateOfBirth || '',
                                    dob: passenger?.passportDOB || '',
                                    gender: getGenderFromTitle(passenger?.gender),
                                    passportNumber: passenger?.passportNumber?.trim() || '',
                                    passportExpiryDate: passenger?.passportExpiryDate || '',
                                    passportNationality: countryISOCode?.toUpperCase() || '',
                                    passportIssueDate: passenger?.passportIssueDate || '',
                                    documentId: "",
                                    baggage: baggageData,
                                    meal: mealData,
                                    seat: seatData
                                }
                            }) || [],
                            deliveryInfo: {
                                address: "",
                                email: formik.values.email,
                                contactNumber: contactNumber
                            },
                            usePreRegisteredSupplier: usePreRegisteredSupplier,
                            requiredParameters: travelfusionparameters,
                            routingIds: {
                                outwardId: queryParams?.outwardId,
                                returnId: queryParams?.returnId
                            },
                            returnDate,
                        }
                    } else if (queryParams?.source === 'fly-dubai') {
                        let travellerInfo = [];
                        let baggageData = [];
                        let mealData = [];

                        formik?.values?.passgeners?.map((passenger, index) => {
                            const paxType = passenger?.passengerType || '';
                            let refListNum = `${paxType?.charAt(0)}${index + 1}`;

                            let traveller = {
                                title: getTitleFromGender(passenger?.gender),
                                firstName: passenger?.firstName?.trim() || '',
                                lastName: passenger?.lastName?.trim() || '',
                                paxType: passenger?.passengerType || '',
                                dateOfBirth: passenger?.dateOfBirth || '',
                                dob: passenger?.passportDOB || '',
                                passportNumber: passenger?.passportNumber?.trim() || '',
                                passportExpiryDate: passenger?.passportExpiryDate || '',
                                passportNationality: passenger?.selectedCountryOption?.value?.toUpperCase() || '',
                                passportIssueDate: passenger?.passportIssueDate || '',
                                refListNum: refListNum,
                                MEAL: {},
                                BAGGAGE: {}
                            };

                            if (passenger?.MEAL?.length) {
                                passenger?.MEAL?.forEach((meal) => {
                                    const mealKey = meal?.pfId;
                                    if (mealKey) {
                                        traveller.MEAL[mealKey] = {
                                            code: meal?.code || meal?.value,
                                            categoryID: meal?.categoryID || 121,
                                            cutoffHours: meal?.cutoffHours || 24,
                                            currency: meal?.currency || 'AED',
                                            description: meal?.description,
                                            amount: meal?.amount || meal?.price || 0,
                                            redeemMiles: meal?.redeemMiles || 0,
                                            ruleID: meal?.ruleID || '',
                                            ruleDesc: meal?.ruleDesc || '',
                                            maxCountFlightLevel: meal?.maxCountFlightLevel || 200,
                                            maxCountServiceLevel: meal?.maxCountServiceLevel || 200,
                                            quantity: meal?.quantity || 200,
                                            pfID: mealKey,
                                            lfID: meal?.lfID || meal?.flightId,
                                            depDate: meal?.depDate || ''
                                        };
                                    }
                                });
                            }

                            if (passenger?.BAGGAGE?.length) {
                                passenger?.BAGGAGE?.forEach((baggage) => {
                                    const baggageKey = baggage?.lfID || baggage?.flightId;
                                    if (baggageKey) {
                                        traveller.BAGGAGE[baggageKey] = {
                                            code: baggage?.code || baggage?.value,
                                            categoryID: baggage?.categoryID || 99,
                                            cutoffHours: baggage?.cutoffHours || -1,
                                            currency: baggage?.currency || 'AED',
                                            description: baggage?.description,
                                            amount: baggage?.amount || baggage?.price || 0,
                                            redeemMiles: baggage?.redeemMiles || 0,
                                            ruleID: baggage?.ruleID || '',
                                            ruleDesc: baggage?.ruleDesc || '',
                                            maxCountFlightLevel: baggage?.maxCountFlightLevel || 120,
                                            maxCountServiceLevel: baggage?.maxCountServiceLevel || 120,
                                            quantity: baggage?.quantity || 120,
                                            lfID: baggage?.lfID || baggage?.flightId,
                                            depDate: baggage?.depDate || ''
                                        };
                                    }
                                });
                            }

                            travellerInfo.push(traveller);
                        });

                        queryPayload = {
                            type: 'fly-dubai',
                            token: getCookie(`dahr--fly_dubaiToken`),
                            flightDHTRId: queryParams?.flightId,
                            travellerInfo: travellerInfo,
                            finalAmount: totalPrice,
                            originalAmount: flightDataPriceObj?.originalPrice || flightDataPriceObj?.totalFare,
                            email: formik.values.email,
                            countryCode: formik.values.phoneCode?.value,
                            mobileNumber: formik.values.phoneNumber,
                            baggageData: baggageData,
                            mealData: mealData,
                            addressCountry: formik?.values?.addressCountry,
                            addressCity: formik?.values?.addressCity,
                            transcationId: deductBalanceFromWallet?.data?.transaction_id,
                            activeCurrency: agentActiveCurrency,
                            flyDubaiCartResponse: flyDubaiCartResponse,
                        };
                    } else if (queryParams?.source === 'aljazeera') {
                        // mapAljazeeraGenderTitle imported from utils/bookingHelpers.js
                        const allPax = formik?.values?.passgeners || [];
                        const infants = allPax.filter(p => p?.passengerType === 'INFANT');
                        let infantIndex = 0;
                        let travellerInfo = [];
                        let ssrData = [];
                        let seatmapdata = [];

                        allPax.forEach((passenger) => {
                            if (passenger?.passengerType === 'INFANT') return;

                            // collect this passenger's selected SSRs (baggage + meal) by per-passenger ssrKey
                            (passenger?.BAGGAGE || []).forEach((b) => {
                                if (b?.ssrKey) ssrData.push({ ssrKey: b.ssrKey, count: 1, note: '' });
                            });
                            (passenger?.MEAL || []).forEach((m) => {
                                if (m?.ssrKey) ssrData.push({ ssrKey: m.ssrKey, count: 1, note: '' });
                            });
                            // Selected seats -> Navitaire seatsAssignment. travelerIndex is the
                            // position in travellerInfo (infants excluded), which is how the
                            // server maps seats onto TripSell's passengerKeys.
                            (passenger?.SEATS || []).forEach((s) => {
                                if (!s?.unitKey || !s?.vendorSegmentKey) return;
                                seatmapdata.push({
                                    unitKey: s.unitKey,
                                    vendorSegmentKey: s.vendorSegmentKey,
                                    // Our own "DEP-ARR" route key — used server-side to build the
                                    // seatInfo map saved on passenger_details.
                                    segmentKey: s?.segmentKey,
                                    travelerIndex: travellerInfo.length,
                                    seatNumber: s?.seatNumber,
                                    price: s?.price,
                                    originalAmount: s?.originalAmount,
                                    waiveFee: !!s?.waiveFee,
                                });
                            });

                            const { gender, title } = mapAljazeeraGenderTitle(passenger?.gender);
                            let traveller = {
                                paxType: passenger?.passengerType || '',
                                title,
                                firstName: passenger?.firstName?.trim() || '',
                                middleName: '',
                                lastName: passenger?.lastName?.trim() || '',
                                gender,
                                dob: passenger?.passportDOB || passenger?.dateOfBirth || '',
                                passportNationality: passenger?.selectedCountryOption?.value?.toUpperCase() || '',
                                passportNumber: passenger?.passportNumber?.trim() || '',
                                passportExpiryDate: passenger?.passportExpiryDate || '',
                                passportIssueDate: passenger?.passportIssueDate || '',
                            };

                            if (passenger?.passengerType === 'ADULT' && infantIndex < infants.length) {
                                const inf = infants[infantIndex];
                                const infMap = mapAljazeeraGenderTitle(inf?.gender);
                                traveller.infant = {
                                    title: infMap.title,
                                    firstName: inf?.firstName?.trim() || '',
                                    middleName: '',
                                    lastName: inf?.lastName?.trim() || '',
                                    gender: infMap.gender,
                                    dob: inf?.passportDOB || inf?.dateOfBirth || '',
                                    passportNationality: inf?.selectedCountryOption?.value?.toUpperCase() || '',
                                    passportNumber: inf?.passportNumber?.trim() || '',
                                    passportExpiryDate: inf?.passportExpiryDate || '',
                                    passportIssueDate: inf?.passportIssueDate || '',
                                };
                                infantIndex++;
                            }

                            travellerInfo.push(traveller);
                        });

                        queryPayload = {
                            type: 'aljazeera',
                            flightDHTRId: queryParams?.flightId,
                            details: getSessionStorage(`aljazeera-${queryParams?.priceId}`),
                            adult: allPax.filter(p => p?.passengerType === 'ADULT').length,
                            child: allPax.filter(p => p?.passengerType === 'CHILD').length,
                            infant: infants.length,
                            baseCurrency: getSessionStorage(`aljazeera-${queryParams?.priceId}`)?.baseCurrency || agentActiveCurrency,
                            travellerInfo: travellerInfo,
                            email: formik.values.email,
                            mobileNumber: `${formik.values.phoneCode?.value}-${formik.values.phoneNumber}`,
                            addressOne: formik?.values?.addressOne || '',
                            addressTwo: '',
                            addressCity: formik?.values?.addressCity || '',
                            provinceState: formik?.values?.addressState?.value || '',
                            addressCountry: formik?.values?.addressCountry?.value?.toUpperCase() || '',
                            postalCode: formik?.values?.postalCode || '',
                            seatmapdata: seatmapdata,
                            ssrData: ssrData,
                            notifyContacts: false,
                            searchQuery: searchQueryObj,
                            tripInfo: flightDetails,
                        };
                    } else {
                        let tripJackOriginalAmount = flightDataPriceObj?.originalPrice;
                        if (extraChargePrice?.total > 0) {
                            formik?.values?.passgeners?.map((passenger) => {
                                if (passenger?.['MEAL'] && passenger?.['MEAL']?.length) {
                                    passenger?.['MEAL']?.map((mealData) => {
                                        let mealPrice = parseFloat(mealData?.originalprice) || 0;
                                        tripJackOriginalAmount += mealPrice;
                                    })
                                }
                                if (passenger?.['BAGGAGE'] && passenger?.['BAGGAGE']?.length) {
                                    passenger?.['BAGGAGE']?.map((baggageData) => {
                                        let baggagePrice = parseFloat(baggageData?.originalprice) || 0;
                                        tripJackOriginalAmount += baggagePrice;
                                    })
                                }
                            })
                        }
                        queryPayload = {
                            type: "tripjack",
                            bookingId: tripJackBookingId,
                            flightDHTRId: queryParams?.flightId,
                            paymentInfos: [
                                {
                                    amount: tripJackOriginalAmount
                                }
                            ],
                            travellerInfo: formik?.values?.passgeners?.map((passenger) => ({
                                title: getTitleFromGenderMsFallbackUpper(passenger?.gender),
                                firstName: passenger?.firstName?.trim() || '',
                                lastName: passenger?.lastName?.trim() || '',
                                paxType: passenger?.passengerType || '',
                                dateOfBirth: passenger?.dateOfBirth || '',
                                dob: passenger?.passportDOB || '',
                                passportNumber: passenger?.passportNumber?.trim() || '',
                                passportExpiryDate: passenger?.passportExpiryDate || '',
                                passportNationality: passenger?.selectedCountryOption?.value?.toUpperCase() || '',
                                passportIssueDate: passenger?.passportIssueDate || '',
                                ssrBaggageInfos: passenger?.['BAGGAGE'] && passenger?.['BAGGAGE']?.length ? passenger?.['BAGGAGE']?.map((baggageData) => ({
                                    code: baggageData?.value,
                                    key: baggageData?.flightId
                                })) : [],
                                ssrMealInfos: passenger?.['MEAL'] && passenger?.['MEAL']?.length ? passenger?.['MEAL']?.map((mealData) => ({
                                    code: mealData?.value,
                                    key: mealData?.flightId
                                })) : []
                            })) || [],
                            deliveryInfo: {
                                emails: [
                                    formik.values.email
                                ],
                                contacts: [
                                    contactNumber
                                ]
                            },
                        }
                    }
                    queryPayload.onlineServiceFeeAmount = onlineServiceFeeAmount;
                    queryPayload.paymentMode = 'ONLINE';
                    queryPayload.transcationId = paymentMethod?.id;
                    queryPayload.activeCurrency = agentActiveCurrency;
                    if (formik.values.bookingReferenceNote) {
                        queryPayload.bookingReferenceNote = formik.values.bookingReferenceNote;
                    }
                    if (showDiscounts) {
                        queryPayload.couponCodeData = activeCouponCodeData
                        if (checkPriceBeforeBooking?.showForm || checkPriceBeforeBooking?.onlineForm) {
                            let originalAmount = checkPriceBeforeBooking?.amount?.originalAmount;
                            queryPayload.couponCodeData.finalAmount = originalAmount;
                            let totalDiscount = 0;
                            if (activeCouponCodeData?.discount_type === "percentage") {
                                totalDiscount = (originalAmount * (parseFloat(activeCouponCodeData?.discount_value) / 100));
                            } else if (activeCouponCodeData?.discount_type === "fixed") {
                                totalDiscount = parseFloat(activeCouponCodeData?.discount_value);
                            }
                            queryPayload.couponCodeData.totalDiscount = totalDiscount;
                        }
                    }

                    const flightBooking = await ApiCall('POST', `/flights/flight-booking`, { ...queryPayload, activeCurrency: "AED", agentActiveCurrency: "AED", display_currency: bookingOtherData?.currency || agentActiveCurrency }, { authorization: userToken });
                    if (flightBooking?.status === 200 && flightBooking?.data?.statusCode === 200 && !flightBooking?.data?.data?.errors) {
                        let bookingReferenceNumber;
                        let bookingId;
                        if (queryParams?.source === 'amadeus') {
                            bookingId = flightBooking?.data?.data?.orderList?.[0]?.bookingID;
                            bookingReferenceNumber = flightBooking?.data?.data?.bookingReferenceNumber;
                        } else if (queryParams?.source === 'tripjack') {
                            bookingId = flightBooking?.data?.data?.bookingId;
                        } else if (queryParams?.source === 'air-arabia') {
                            bookingId = flightBooking?.data?.data?.bookingId;
                        } else if (queryParams?.source === 'akasa-air') {
                            bookingId = flightBooking?.data?.data?.bookingId;
                        } else if (queryParams?.source === 'travel-fusion') {
                            bookingId = flightBooking?.data?.data?.CommandList?.StartBooking?.TFBookingReference;
                        } else if (queryParams?.source === 'ndc-portal') {
                            bookingId = flightBooking?.data?.data?.ndcBookingReference;
                        } else if (queryParams?.source === 'verteil') {
                            bookingId = flightBooking?.data?.data?.Response?.Order?.[0]?.OrderID?.value;
                        } else if (queryParams?.source === 'fly-dubai') {
                            bookingId = flightBooking?.data?.data?.ViewPNR?.ConfirmationNumber;
                            bookingReferenceNumber = flightBooking?.data?.data?.ViewPNR?.BookingReferenceNumber;
                        } else if (queryParams?.source === 'aljazeera') {
                            bookingId = flightBooking?.data?.data?.recordLocator || flightBooking?.data?.data?.bookingId;
                        }
                        if (bookingId) {
                            // await paymentCaptureCommonFn(paymentMethod?.id,userToken);
                            let createFlightBookingZohoInvoice = await ApiCall('POST', `wp-json/dahrEmaarApi/v1/createFlightBookingZohoInvoice`, {
                                totalPrice: totalPrice,
                                bookingReference: bookingId,
                                "paymentMode": "ONLINE",
                            }, {}, 'wordpress');
                            let nonceToken = await generateNonceForTranscationFn('loyalty', 'credit');
                            ApiCall('POST', `wp-json/dahr/v1/loyalty-points-transaction`, {
                                userToken: userToken,
                                amount: totalPrice,
                                booking_type: "vendor_flight_booking",
                                booking_id: bookingId,
                                transaction_comment: `Credited Towards: Flight Booking`,
                                nonce: nonceToken
                            }, {}, 'wordpress');
                            let nonceWalletToken = await generateNonceForTranscationFn('online', 'debit');
                            const deductBalanceFromWallet = await ApiCall('POST', `wp-json/dahr/v1/wallet-transaction`, {
                                userToken: userToken,
                                activeUserCurrency: agentActiveCurrency,
                                display_currency: getActiveCode(),
                                conversion_rate: getActiveRate(),
                                transaction_type: "debit",
                                payment_mode: "online",
                                amount: totalPrice,
                                transaction_comment: `Debited Towards: Flight Booking`,
                                nonce: nonceWalletToken
                            }, {}, 'wordpress');
                            setPayNowBtnLoader(false);
                            setOnLoadLoader(false);
                            navigate(`/flight/booking?bookingId=${bookingId}&source=${toUrlSource(queryParams?.source)}&bookingReferenceNumber=${bookingReferenceNumber}${queryParams?.source === 'aljazeera' ? '&freshBooking=1' : ''}`);
                        } else {
                            // await paymentCancelCommonFn(paymentMethod?.id,userToken);
                            let errorData = flightBooking?.data?.data?.errors || flightBooking?.data?.message;
                            setCheckboxAndWalletError(getBookingErrorMessage(errorData, 'Something went wrong!'));
                            setPayNowBtnLoader(false);
                            setOnLoadLoader(false);
                        }
                    } else {
                        // await paymentCancelCommonFn(paymentMethod?.id,userToken);
                        let errorData = flightBooking?.data?.data?.errors || flightBooking?.data?.message;
                        setCheckboxAndWalletError(getBookingErrorMessage(errorData, 'Something went wrong!'));
                        setPayNowBtnLoader(false);
                        setOnLoadLoader(false);
                    }
                }
         
        }
        setPayNowBtnLoader(false);
        setOnLoadLoader(false);
    }

    // While /flights/flight-review or /flights/flight-booking-details loads, show the hero + a skeleton of the
    // booking layout instead of the full-page spinner (`loader`).
    if (onLoadLoader && !payNowBtnLoader) {
        return (
            <>
                <div className="hw-stay--div" />
                <div className={`hw-flight--flightDetails hw-passenger--pageList${(currentTab?.['3']?.active || queryParams?.bookingId) ? " hw-passenger--pageListEnd" : ""}`}>
                    <div className="hw-flight--stepsWrapper">
                        <ReviewBookingBanner currentTab={currentTab} tab2SubStep={tab2SubStep} timeRemaining={timeRemaining} headerBackButtonFn={headerBackButtonFn} />
                        <BookingConfirmationBanner
                            currentTab={currentTab}
                            queryParams={queryParams}
                            bookingStatus={bookingStatus}
                            bookingOtherData={bookingOtherData}
                        />
                    </div>
                    <div className="hw-page--width">
                        <div className="hw-passenger--wrapper fbd-overlap-wrap">
                            <FlightBookingSkeleton />
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            {/* Full-screen overlay while the booking/payment is being processed —
                same component the hotel & excursion checkouts use. */}
            {payNowBtnLoader ? <BookingProcessingOverlay flight={true} /> : null}
            {/* Destination grid */}

            {/* End Destination grid */}

            {/* Flight Filter */}
            <div className="hw-stay--div" />
            <div className={`hw-flight--flightDetails hw-passenger--pageList${currentTab?.['3']?.active ? " hw-passenger--pageListEnd" : ""}`}>
                <div className="hw-flight--stepsWrapper">
                    <ReviewBookingBanner currentTab={currentTab} tab2SubStep={tab2SubStep} timeRemaining={timeRemaining} headerBackButtonFn={headerBackButtonFn} />
                    <BookingConfirmationBanner
                        currentTab={currentTab}
                        queryParams={queryParams}
                        bookingStatus={bookingStatus}
                        bookingOtherData={bookingOtherData}
                    />
                </div>

                <div className="hw-page--width">
                    <div className={`hw-passenger--wrapper ${(currentTab?.['1']?.active || currentTab?.['2']?.active || currentTab?.['3']?.active) ? "fbd-overlap-wrap" : ""}`}>
                    <div className={`hw-passenger--list ${currentTab?.['3']?.active ? "hw-3rd-active-booking-details" : ""} ${(currentTab?.['2']?.active && tab2SubStep === 'payment') ? "fbd-payment-left" : ""}`}>
                        {(currentTab?.['2']?.active && tab2SubStep === 'payment') && (
                            <BookingDetailsSideBarComponent
                                renderMode="paymentOnly"
                                setTab2SubStep={setTab2SubStep}
                                resetSubmissionState={resetSubmissionState}
                                currentTab={currentTab}
                                flightDataPriceObj={flightDataPriceObj}
                                agentActiveCurrency={agentActiveCurrency}
                                setShowTaxAndFees={setShowTaxAndFees}
                                showTaxAndFees={showTaxAndFees}
                                activeCouponCodeData={activeCouponCodeData}
                                showDiscounts={showDiscounts}
                                extraChargePrice={extraChargePrice}
                                setExtraChargePrice={setExtraChargePrice}
                                finalAmount={finalAmount}
                                couponCodeError={couponCodeError}
                                couponCodeInput={couponCodeInput}
                                setCouponCodeInput={setCouponCodeInput}
                                setCouponCodeError={setCouponCodeError}
                                holdTicketConfirmFn={holdTicketConfirmFn}
                                couponCodeApplyBtnFn={couponCodeApplyBtnFn}
                                couponCodeLoader={couponCodeLoader}
                                unHoldTicketFn={unHoldTicketFn}
                                payNowBtnLoader={payNowBtnLoader}
                                checkboxAndWalletError={checkboxAndWalletError}
                                unHoldButtonLoader={unHoldButtonLoader}
                                removeCoupnCodeFn={removeCoupnCodeFn}
                                setSelectPaymentMethod={setSelectPaymentMethod}
                                selectPaymentMethod={selectPaymentMethod}
                                setCheckboxAndWalletError={setCheckboxAndWalletError}
                                setIAcceptCheckBox={setIAcceptCheckBox}
                                iAcceptCheckBox={iAcceptCheckBox}
                                termsError={termsError}
                                setTermsError={setTermsError}
                                step2PayNowBtnFn={step2PayNowBtnFn}
                                holdButtonLoader={holdButtonLoader}
                                queryParams={queryParams}
                                downLoadTicketFn={downLoadTicketFn}
                                bookingOtherData={bookingOtherData}
                                formik={formik}
                                downloadTicketWithFareLoader={downloadTicketWithFareLoader}
                                downloadTicketWithOutFareLoader={downloadTicketWithOutFareLoader}
                                downloadTicketWithMarkupLoader={downloadTicketWithMarkupLoader}
                                flightOnHoldCondition={flightOnHoldCondition}
                                setHasSubmitted={setHasSubmitted}
                                onlinePaymentEnable={onlinePaymentEnable}
                                bookingStatus={bookingStatus}
                                displayPrice={displayPrice}
                            />
                        )}
                        {!(currentTab?.['2']?.active && tab2SubStep === 'payment') && (
                            <>
                        <FlightBookingDetailsComponent
                            flightDetails={flightDetails}
                            currentTab={currentTab}
                            queryParams={queryParams}
                            vendorNotice={
                                <VendorInfoBanners
                                    queryParams={queryParams}
                                    airArabiaBundleMessage={airArabiaBundleMessage}
                                    currentTab={currentTab}
                                />
                            }
                            viewBaggageDetailsFn={viewBaggageDetailsFn}
                            setShowAllFlightDetails={setShowAllFlightDetails}
                            showAllFlightDetails={showAllFlightDetails}
                            setFareRulesOpen={setFareRulesOpen}
                            fareRulesOpen={fareRulesOpen}
                            setFareRulesActiveTab={setFareRulesActiveTab}
                            formik={formik}
                            setPassangerExtraServiceFn={setPassangerExtraServiceFn}
                            countryDialCodeData={countryDialCodeData}
                            bookingOtherData={bookingOtherData}
                            fareRuleDataBookingPage={fareRuleDataBookingPage}
                            fareRulesActiveTab={fareRulesActiveTab}
                            countryData={countryData}
                            agentActiveCurrency={agentActiveCurrency}
                            searchQueryObj={searchQueryObj}
                            setFareRuleActiveIndex={setFareRuleActiveIndex}
                            fareRuleActiveIndex={fareRuleActiveIndex}
                            fareRuleData={fareRuleData}
                            resetSubmissionState={resetSubmissionState}
                            hasSubmitted={hasSubmitted}
                            setHasSubmitted={setHasSubmitted}
                            flightDataPriceObj={flightDataPriceObj}
                            extraData={{ echoToken, transactionId, rphCode }}
                            sectionError={sectionError}
                            seatmapdata={seatMapCache}
                            seatRequired={seatRequired}
                            displayPrice={displayPrice}
                        />
                            </>
                        )}
                    </div>
                    <BookingDetailsSideBarComponent
                        renderMode={(currentTab?.['2']?.active && tab2SubStep === 'payment') ? "summaryOnly" : "full"}
                        setTab2SubStep={setTab2SubStep}
                        currentTab={currentTab}
                        flightDataPriceObj={flightDataPriceObj}
                        agentActiveCurrency={agentActiveCurrency}
                        setShowTaxAndFees={setShowTaxAndFees}
                        showTaxAndFees={showTaxAndFees}
                        activeCouponCodeData={activeCouponCodeData}
                        showDiscounts={showDiscounts}
                        extraChargePrice={extraChargePrice}
                        setExtraChargePrice={setExtraChargePrice}
                        finalAmount={finalAmount}
                        couponCodeError={couponCodeError}
                        couponCodeInput={couponCodeInput}
                        setCouponCodeInput={setCouponCodeInput}
                        setCouponCodeError={setCouponCodeError}
                        holdTicketConfirmFn={holdTicketConfirmFn}
                        couponCodeApplyBtnFn={couponCodeApplyBtnFn}
                        couponCodeLoader={couponCodeLoader}
                        unHoldTicketFn={unHoldTicketFn}
                        payNowBtnLoader={payNowBtnLoader}
                        checkboxAndWalletError={checkboxAndWalletError}
                        unHoldButtonLoader={unHoldButtonLoader}
                        removeCoupnCodeFn={removeCoupnCodeFn}
                        setSelectPaymentMethod={setSelectPaymentMethod}
                        selectPaymentMethod={selectPaymentMethod}
                        setCheckboxAndWalletError={setCheckboxAndWalletError}
                        setIAcceptCheckBox={setIAcceptCheckBox}
                        iAcceptCheckBox={iAcceptCheckBox}
                        termsError={termsError}
                        setTermsError={setTermsError}
                        step2PayNowBtnFn={step2PayNowBtnFn}
                        holdButtonLoader={holdButtonLoader}
                        queryParams={queryParams}
                        downLoadTicketFn={downLoadTicketFn}
                        bookingOtherData={bookingOtherData}
                        formik={formik}
                        downloadTicketWithFareLoader={downloadTicketWithFareLoader}
                        downloadTicketWithOutFareLoader={downloadTicketWithOutFareLoader}
                        downloadTicketWithMarkupLoader={downloadTicketWithMarkupLoader}
                        flightOnHoldCondition={flightOnHoldCondition}
                        setHasSubmitted={setHasSubmitted}
                        onlinePaymentEnable={onlinePaymentEnable}
                        bookingStatus={bookingStatus}
                        displayPrice={displayPrice}
                    />
                    </div>
                </div>

            </div>
            {/* End flight filter */}

            <FlightPriceChangePopup
                flightPriceChangeInfo={flightPriceChangeInfo}
                agentActiveCurrency={agentActiveCurrency}
                displayPrice={displayPrice}
                dismissFlightPriceChangePopupFn={dismissFlightPriceChangePopupFn}
                backtoSearchButtonFn={backtoSearchButtonFn}
            />

            <PreBookingPriceRevisionPopup
                checkPriceBeforeBooking={checkPriceBeforeBooking}
                payNowBtnLoader={payNowBtnLoader}
                step2PayNowBtnFn={step2PayNowBtnFn}
                setCheckPriceBeforeBooking={setCheckPriceBeforeBooking}
                amadeusReconfirmRef={amadeusReconfirmRef}
            />

            <BaggageDetailsPopup
                showBaggageDetailsModal={showBaggageDetailsModal}
                setShowBaggageDetailsModal={setShowBaggageDetailsModal}
                baggageDetailsPassengerData={baggageDetailsPassengerData}
                bagggageDetailsFlightDetails={bagggageDetailsFlightDetails}
                baggageDetailsFlightDetailsIndex={baggageDetailsFlightDetailsIndex}
                source={queryParams?.source}
                bookingId={queryParams?.bookingId}
                flightShowErrorMessage={flightShowErrorMessage}
                backtoSearchButtonFn={backtoSearchButtonFn}
                searchQuery={searchQueryObj}
                showBundleinclusion={flightShowBundleInclusionMessage}
                setbundleInclusion={setflightShowBundleInclusionMessage}
            />

            <StripeWrapper
                show={stripeModalShow}
                setShow={setStripeModalShow}
                totalPrice={finalAmount}
                showDiscounts={showDiscounts}
                extraChargePrice={extraChargePrice}
                queryParams={queryParams}
                bookingOtherData={bookingOtherData}
                selectPaymentMethod={selectPaymentMethod}
                onineServicesFees={onineServicesFees}
                agentActiveCurrency={agentActiveCurrency}
                onPaymentSuccess={handleStripePaymentSuccess}
                onClose={() => {
                    setStripeModalShow(false);
                    setPayNowBtnLoader(false);
                    setOnLoadLoader(false);
                }}
                ndcPriceAfterHold={ndcPriceAfterHold}
                checkPriceBeforeBooking={checkPriceBeforeBooking}
                displayPrice={displayPrice}
            />

            <CommonPopup
                show={showSessionExpired}
                title={"Notification"}
                setShow={() => {
                    setShowSessionExpired(false);
                    const getlastQueryParamsFlightData = getCookie('lastQueryParamsFlight');
                    navigate(`/flight/list${getlastQueryParamsFlightData}`, { state: new Date().getTime() });
                }}
            >
                <p>Your booking session time has ended to ensure availability and accurate pricing. <br /> Please start a new search to proceed.</p>
            </CommonPopup>

        </>


    );
};


export default PassengerListPage;
